/* eslint-disable max-lines */
import hints from './hints';

export default {
  ...hints,
  'HTML_DIR': ['ltr', 'rtl', 'ltr'],
  'EN': ['English', 'English', 'English'],
  'FA': ['Farsi', 'Farsi', 'Farsi'],
  'CH': ['Chinese', 'Chinese', 'Chinese'],
  'BAZAAR': ['Bazaar', 'بازار', 'Bazaar'],
  'BAZAARGAH_TOUCHPOINT.DESCRIPTION': [
    'Exclusive products and services for developers',
    'محصولات و خدمات ویژه توسعه‌دهندگان',
    '面向开发者的专属产品和服务',
  ],
  'BAZAARGAH_TOUCHPOINT.CTA': [
    'Go to Bazaargah',
    'رفتن به بازارگاه',
    '前往 Bazaargah',
  ],
  'LOGIN': ['Login', 'ورود', '登录'],
  'LOGIN_TO_PISHKHAN': [
    'Login to Pishkhan',
    'ورود به پیشخان',
    'Login to Pishkhan',
  ],
  'NEW': ['New', 'جدید', '新'],
  'ADD': ['Add', 'افزودن', '添加'],
  'OPTIONAL': ['Optional', 'اختیاری', 'Optional'],
  'OR': ['Or', 'یا', 'Or'],
  'AND': ['And', 'و', 'And'],
  'BANNER.SLIDER.PREV': ['Previous banner', 'بنر قبلی', 'Previous banner'],
  'BANNER.SLIDER.NEXT': ['Next banner', 'بنر بعدی', 'Next banner'],
  'INFO': ['Info', 'توجه', 'Info'],
  'ATTENTION': ['Attention!', 'توجه!', 'Attention!'],
  'EDITED': ['Edited', 'ویرایش‌شده', 'Edited'],
  'INSTALL': ['Install', 'نصب', 'Install'],
  'MORE_OPTIONS': ['More Options', 'گزینه‌های بیشتر', 'More Options'],
  'JALALI_CALENDAR': ['Jalali Calendar', 'تقویم شمسی', 'Jalali Calendar'],
  'GREGORIAN_CALENDAR': [
    'Gregorian Calendar',
    'تقویم میلادی',
    'Gregorian Calendar',
  ],
  'MORE_INFO': ['More Info', 'اطلاعات بیشتر', 'More Info'],
  'LOADING_DATA': [
    'Loading data...',
    'درحال دریافت اطلاعات...',
    'Loading data...',
  ],
  'LEARN_MORE': ['Learn more...', 'بیشتر بدانید...', '更多了解...'],
  'LOGIN_TO_PANEL': ['Login to Panel', 'ورود به پیشخان', '登录到面板'],
  'DRAG_AND_DROP_FILE_INPUT': [
    'Click to select the file or drag and drop the file here',
    'برای انتخاب فایل برنامه کلیک کنید و یا فایل برنامه را کشیده و اینجا رها کنید',
    'Click to select the file or drag and drop the file here',
  ],
  'RANGE': ['Range', 'بازه', '范围'],
  'EXPORT_CSV': ['Download CSV', 'دریافت CSV', '下载CSV'],
  'NOT_SPECIFIED': ['Not Specified', 'تعیین نشده', 'Not Specified'],
  'ACTION': ['Action', 'عملیات', 'Action'],
  'PRICE_VALIDATION_ERROR': [
    'Price should be greater than 0.',
    'قیمت باید بیشتر از ۰ باشد.',
    'Price should be greater than 0.',
  ],
  'RANGEFITLER.CHANGE_RANGE': ['Change Range', 'تغییر بازه', '改变范围'],
  'RANGEFILTER.CUSTOM_RANGE': ['Custom Range', 'بازه‌ی دلخواه', '自定义范围'],
  'RANGE.YESTERDAY': ['Yesterday', 'دیروز', 'Yesterday'],
  'RANGE.TODAY': ['Today', 'امروز', 'Today'],
  'VERIFY_EXTEND_MEMBERSHIP.TITLE': [
    'Extend Subscription',
    'تمدید اشتراک',
    'Extend Subscription',
  ],
  'VERIFY_EXTEND_MEMBERSHIP.CHECKING': [
    'Verifying your information...',
    'در حال بررسی اطلاعات...',
    '验证您的信息...',
  ],
  'VERIFY_EXTEND_MEMBERSHIP.ERROR': [
    'Subscription renewal failed',
    'تمدید اشتراک ناموفق بود',
    'Subscription renewal failed',
  ],
  'VERIFY_EXTEND_MEMBERSHIP.SUCCESS': [
    'Subscription renewal done',
    'تمدید اشتراک انجام شد',
    'Subscription renewal done',
  ],
  'VERIFY_EXTEND_MEMBERSHIP.EXPIRE_DATE': [
    'Expiration Date',
    'اتمام اشتراک',
    'Expiration Date',
  ],
  'VERIFY_EXTEND_MEMBERSHIP.BACK_LINK': [
    'Back to panel',
    'برگشت به پنل',
    'Back to panel',
  ],
  'FILE_UPLOAD.FAILED': [
    'Sorry, uploading failed',
    'متاسفانه آپلود ناموفق بود',
    'Sorry, uploading failed',
  ],
  'REGISTER': ['Register', 'ثبت‌نام', '注册'],
  'REGISTER_AGENT': ['Register Agent', 'ثبت‌نام کارپرداز', '代理注册'],
  'REGISTER_AGENT.HAS_PASSWORD': [
    'You have already registered and set a password with this email address on this panel. By clicking the button below, you, {user_email}, will be registered as an agent for a developer with the email address of {publisher_email}.',
    'شما قبلا با این آدرس ایمیل در «پیشخان توسعه‌دهندگان بازار»، ثبت‌نام و تعیین رمز کرده‌اید. <br> با فشردن دکمه‌ی زیر، شما با ایمیل {user_email}، کارپرداز توسعه‌دهنده‌ای با ایمیل {publisher_email} می‌شوید.',
    'You have already registered and set a password with this email address on this panel. By clicking the button below, you, {user_email}, will be registered as an agent for a developer with the email address of {publisher_email}.',
  ],
  'REGISTER_AGENT.MESSAGE': [
    'By completing this form, you, {user_email}, will be registered as an agent for a developer with the email address of {publisher_email}',
    'با تکمیل این فرم، شما با ایمیل ادرس {user_email}، کارپرداز توسعه‌دهنده‌ای با ایمیل ادرس {publisher_email} می‌شوید.',
    '完成此表单后, 您, {user_email}, 将注册为电子邮件地址为{publisher_email}的开发人员的代理.',
  ],
  'PASSWORD_RESET': ['Password Reset', 'بازنشانی رمزعبور', 'Password Reset'],
  'FORGET_PASSWORD': [
    'I forgot my password',
    'رمزعبورم را فراموش کرده‌ام',
    'I forgot my password',
  ],
  'FORGET_PASSWORD.MESSAGE': [
    'Forgot your password? Enter your email address below and we will send you the new password setting method.',
    'رمز عبور خود را فراموش کرده‌اید؟ آدرس ایمیل خود را در زیر وارد کنید و ما روش تنظیم رمز جدید را برایتان ارسال می‌کنیم.',
    '忘记密码？在下面输入您的电子邮件地址,我们将向您发送新的密码设置方法。',
  ],
  'FORGET_PASSWORD.BUTTON_TEXT': ['Send', 'ارسال', '发送'],
  'FORGET_PASSWORD.EMAIL_SENT': [
    'The email has been sent',
    'ایمیل تغییر رمز ارسال شد',
    'The email has been sent',
  ],
  'FORGET_PASSWORD.INFO.SUPPORT': [
    '',
    'اگر در تغییر رمز عبور مشکلی داشتید، با پشتیبانی بازار به شماره  ۹۱۰۰۹۷۹۸-۰۲۱ تماس بگیرید.',
    '',
  ],
  'FORGET_PASSWORD.SENT_TEXT': [
    'We have sent a password change instruction for you. If you have an account with the email you entered, you will receive this email soon. <br> If you do not receive an email, check your spam folder. Also, please check that the address you entered is the one you registered with.',
    'دستورالعمل تغییر رمز عبور را برایتان ایمیل کردیم. اگر با ایمیلی که وارد کرده‌اید، اکانتی در پیشخان ثبت‌ شده‌باشد، به زودی این ایمیل را دریافت می‌کنید.<br> اگر ایمیلی دریافت نمی‌کنید، پوشه‌ی اسپم خود را چک کنید. در ضمن لطفاً بررسی کنید که آدرسی که وارد کرده‌اید همان است که با آن ثبت نام کرده‌اید.',
    '我们已经为您发送了密码更改指令。如果您有一个帐户与您输入的电子邮件,您将很快收到这封电子邮件。<br>如果您没有收到电子邮件,请检查您的垃圾邮件文件夹。另外,请检查您输入的地址是否是您注册的地址。',
  ],
  'FORGET_PASSWORD.LOGIN': ['{login}', '{login}', '{login}'],
  'FORGET_PASSWORD.RESET_PASSWORD.TITLE': [
    'Set the new password for Pishkhan account',
    'تنظیم رمز جدید برای حساب پیشخان',
    'Set the new password for Pishkhan account',
  ],
  'FORGET_PASSWORD.RESET_PASSWORD.MESSAGE': [
    'Enter the new password twice in the section below and then click the Change Password button.',
    'رمز جدید را در بخش زیر دو بار وارد کنید و سپس دکمه‌ی تعویض رمز را بزنید.',
    'Enter the new password twice in the section below and then click the Change Password button.',
  ],
  'FORGET_PASSWORD.RESET_PASSWORD.BUTTON_TEXT': [
    'Reset Password',
    'تعویض رمز',
    '重置密码',
  ],
  'FORGET_PASSWORD.RESET_PASSWORD.INVALID_TOKEN': [
    'Your password reset link has expired',
    'لینک بازیابی رمز عبور شما منقضی شده است',
    'Your password reset link has expired',
  ],
  'FORGET_PASSWORD.RESET_PASSWORD.SUCCESSFUL': [
    'You have successfully changed your password.',
    'شما با موفقیت رمز عبور خود را تغییر دادید.',
    '您已成功更改密码',
  ],
  'LOGIN_WITH_GOOGLE': ['Login with Google', 'ورود با گوگل', '用谷歌登录'],
  'RETURN_TO_LOGIN': [
    'Return to login page',
    'بازگشت به صفحه‌ی ورود',
    'Return to login page',
  ],
  'LOGOUT': ['Logout', 'خروج', '退出'],
  'USERNAME': ['Username', 'نام کاربری', '用户名'],
  'PASSWORD': ['Password', 'رمز عبور', '密码'],
  'PASSWORD_CONFIRM': ['Password confirm', 'تکرار رمز عبور', '密码确认'],
  'SIGN_UP_NOW': ['Sign up now', 'ثبت‌نام کنید', 'Sign up now'],
  'DONT_HAVE_ACCOUNT': [
    "Don't have a developer account? {signup}",
    'حساب توسعه دهنده ندارید؟ {signup}',
    "Don't have a developer account? {signup}",
  ],
  'SIGN_UP_DECS': ['Become a Developer', 'توسعه‌دهنده‌ شوید', '成为开发商'],
  'AUTH.VERIFY_EMAIL.VERIFYING_MESSAGE': [
    'Verifying email address',
    'در حال بررسی ایمیل تأیید',
    '验证电子邮件地址',
  ],
  'AUTH.REGISTER.EMAIL_NATURAL_WARNING': [
    'This email address will be irreversible.',
    'این ایمیل غیرقابل‌تغییر خواهد بود.',
    '此电子邮件地址将不可逆。',
  ],
  'AUTH.REGISTER.EMAIL_LEGAL_WARNING': [
    'For corporate accounts, please enter an email address with your company domain. You can NOT change this email address in the future.',
    'برای ثبت اکانت شرکتی، لطفاً از ایمیلی با دامنه‌ی شرکت خود استفاده کنید. این ایمیل بعدأ قابل تغییر نیست.',
    '对于公司帐户,请输入公司网站域的电子邮件地址。您以后不能更改此电子邮件地址。',
  ],
  'AUTH.REGISTER.FOOTER_LOGIN_GUIDE': [
    'Already registered? {login}',
    'قبلاً ثبت‌نام کرده‌اید؟ {login}',
    '已经注册了？{login}',
  ],
  'AUTH.SMS_VERIFICATION_DESCRIPTION': [
    'To ensure security and prevent unauthorized access to the Pishkhan panel, it is necessary to\
    When you haven\'t changed your password, to log in with a one-time password\
    SMS, confirm your ownership, so that no one but you can access it.\
    Not to your user account. After changing the password or activating the feature\
    <a href="https://developers.cafebazaar.ir/fa/guidelines/developers-panel/two-step-verification" target="_blank" class="link">two-step verification</a>\
    , which has just been added to Pishkhan, SMS verification will be disabled.',
    'برای تضمین امنیت و جلوگیری از دسترسی غیرمجاز به پنل پیشخان، ضروری است تا\
    زمانی که رمزعبور خود را تغییر نداده‌اید، برای ورود از طریق رمز یکبار مصرف\
    پیامکی، مالکیت خود را تایید نمایید، تا هیچ فردی غیر از شما قادر به دسترسی\
    به حساب کاربری‌تان نباشد. پس از تغییر رمز و یا فعال‌سازی قابلیت\
    <a href="https://developers.cafebazaar.ir/fa/guidelines/developers-panel/two-step-verification" target="_blank" class="link">تایید دومرحله‌ای</a>\
    ، که به تازگی به پیشخان اضافه شده است، تایید پیامکی غیرفعال خواهد شد.',
    'To ensure security and prevent unauthorized access to the Pishkhan panel, it is necessary to\
    When you haven\'t changed your password, to log in with a one-time password\
    SMS, confirm your ownership, so that no one but you can access it.\
    Not to your user account. After changing the password or activating the feature\
    <a href="https://developers.cafebazaar.ir/fa/guidelines/developers-panel/two-step-verification" target="_blank" class="link">two-step verification</a>\
    , which has just been added to Pishkhan, SMS verification will be disabled.',
  ],
  'AUTH.STEPS.TITLE': [
    'Become a developer in "Bazaar"',
    'توسعه‌دهنده‌ی «بازار» شوید',
    '成为巴扎商店开发者',
  ],
  'AUTH.STEPS.LOGOUT': ['Cancel SignUp', 'خروج از ثبت‌نام', '取消注册'],
  'AUTH.STEPS.NEXT_LEVEL_BTN': ['Next level', 'مرحله‌ی بعد', '下一步'],
  'AUTH.STEPS.PREV_LEVEL_BTN': ['Prev level', 'مرحله‌ی قبل', '上一步'],
  'AUTH.STEPS.ACCOUNT_TYPE': ['Account type', 'نوع حساب', '账号类型'],
  'AUTH.STEPS.ACCOUNT_INFORMATION': [
    'Account Information',
    'اطلاعات حساب',
    '账户信息',
  ],
  'AUTH.STEPS.PUBLIC_PROFILE': [
    'Public Profile',
    'پروفایل عمومی',
    '公开的出版商名称',
  ],
  'AUTH.STEPS.PUBLIC_PROFILE.DEVELOPER_TITLE_GUIDANCE': [
    'More info',
    'اطلاعات بیشتر',
    '更多信息',
  ],
  'AUTH.STEPS.PUBLIC_PROFILE.DEVELOPER_TITLE_MODAL': [
    'Developer title guidance',
    'راهنمای انتخاب عنوان توسعه‌دهنده',
    '开发者名称指导',
  ],
  'AUTH.STEPS.PUBLIC_PROFILE.DEVELOPER_TITLE_MODAL_DESC': [
    'A unique title that will be displayed under the name of your apps. This title should not be used by other developers and should be less than 32 characters, consisting only of Persian and English letters, numbers, spaces and half-spaces.',
    'عنوانی یکتا که زیر نام تمام برنامه‌های شما نمایش داده خواهد شد. این عنوان نباید توسط توسعه‌دهندگان دیگر استفاده شده‌ باشد. طول آن حداکثر ۳۲ کاراکتر است که می‌تواند شامل حروف و اعداد فارسی و انگلیسی، فاصله و نیم‌فاصله باشد.',
    '将在应用程序名称下显示的唯一名称。此标题不应被其他开发商使用,且应少于32个字符,仅由波斯语和英语字母、数字和空格组成。',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION': [
    'Identity Verification',
    'تأیید هویت',
    '身份验证',
  ],
  'AUTH.STEPS.DONE': ['Done', 'پایان', '完成'],
  'AUTH.STEPS.ACCOUNT_TYPE.COUNTRY': [
    'Country of residence',
    'کشور محل اقامت',
    'Country of residence',
  ],
  'AUTH.STEPS.ACCOUNT_TYPE.LEGAL': ['Company', 'شرکت', '法人'],
  'AUTH.STEPS.ACCOUNT_TYPE.NATURAL': ['Personal', 'شخص', '自然人'],
  'AUTH.STEPS.IDENTITY_VERIFICATION.CELLPHONE_VERIFICATION': [
    'Verify your mobile number',
    'تأیید شماره تلفن همراه',
    '验证您的手机号码',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.RESEND_BTN': [
    'Resend verification code',
    'ارسال مجدد کد',
    '重新发送验证码',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.EDIT_PHONE_BTN': [
    'Edit cellphone number',
    'ویرایش شماره تلفن',
    '编辑手机号',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.CANCEL_EDIT_PHONE_BTN': [
    'Cancel',
    'لغو عملیات',
    '取消',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.EDIT_PHONE_MODAL_TITLE': [
    'Edit cellphone number',
    'ویرایش شماره تلفن',
    '编辑手机号',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.SEND_CODE': [
    'Send Verification Code',
    'ارسال کد تایید',
    'Send Verification Code',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.MESSAGE_DESC': [
    'A four-digit code has been sent to {phone}. Please enter it.',
    'یک کد چهار رقمی به شماره‌ی <span dir="ltr">{phone}</span> ارسال شده است. لطفاً آن را وارد کنید.',
    '四位数的代码已发送到{phone}。请输入',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.MESSAGE_SENDING_DESC': [
    'A four-digit code will be sent to {phone}.',
    'یک کد چهار رقمی به شماره‌ی <span dir="ltr">{phone}</span> ارسال خواهد شد.',
    '一个四位数的代码将被发送到{phone}。',
  ],
  'AUTH.STEPS.IDENTITY_VERIFICATION.MESSAGE_PHONE_CONFIRM_DESC': [
    'Is the number "{phone}" correct to receive the verification code? If approved, a message containing the verification code will be sent to you.',
    'آیا شماره‌ی «{phone}» برای دریافت کد تأیید صحیح است؟ در صورت تأیید پیامی حاوی کد ورود برای شما ارسال خواهد شد.',
    'Is the number "{phone}" correct to receive the verification code? If approved, a message containing the verification code will be sent to you.',
  ],
  'AUTH.STEPS.DONE.HEADER': ['Done', 'پایان', '完成'],
  'AUTH.STEPS.DONE.MESSAGE': [
    'Your registration has successfully finished.',
    'ثبت‌نام شما با موفقیت به پایان رسید.',
    '您的注册已成功完成。',
  ],
  'AUTH.STEPS.DONE.GO_HOME': ["Let's Begin", 'انتقال به پیشخان', '开始'],
  'AUTH.STEPS.NAME_WARNING': [
    'This name should be identical to the name of the owner of the back account for future payments.',
    'این نام برای پرداخت‌های آتی لازم است با نام صاحب حساب بانکی یکی باشد.',
    '此名称应与将来付款的后台帐户所有者的名称相同',
  ],
  'AUTH.STEPS.LEGAL_EMAIL_WARNING': [
    'This should be a corporate email address.',
    'برای ثبت اکانت شرکتی، ایمیل باید دامنه‌ی شرکتی داشته باشد.',
    '这应该是一个公司网站域电子邮件地址。',
  ],
  'AUTH.STEPS.CERTIFICATION_IMAGE_WARNING': [
    'Images of companies latest changes in a JPEG file',
    'تصویر اسکن‌شده‌ی آگهی آخرین تغییرات شرکت در قالب یک فایل تصویر JPG',
    '公司最新更改的文件（图像JPEG）',
  ],
  'AUTH.STEPS.CEO_IMAGE_WARNING': [
    "CEO's National Card images in a JPEG file, the image must be scanned and colored.",
    'تصویر رنگی و اسکن‌شده‌ی کارت ملی مدیرعامل در قالب یک فایل تصویر JPG',
    'CEO的国民身份证图片在JPEG文件中,图片必须扫描并着色',
  ],
  'AUTH.STEPS.VAT_IMAGE_WARNING': [
    'The image of VAT registration certificate as a JPEG file, the image must be scanned.',
    'تصویر اسکن‌شده‌ی گواهی ثبت‌نام مالیات بر ارزش افزوده در قالب یک فایل تصویر JPG',
    '增值税注册证书的图像（JPEG文件）,必须扫描该图像。',
  ],
  'AUTH.STEPS.CELLPHONE_WARNING': [
    'This number will be used for our communications with you.',
    'این شماره راه ارتباطی «بازار» با شما خواهد بود.',
    '这个号码将用于我们与您的通信。',
  ],
  'HERE': ['here', 'این‌جا', '这里'],
  'THIS_POST': ['this post', 'این پست', '这个帖子'],
  'THIS_LINK': ['این آدرس', 'این آدرس', '这个链接'],
  'RETRY': ['Retry', 'تلاش دوباره', '重新'],
  'ACCOUNT_SETTINGS': [
    'account settings section',
    'تنظیمات حساب کاربری',
    '账户设置部分',
  ],
  'LOGIN_TROUBLE': [
    'Having trouble logging in?',
    'نمی‌توانید وارد شوید؟',
    '登录时遇到问题？',
  ],
  'LOGIN_GAPI_ERROR': [
    'Error communicating with Google service',
    'بروز خطا در برقراری ارتباط با سرویس گوگل',
    '与谷歌通信时出错',
  ],
  'LOGIN_GAPI_RETRYING': ['retrying...', 'در حال تلاش دوباره ...', '重试中'],
  'NO_PASSWORD_DESC': [
    "In order to use Pishkhan Developers' Panel you have to set a password for your Bazaar account. You can do so in the {account-setting} of Bazaar's website or mobile app.",
    'برای دسترسی به پیشخان توسعه‌دهندگان نیاز است که برای حساب کاربری خود در بازار رمز عبور تنظیم کنید. این کار از طریق  {account-setting} در وب‌سایت یا برنامه‌ی بازار قابل انجام است',
    '要使用Pishkhan开发者面板,您必须为巴扎帐户设置密码。您可以在巴扎商店网站或移动应用程序的{account setting}中执行此操作。',
  ],
  'FORGET_PASSWORD_TITLE': [
    'Forgot your password?',
    'رمز عبور را فراموش کرده‌اید؟',
    '忘记密码？',
  ],
  'FORGET_PASSWORD_DESC': [
    'You can recover your password {forget-password}.',
    'می‌توانید از {forget-password} رمز عبور خود را تغییر دهید.',
    '你可以恢复你的密码 {forget-password} ',
  ],
  'ANOTHER_TROUBLE_TITLE': [
    'Have another problem?',
    'مشکل دیگری دارید؟',
    '有其他问题？',
  ],
  'ANOTHER_TROUBLE_DESC': [
    'You can contact {developers-support}.',
    'می‌توانید با {developers-support} مطرح کنید.',
    '您可以与{developers-support}联系。',
  ],
  'APPLICATIONS': ['Applications', 'برنامه‌ها', '应用程序'],
  'MANAGEMENT': ['Management', 'مدیریت', '管理'],
  'SUPPORT': ['Support', 'پشتیبانی', '支持'],
  'SUPPORT_AND_EDUCATION': [
    'Support & Education',
    'پشتیبانی و آموزش',
    '支持与教育',
  ],
  'SUPPORT.SUPPORT_TICKETS': [
    'Support Tickets',
    'تیکت‌های پشتیبانی',
    'Support Tickets',
  ],
  'SUPPORT.FAQ': [
    'Support FAQ',
    'سوالات متدوال',
    'Support FAQ',
  ],
  'SUPPORT.CONTACT_US': ['Contact us', 'تماس با ما', 'Contact us'],
  'DEV_SUPPORT': ['Developers support', 'پشتیبانی توسعه‌دهندگان', '开发商支持'],
  'FAQ': ['FAQ', 'سؤالات پرتکرار', '常温问题'],
  'TICKET': ['Ticket', 'ارسال تیکت', '支持票'],
  'DOCUMENTATION': ['Documentation', 'مستندات', '文档'],
  'BLOG': ['Blog', 'بلاگ', '博客'],
  'PUBLISH_RULES': ['Publish Rules', 'قوانین انتشار', 'Publish Rules'],
  'EMAIL': ['Email', 'ایمیل', '电子邮件'],
  'RIALS': ['Rials', 'ریال', '里亚尔'],
  'FREE': ['Free', 'رایگان', '免费'],
  'COUNTRY': ['Country', 'کشور', '国家'],
  'APPLY': ['Apply', 'اعمال', '应用'],
  'ARROW': ['→', '←', '→'],
  'DAY': ['Day', 'روز', '日'],
  'MONTH': ['Month', 'ماه', '月'],
  'YEAR': ['Year', 'سال', '年'],
  'ACTIVE': ['Active', 'فعال', '活性'],
  'DISABLED': ['Disabled', 'غیرفعال', '禁用的'],
  'DEACTIVATE': ['Deactivate', 'غیرفعال کردن', 'Deactivate'],
  'ALL': ['All', 'همه', '全部'],
  'API_ERROR': [
    'Error fetching data',
    'خطا در دریافت اطلاعات',
    '获取数据时出错',
  ],
  'FAILED_TO_FETCH': [
    'The information in this section was not received correctly! Try again.',
    'اطلاعات این قسمت به درستی دریافت نشده‌اند! دوباره تلاش کنید.',
    'The information in this section was not received correctly! Try again.',
  ],
  'ERRORS_LIST_GUIDE': [
    'Fix the following items :',
    'موارد زیر را اصلاح کنید:',
    '修复以下项目',
  ],
  'TAX_INCLUSIVE': ['Tax Inclusive', 'شامل مالیات', '含税'],
  'ACCOUNT.DESC': ['', '', ''],
  'ACCOUNT.STATUS.TITLE': ['Subscription Status', 'وضعیت اشتراک', '订阅状态'],
  'ACCOUNT.STATUS.ACTIVE': [
    'Your account is active.',
    'حساب شما فعال است.',
    '您的帐户处于活动状态。',
  ],
  'ACCOUNT.STATUS.IS_EXPIRED': [
    'Your account is has been expired.',
    'حساب شما منقضی شده است.',
    '您的帐户已过期。',
  ],
  'ACCOUNT.STATUS.IS_EXPIRED_DESC': [
    'You must renew your account to publish or update your apps. The annual renewal fee is 400,000 Rials',
    'برای انتشار یا بروزرسانی برنامه، لازم است حساب خود را تمدید نمایید. هزینه‌ی تمدید حساب سالیانه ۴۰۰٬۰۰۰ ریال است.',
    '必须续订帐户才能发布或更新应用程序。年费是40万里亚尔。',
  ],
  'ACCOUNT.STATUS.SKIP_EXTENSION_PAY': [
    'If you do not wish to pay the annual subscription fee, please send your request to us via <a class="link" href="mailto:developers@cafebazaar.ir">developers@cafebazaar.ir</a>.',
    'اگر تمایلی به پرداخت حق اشتراک سالیانه ندارید، درخواست خود را از طریق ایمیل <a class="link" href="mailto:developers@cafebazaar.ir">developers@cafebazaar.ir</a> با ما درمیان بگذارید.',
    'If you do not wish to pay the annual subscription fee, please send your request to us via <a class="link" href="mailto:developers@cafebazaar.ir">developers@cafebazaar.ir</a>.',
  ],
  'ACCOUNT.STATUS.EXTENDABLE_DESC': [
    'The annual renewal fee is 400,000 Rials.',
    'هزینه‌ی تمدید حساب سالیانه ۴۰۰٬۰۰۰ ریال است.',
    '年费是40万里亚尔。',
  ],
  'ACCOUNT.STATUS.EXPIRE_DATE': ['Expire date', 'تاریخ انقضا', "'到期日期"],
  'ACCOUNT.STATUS.EXTEND_MEMBERSHIP': [
    'Extend membership',
    'تمدید حساب',
    '续订帐户',
  ],
  'ACCOUNT.STATUS.API_ERROR': [
    'Error fetching receipts list',
    'خطا در دریافت لیست رسیدهای تمدید حساب',
    '提取收据列表时出错',
  ],
  'ACCOUNT.STATUS.RECEIPTS': ['Receipts', 'رسیدهای تمدید حساب', '收据'],
  'ACCOUNT.STATUS.RECEIPT_AMOUNT': ['Amount', 'مبلغ', '数额'],
  'ACCOUNT.STATUS.RECEIPT_DATE': ['Date', 'تاریخ', '日期'],
  'ACCOUNT.STATUS.RECEIPT_TOKEN': ['Token', 'توکن', '代币'],
  'ACCOUNT.STATUS.NO_DATA': [
    'No receipt found.',
    'هیچ رسیدی پیدا نشد.',
    '未找到收据',
  ],
  'ACCOUNT.PUBLISHER_INFO_TITLE': [
    'Agent Info',
    'اطلاعات کارپردازی',
    '代理信息',
  ],
  'ACCOUNT.PUBLISHER_INFO_DESC': [
    'The info of the publisher that you are his/her agent is shown here. You can resign as his/her agent.',
    'اطلاعات ناشری که کارپرداز آن هستید در این قسمت نمایش داده شده است. شما می‌توانید از عنوانِ کارپرداز این ناشر کناره‌گیری کنید.',
    '这里显示了出版商的信息,即您是其代理人。你可以辞去他的经纪人职务。',
  ],
  'ACCOUNT.PUBLISHER_NAME': ['Publisher name', 'نام ناشر', '出版商名称'],
  'ACCOUNT.PUBLISHER_EMAIL': [
    'Publisher email',
    'ایمیل ناشر',
    '出版商电子邮件',
  ],
  'ACCOUNT.RESIGN': ['Resign as Agent', 'کناره‌گیری از کارپردازی', '辞去代理'],
  'ACCOUNT.RESIGN_AGENT_CONFIRM_BTN': [
    'Yes, resign',
    'بله، لغو کارپردازی',
    '是,辞职',
  ],
  'ACCOUNT.RESIGN_AGENT_CONFIRM_MSG': [
    'By resigning your account will be deleted and you will no longer have access to the dashboard. Are you sure?',
    'با لغو کارپردازی، حساب کاربری شما حذف شده و از سیستم خارج خواهید شد. آیا از این کار اطمینان دارید؟',
    '辞职后,您的帐户将被删除,您将不再有权访问仪表板。你确定吗？',
  ],
  'ACCOUNT.CHANGE_PASSWORD.TITLE': [
    'Change Password',
    'تغییر رمز عبور',
    '更改密码',
  ],
  'ACCOUNT.CHANGE_PASSWORD.DESCRIPTION': [
    'You can change your password through this section. If you have forgotten your password, go to login page.',
    'شما در این بخش می‌توانید رمز عبور خود را تغییر دهید. در صورت فراموشی رمز خود، به صفحه‌ی ورود مراجعه کنید.',
    '您可以通过此部分更改密码。如果您忘记了密码,请转到登录页。',
  ],
  'ACCOUNT.CHANGE_PASSWORD.CURRENT_PASSWORD': [
    'Current password',
    'رمز عبور فعلی',
    '当前密码',
  ],
  'PUBLISHER_ACCOUNT.TITLE': ['Publisher Info', 'اطلاعات ناشر', '出版商信息'],
  'PUBLISHER_ACCOUNT.DESC': [
    'This information is required for your cooperation contract with Bazaar. You must complete it and get confirmation before sending the app publishing request.',
    'این اطلاعات به منظور تکمیل قرارداد همکاری شما با بازار دریافت می‌شود و لازم است پیش از ارسال درخواست انتشار برنامه، تکمیل و تایید شود.',
    'This information is required for your cooperation contract with Bazaar. You must complete it and get confirmation before sending the app publishing request.',
  ],
  'PUBLISHER_ACCOUNT.DEFECTIVE_LABEL': ['Defective', 'ناقص', '有缺陷的'],
  'PUBLISHER_ACCOUNT.NOT_REVIEWED_LABEL': [
    'Not Reviewed',
    'بررسی‌نشده',
    '未审核',
  ],
  'PUBLISHER_ACCOUNT.VERIFIED_LABEL': ['Verified', 'تأیید‌شده', '已证实'],
  'PUBLISHER_ACCOUNT.MODIFIED_LABEL': ['Modified', 'تغییریافته', '被改进'],
  'PUBLISHER_ACCOUNT.BLOCKED_LABEL': ['Blocked', 'تعلیق‌شده', '被阻止'],
  'PUBLISHER_ACCOUNT.ACCEPTED_FOR_FREE_PRODUCTS_LABEL': [
    'Limited Verified',
    'تأییدشده‌ی محدود',
    '有限验证',
  ],
  'PUBLISHER_ACCOUNT.ACCEPTED_WITH_MODIFIED_FINANCE_LABEL': [
    'Modified Finance Info',
    'اطلاعات مالی تغییر‌یافته',
    '修改的账户信息',
  ],
  'PUBLISHER_ACCOUNT.DEFECTIVE_MESSAGE': [
    'Your account is in "defective" state. You can not send any application publish request while your information is defective. Please complete your information.',
    'حساب شما در حالت «ناقص» قرار دارد. تا زمانی که اطلاعات شما ناقص باشد، نمی‌توانید درخواست انتشار برنامه بدهید. لطفاً به صفحه حساب توسعه‌دهنده بروید و اطلاعات خود را کامل کنید.',
    '您的帐户处于缺陷的状态。当您的信息有缺陷时,您不能发送任何应用程序发布请求。请填写您的信息。',
  ],
  'PUBLISHER_ACCOUNT.NOT_REVIEWED_MESSAGE': [
    'Your account is in "not reviewed" state. You can not send any application publish request while your account is being reviewed. The account review process takes up to a day. Please wait until the review process is done.',
    'حساب شما در حالت «بررسی‌نشده» قرار دارد. در مدت زمان بررسی حساب شما نمی‌توانید درخواست انتشار برنامه بدهید. روند بررسی حساب تا حداکثر یک روز کاری طول می‌کشد. لطفاً تا زمان اتمام روند بررسی صبر کنید.',
    '您的帐户处于"未审核"状态。在审阅帐户时,您不能发送任何要发布应用程序的请求。帐户审核过程最多需要一天时间。请等待审查过程完成。',
  ],
  'PUBLISHER_ACCOUNT.VERIFIED_MESSAGE': [
    'Your account is verified.',
    'حساب شما تأیید شده است.',
    '您的帐户已验证。',
  ],
  'PUBLISHER_ACCOUNT.MODIFIED_MESSAGE': [
    'Your account is in "modified" state. You can not send any application publish request while your account is being reviewed. The account review process takes up to a day. Please wait until the review process is done.',
    'حساب شما در حالت «تغییریافته» قرار دارد. در مدت زمان بررسی حساب، شما نمی‌توانید درخواست انتشار برنامه را ارسال کنید. روند بررسی حساب ممکن است حداکثر یک روز کاری به طول انجامد. لطفاً تا زمان اتمام روند بررسی صبر کنید.',
    '您的帐户处于"已修改"状态。在审核帐户时,不能发送任何发布应用程序的请求。帐户审核过程最多需要一天时间。请等待审查过程完成。',
  ],
  'PUBLISHER_ACCOUNT.BLOCKED_MESSAGE': [
    'Your account is in "blocked" state. You can not send any application publish request while your account is blocked.',
    'حساب شما در حالت «تعلیق» قرار دارد. تا زمانی که حساب شما در حالت تعلیق قرار دارد، نمی‌توانید درخواست انتشار برنامه بدهید.',
    '您的帐户处于"阻止"状态。当您的帐户被阻止时,您不能发送任何应用程序来发布请求。',
  ],
  'PUBLISHER_ACCOUNT.ACCEPTED_FOR_FREE_PRODUCTS_MESSAGE': [
    "Your account's financial info is defective. You can send publish request only for free applications. Please complete your financial info.",
    'اطلاعات مالی حساب شما ناقص است. حساب شما تنها برای انتشار برنامه‌های رایگان تأیید شده است. برای تأیید حساب اطلاعات مالی را تکمیل کنید.',
    '你帐户的财务信息有缺陷。您只能为免费应用程序发送发布请求。请填写您的财务信息。',
  ],
  'PUBLISHER_ACCOUNT.ACCEPTED_WITH_MODIFIED_FINANCE_MESSAGE': [
    "Your account's financial info has been changed. You can not send any publish request for non-free applications while your account is being reviewed. The account review process takes up to a week. Please wait until the review process is done.",
    'اطلاعات مالی حساب شما تغییر یافته است. در مدت زمان بررسی حساب، شما امکان انتشار برنامه‌های غیررایگان را ندارید. روند بررسی حساب تا یک هفته طول می‌کشد. لطفاً تا زمان اتمام روند بررسی صبر کنید.',
    '您帐户的财务信息已更改。在审核帐户时,您不能发送任何非免费应用程序的发布请求。帐户审核过程最多需要一周时间。请等待审查过程完成。',
  ],
  'PUBLISHER_ACCOUNT.ACCOUNT_INFO': [
    'General Information',
    'اطلاعات عمومی',
    '基本信息',
  ],
  'PUBLISHER_ACCOUNT.PASSPORT_CODE_HELP_TEXT': [
    'Please enter passport number (Only digits).',
    'لطفا شماره پاسپورت خود را وارد کنید (فقط اعداد).',
    '请输入护照号码（只用数字）',
  ],
  'EDIT_DISABLED_DESC': [
    'You cannot edit your information after confirmation. For more information, contact the {support} team.',
    'پس از تایید اطلاعات شناسایی، امکان تغییر آن وجود ندارد. برای راهنمایی بیشتر با {support} در ارتباط باشید.',
    'You cannot edit your information after confirmation. For more information, contact the {support} team.',
  ],
  'PUBLISHER_EMAIL_CAN_NOT_CHANGE': [
    'It is not possible to change email',
    'امکان تغییر ایمیل وجود ندارد',
    'It is not possible to change email',
  ],
  'PUBLISHER_ACCOUNT.FULL_NAME': ['Full Name', 'نام کامل', '全名'],
  'PUBLISHER_ACCOUNT.COMPANY_FULL_NAME': [
    'Company full Name',
    'نام کامل شرکت',
    '公司全名',
  ],
  'PUBLISHER_ACCOUNT.NAME_HELP_TEXT': [
    'This name should be identical to the name of the owner of the back account for future payments',
    'این نام برای پرداخت‌های آتی لازم است با نام صاحب حساب بانکی یکی باشد',
    '此名称应与将来付款的后台帐户所有者的名称相同',
  ],
  'PUBLISHER_ACCOUNT.ACCOUNT_TYPE': ['Account Type', 'نوع حساب', '账号类型'],
  'PUBLISHER_ACCOUNT.NATIONAL_INFO': [
    'National Information',
    'اطلاعات ملی',
    '国民个人信息',
  ],
  'PUBLISHER_ACCOUNT.NATIONAL_INFO_DESC': [
    'Edit your national information.',
    'اطلاعات ملی خود را ویرایش کنید.',
    '编辑国民个人信息',
  ],
  'PUBLISHER_ACCOUNT.DRAG_NATIONAL_IMAGE': [
    'Drag your national card image here or click to select.',
    'تصویر کارت ملی خود را اینجا بکشید یا برای انتخاب کلیک کنید.',
    '将您的国民身份证的图像拖到此处或单击以选择',
  ],
  'PUBLISHER_ACCOUNT.DRAG_CEO_NATIONAL_IMAGE': [
    "Drag the CEO's national card image here or click to select.",
    'تصویر کارت ملی مدیرعامل را اینجا بکشید یا برای انتخاب کلیک کنید.',
    '将CEO国民身份证的图像拖到此处或单击以选择',
  ],
  'PUBLISHER_ACCOUNT.DRAG_PASSPORT_IMAGE': [
    'Drag your passport image here or click to select.',
    'تصویر گذرنامه خود را اینجا بکشید یا برای انتخاب کلیک کنید.',
    '将您护照的图像拖到此处或单击以选择',
  ],
  'PUBLISHER_ACCOUNT.NATIONAL_CODE': [
    'National Code',
    'کد ملی',
    '国民识别号码',
  ],
  'PUBLISHER_ACCOUNT.PASSPORT_CODE': [
    'Passport Number',
    'شماره‌ی پاسپورت',
    '护照号码',
  ],
  'PUBLISHER_ACCOUNT.NATIONAL_CODE_HELP_TEXT': [
    'This code must match the image above.',
    'این کد باید با تصویر کارت ملی تطابق داشته باشد.',
    '此识别号码应与身份证里的号码匹配',
  ],
  'PUBLISHER_ACCOUNT.NATIONAL_CODE_USED_WARNING': [
    'Warning: Another account is already registered with this national code. So, it is necessary to contact support after completing the registration process to activate your account.',
    'توجه: با این کد ملی قبلا در پیشخان حساب دیگری ثبت‌ شده است. به همین دلیل لازم است پس انجام مراحل ثبت‌نام برای فعال‌سازی حساب خود با پشتیبانی تماس بگیرید.',
    'Warning: Another account is already registered with this national code. So, it is necessary to contact support after completing the registration process to activate your account.',
  ],
  'PUBLISHER_ACCOUNT.CEO_NATIONAL_INFO': [
    'CEO National Information',
    'اطلاعات ملی مدیرعامل',
    'CEO的国民个人信息',
  ],
  'PUBLISHER_ACCOUNT.CEO_NATIONAL_INFO_DESC': [
    "Edit CEO's national information.",
    'اطلاعات ملی مدیرعامل را ویرایش کنید.',
    '编辑CEO的国民个人信息',
  ],
  'PUBLISHER_ACCOUNT.CEO_NATIONAL_CODE': [
    'CEO National Code',
    'کد ملی مدیرعامل',
    'CEO身份证号码',
  ],
  'PUBLISHER_ACCOUNT.FINANCE_INFO': [
    'Financial Information',
    'اطلاعات مالی',
    '财务信息',
  ],
  'PUBLISHER_ACCOUNT.FINANCE_INFO_DESC': [
    'Edit your financial information.',
    'اطلاعات مالی خود را ویرایش کنید. برای اینکه بتوانید تصفیه‌حساب کنید، اطلاعات این بخش باید تکمیل و تأیید شود.',
    '编辑财务信息',
  ],
  'PUBLISHER_ACCOUNT.DRAG_VAT_IMAGE': [
    'Drag your VAT image here or click to select.',
    'تصویر مدرک مالیات بر ارزش افزوده‌ی خود را اینجا بکشید یا برای انتخاب کلیک کنید.',
    '将您增值税的图像拖到此处或单击以选择',
  ],
  'PUBLISHER_ACCOUNT.CONTACT_INFO': [
    'Contact Information',
    'اطلاعات تماس',
    '联系信息',
  ],
  'PUBLISHER_ACCOUNT.CONTACT_INFO_DESC.PHONE': [
    'Edit your cellphone number.',
    'شماره تلفن همراه خود را ویرایش کنید.',
    'Edit your cellphone number',
  ],
  'PUBLISHER_ACCOUNT.CONTACT_INFO_DESC': [
    'Please write your full postal address including, your country name, city name, street name, and flat number, accurately.',
    'لطفا آدرس پستی را به صورت کامل و نام استان، نام شهر، نام خیابان، نام کوچه، پلاک و شماره واحد ملک را دقیق بنویسید.',
    'Please write your full postal address including, your country name, city name, street name, and flat number, accurately.',
  ],
  'PUBLISHER_ACCOUNT.COMPANY_NAME': ['Company Name', 'نام شرکت', '公司名称'],
  'PUBLISHER_ACCOUNT.COMPANY_NAME_HELP_TEXT': [
    'This name should be identical to the name of the owner of the back account for future payments.',
    'این نام برای پرداخت‌های آتی لازم است با نام صاحب حساب بانکی یکی باشد.',
    '此名称应与将来付款的后台帐户所有者的名称相同',
  ],
  'PUBLISHER_ACCOUNT.COMPANY_INFO': [
    'Company Information',
    'اطلاعات شرکت',
    '公司信息',
  ],
  'PUBLISHER_ACCOUNT.COMPANY_INFO_DESC': [
    'Edit company information.',
    'اطلاعات شرکت را ویرایش کنید.',
    '编辑公司信息',
  ],
  'PUBLISHER_ACCOUNT.DRAG_CERTIFICATION_IMAGE': [
    'Drag your company certification image here or click to select.',
    'تصویر گواهی روزنامه‌ی رسمی شرکت خود را اینجا بکشید یا برای انتخاب کلیک کنید.',
    '将您的公司认证图像拖到此处或单击以选择',
  ],
  'PUBLISHER_ACCOUNT.NATIONAL_CARD_IMAGE': [
    'National Card Image',
    'تصویر کارت ملی',
    '国民身份证图像',
  ],
  'PUBLISHER_ACCOUNT.VAT_IMAGE': [
    'VAT Image',
    'تصویر مدرک مالیات بر ارزش افزوده',
    '增值税图像',
  ],
  'PUBLISHER_ACCOUNT.ECONOMIC_CODE': [
    'Economic Code',
    'کد اقتصادی',
    '经济指数',
  ],
  'PUBLISHER_ACCOUNT.PASSPORT_IMAGE': [
    'Passport Image',
    'تصویر گذرنامه',
    '护照图像',
  ],
  'PUBLISHER_ACCOUNT.COMPANY_CERTIFICATE': [
    'Company Certificate',
    'تصویر گواهی روزنامه‌ی رسمی',
    '公司认证图像',
  ],
  'PUBLISHER_ACCOUNT.CEO_NATIONAL_CARD': [
    "CEO's National Card Image",
    'تصویر کارت ملی مدیرعامل',
    'CEO国民身份证的图像',
  ],
  'PUBLISHER_ACCOUNT.REGISTRATION_NUMBER': [
    'Registration Number',
    'شماره‌ی ثبت',
    '公司注册号码',
  ],
  'PUBLISHER_ACCOUNT.COMPANY_NATIONAL_ID': [
    'National ID',
    'شناسه‌ی ملی',
    '国民识别号码',
  ],
  'PUBLISHER_ACCOUNT.INVALID_COMPANY_NATIONAL_ID': [
    "Company's national id should be 11 numeric letters.",
    'شناسه‌ی ملی باید ۱۱ رقم باشد.',
    '公司的注册号应该是18个数字字母。',
  ],
  'PUBLISHER_ACCOUNT.INVALID_PHONE': [
    'Phone number should be 11 numeric letters starting with 09.',
    'شماره‌ موبایل باید ۱۱ رقم باشد و با ۰۹ آغاز شود.',
    '电话号码应为11个数字字母',
  ],
  'PUBLISHER_ACCOUNT.INVALID_PASSPORT_CODE': [
    'Passport number must be 8 or 12 characters.',
    'شماره‌ی پاسپورت باید ۸ الی ۱۲ کاراکتر باشد.',
    '护照号码必须是8或12个字符。',
  ],
  'PUBLISHER_ACCOUNT.INVALID_FOREIGN_PHONE': [
    'Phone number should be in numeric letters, not less than 3 digits.',
    'شماره‌ موبایل باید به عدد و حداقل ۳ رقم باشد.',
    '电话号码应为数字字母,不少于3位。',
  ],
  'PUBLISHER_ACCOUNT.INVALID_POSTAL_CODE': [
    'Postal code length should be between 3 to 30.',
    'طول کد پستی باید بین ۳ تا ۳۰ باشد.',
    '邮政编码长度应在3到30之间。',
  ],
  'PUBLISHER_ACCOUNT.COMPANY_NATIONAL_ID_USED_WARNING': [
    'Warning: Another account is already registered with this company national id, your account needs to be verified and accepted by our support team.',
    'توجه: با این شناسه ملی قبلا در پیشخان حساب دیگری ثبت‌ شده است و تنها در صورت تأیید تیم پشتیبانی، حساب شما فعال خواهد شد.',
    '警告：另一个帐户已注册此公司的国家标识,您的帐户需要我们的支持团队验证和接受。',
  ],
  'PUBLISHER_ACCOUNT.VAT_LETTER': [
    'Vat Registration letter',
    'نامه‌ی ثبت مالیات',
    '增值税登记证',
  ],
  'CONTRACT.TITLE': ['Contract', 'قرارداد', '财务'],
  'CONTRACT.DESC': ['', '', ''],
  'CONTRACT.CHANGES': ['Contract changes', 'تغییرات قرارداد', '合同变更'],
  'CONTRACT.ACCEPT_BTN': [
    'I accept the contract.',
    'قرارداد را می‌پذیرم.',
    '我接受合同',
  ],
  'CONTRACT.REJECT_BTN': [
    'I reject the contract.',
    'قرارداد را نمی‌پذیرم.',
    'I reject the contract.',
  ],
  'CONTRACT.ACCEPTED': ['Accepted', 'پذیرفته‌شده', '认可的'],
  'CONTRACT.NOT_ACCEPTED': [
    'Waiting to be accepted',
    'در انتظار پذیرش',
    '等待接受',
  ],
  'APPS.ALERT.TITLE': ['Announcement!', 'اطلاعیه!', '公告!'],
  'APPS.ALERT.DESCRIPTION': [
    'The developer panel will not accept new updates with SDK version below 26, from Jun 23rd. For more information, see {post_link}.',
    'مطابق زمانبندی گفته‌شده، از ۱ مرداد، امکان آپلود بسته‌‌های جدیدی که SDK version پایین‌تر از ۲۶ دارند، وجود ندارد. برای اطلاعات بیشتر به {post_link} مراجعه نمایید.',
    '从6月23日起,开发人员面板将不接受低于26的SDK版本的新更新。有关详细信息,请参阅{post_link}。',
  ],
  'APPS.TITLE': ['Apps', 'برنامه‌ها', '应用'],
  'APPS.GAMES': ['Games', 'بازی‌ها', '游戏'],
  'APPS.DEVELOPER_TITLE': [
    'Developer Title',
    'عنوان توسعه‌دهنده',
    '开发商名称',
  ],
  'APPS.NEW_APP': ['New App', 'برنامه‌ی جدید', '新应用'],
  'APPS.HIDDEN_APPS.TITLE': [
    'Hidden Apps',
    'برنامه‌های پنهان‌شده',
    '隐藏的应用程序',
  ],
  'APPS.HIDDEN_APPS.UNHIDE': [
    'Unhide App',
    'آشکار کردن برنامه',
    '取消隐藏应用程序',
  ],
  'APPS.NEW_APP_BTN': ['Create App', 'ایجاد برنامه', '创造应用'],

  'APPS.DRAFT.TITLE': ['Draft Apps', 'برنامه‌های پیش‌نویس', 'Draft Apps'],
  'APPS.DRAFT.CREATE_NEW': [
    'Create New App',
    'ایجاد برنامه جدید',
    'Create New App',
  ],
  'APPS.DRAFT.NEXT_STEP': ['Next Step', 'مرحله‌ی بعد', 'Next Step'],
  'APPS.DRAFT.PREVIOUS_STEP': ['Previous Step', 'مرحله‌ی قبل', 'Previous Step'],
  'APPS.DRAFT.STEPS.UPLOAD_FILES': [
    'Upload Files',
    'آپلود APK یا App Bundle',
    'Upload Files',
  ],
  'APPS.DRAFT.UPLOADED_FILES': [
    'Uploaded Files',
    'بسته‌های بارگذاری شده',
    'Uploaded Files',
  ],
  'APPS.DRAFT.STEPS.UPLOAD_FILES.DELETE_RELEASE': [
    'Delete The File & Upload Another File',
    'حذف فایل و بارگذاری فایل دیگر',
    'Delete The File & Upload Another File',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO': ['Basic Info', 'اطلاعات پایه', 'Basic Info'],
  'APPS.DRAFT.STEPS.BASIC_INFO.DEVELOPER_TITLE': [
    'Developer Title',
    'عنوان توسعه‌دهنده',
    'Developer Title',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.DEVELOPER_TITLE_DESCRIPTION': [
    'Under what title do you want your app or game to be published?',
    'تمایل دارید برنامه یا بازی شما تحت کدام عنوان منتشر شود؟',
    'Under what title do you want your app or game to be published?',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.APP_TYPE': [
    'App Type',
    'نوع برنامه',
    'App Type',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.APP_TYPE.APPLICATION': [
    'Application',
    'برنامه‌ی کاربردی',
    'Application',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.APP_TYPE.GAME': ['Game', 'بازی', 'Game'],
  'APPS.DRAFT.STEPS.BASIC_INFO.APP_TYPE_DESCRIPTION': [
    'Is the file you uploaded in the previous step an application or a mobile game?',
    'فایلی که در مرحله‌ی قبل بارگذاری کردید برنامه‌ی کاربردی است یا بازی موبایلی؟',
    'Is the file you uploaded in the previous step an application or a mobile game?',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.APP_CATEGORY': [
    'Category',
    'دسته‌بندی',
    'Category',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.APP_CATEGORY_DESCRIPTION': [
    'In which category do you want your application or game to be displayed?',
    'تمایل دارید برنامه یا بازی شما در کدام دسته‌بندی نمایش داده شود؟',
    'In which category do you want your application or game to be displayed?',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.PRICING_METHOD': [
    'Pricing Method',
    'روش قیمت‌گذاری',
    'Pricing Method',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.PRICING_METHOD_DESCRIPTION': [
    'Note that you will only be able to choose the "Pay before download" option until the app is published by "Bazaar". After publication, it is not possible to change the free app to a paid one, and only the price can be changed.',
    'توجه کنید که فقط تا قبل از انتشار برنامه توسط «بازار» امکان انتخاب گزینه‌ی «پرداخت هزینه قبل از دانلود» راخواهید داشت. بعد از انتشار امکان تغییر برنامه‌ی رایگان به پولی وجود ندارد و فقط مبلغ پرداختی قابل تغییر است.',
    'Note that you will only be able to choose the "Pay before download" option until the app is published by "Bazaar". After publication, it is not possible to change the free app to a paid one, and only the price can be changed.',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.PRICING_METHOD.FREE': ['Free', 'رایگان', 'Free'],
  'APPS.DRAFT.STEPS.BASIC_INFO.GET_RSA_KEY': [
    'Get RSA Key',
    'دریافت کلید RSA',
    'Get RSA Key',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.RSA_KEY_TITLE': [
    'Get a RSA key to put in your app',
    'دریافت کلید RSA برای قراردادن در برنامه',
    'Get a RSA key to put in your app',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.DYNAMIC_PRICE_KEY_TITLE': [
    'Dynamic Price key',
    'کلید تخفیف پویا',
    'Dynamic Price key',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.RSA_DESC': [
    'Generate an RSA key before defining your in-app products. After getting your RSA key, put it into the source code of your app based on the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/in-app-billing/implementation/kotlin">Documentations</a>.',
    'پیش از تعریف محصولات درون‌برنامه‌ای خود، باید کلید RSA بسازید. پس از دریافت کلید رمزشده (RSA)، آن را به روشی که در <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/implementation/kotlin">مستندات</a> توضیح داده‌ایم در کد برنامه‌تان قرار دهید.',
    'Generate an RSA key before defining your in-app products. After getting your RSA key, put it into the source code of your app based on the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/in-app-billing/implementation/kotlin">Documentations</a>.',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.GET_DYNAMIC_PRICE_KEY': [
    'Get Dynamic Price Key',
    'دریافت کلید تخفیف پویا',
    'Get Dynamic Price Key',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.REVOKE_THE_KEY': [
    'Revoke The Key',
    'بازنشانی کلید',
    'Revoke The Key',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.DYNAMIC_PRICE_DESC': [
    'You can use this feature in order to specify a dynamic price for a product, on the fly. For more information please refer to the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/dynamic-discount/">documentation</a>',
    'با استفاده از این کلید و مطابق با <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/dynamic-discount/">مستندات</a>، می‌توانید قیمت یک شناسه محصول را در فرآیند پرداخت تغییر دهید.',
    'You can use this feature in order to specify a dynamic price for a product, on the fly. For more information please refer to the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/dynamic-discount/">documentation</a>',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.PRICING_METHOD.PAY_BEFORE_DOWNLOAD': [
    'Pay before download',
    'پرداخت هزینه قبل از دانلود',
    'Pay before download',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.PRICE': ['Price', 'قیمت', 'Price'],
  'APPS.DRAFT.STEPS.BASIC_INFO.PRICE_DESCRITION': [
    'Specify the price that the user must pay before downloading your app or game.',
    'قیمتی که کاربر باید قبل از دانلود برنامه یا بازی شما پرداخت کند را مشخص کنید.',
    'Specify the price that the user must pay before downloading your app or game.',
  ],

  'APPS.DRAFT.STEPS.BASIC_INFO.USE_IAP': [
    'The app needs in-app purchases',
    'برنامه نیاز به پرداخت درون‌برنامه‌ای دارد',
    'The app needs in-app purchases',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.HAVE_IAP': [
    'Has in-app purchases',
    'دارای پرداخت درون‌برنامه‌ای',
    'Has in-app purchases',
  ],
  'APPS.DRAFT.STEPS.IN_APP_PURCHASE': [
    'In-app Purchase',
    'پرداخت درون‌برنامه‌ای',
    'In-app Purchase',
  ],
  'APPS.DRAFT.STEPS.BASIC_INFO.FINANCE_INFO_WARNING': [
    'Your financial information is incomplete or under review. To request the release of non-free apps, it is necessary to have your account\'s financial information verified. If this information is incomplete, you can complete it by referring to the "Publisher Information" section.',
    'اطلاعات مالی شما ناقص و یا در دست بررسی است. برای درخواست انتشار برنامه‌های غیر رایگان، لازم است تا اطلاعات مالی حساب شما تاییده شده باشد. درصورت ناقص بودن این اطلاعات می‌توانید با مراجعه به بخش «اطلاعات ناشر» آن را کامل کنید.',
    'Your financial information is incomplete or under review. To request the release of non-free apps, it is necessary to have your account\'s financial information verified. If this information is incomplete, you can complete it by referring to the "Publisher Information" section.',
  ],
  'APPS.DRAFT.STEPS.APP_INFO': ['App Info', 'اطلاعات برنامه', 'App Info'],
  'APPS.DRAFT.STEPS.APP_INFO.APP_NAME_FA': [
    'Persian Name',
    'نام فارسی برنامه',
    'Persian Name',
  ],
  'APPS.DRAFT.STEPS.APP_INFO.APP_NAME_EN': [
    'English Name',
    'نام انگلیسی برنامه',
    'English Name',
  ],
  'APPS.DRAFT.STEPS.APP_INFO.SHORT_DESCRIPTION_FA': [
    'Short Persian description',
    'توضیحات کوتاه فارسی',
    'Short Persian description',
  ],
  'APPS.DRAFT.STEPS.APP_INFO.SHORT_DESCRIPTION_EN': [
    'Short English description',
    'توضیحات کوتاه انگلیسی',
    'Short English description',
  ],
  'APPS.DRAFT.STEPS.APP_INFO.DESCRIPTION_FA': [
    'Persian description',
    'توضیحات فارسی',
    'Persian description',
  ],
  'APPS.DRAFT.STEPS.APP_INFO.DESCRIPTION_EN': [
    'English description',
    'توضیحات انگلیسی',
    'English description',
  ],
  'APPS.DRAFT.STEPS.APP_INFO.APP_NAME_HINT': [
    'You are not allowed to use price, rating, emoji and symbol in the name of your application. Just enter the name of your application or game. Otherwise your application will not be approved for publication.',
    'در نام برنامه مجاز به استفاده از قیمت، امتیاز، ایموجی و سیمبل نیستید. فقط نام برنامه یا بازی خود را وارد کنید. در غیر اینصورت برنامه شما برای انتشار تایید نخواهد شد.',
    'You are not allowed to use price, rating, emoji and symbol in the name of your application. Just enter the name of your application or game. Otherwise your application will not be approved for publication.',
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO': [
    'Support Information',
    'اطلاعات پشتیبانی',
    'Support Information',
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO.PHONE': [
    'Contact Number',
    'تلفن تماس',
    'Contact Number',
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO.PHONE_HINT': [
    "Enter the phone number you are answering so that you can be contacted in the event of a problem after installation or payment within the user's applications.",
    'شماره‌ی تلفنی که پاسخگو هستید را وارد کنید تا در صورت بروز مشکل پس از نصب یا پرداخت درون‌برنامه‌ای کاربر امکان تماس با شما را داشته باشد.',
    "Enter the phone number you are answering so that you can be contacted in the event of a problem after installation or payment within the user's applications.",
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO.EMAIL': [
    'Support Email',
    'ایمیل پشتیبانی',
    'Support Email',
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO.PERSIAN_WEBSITE': [
    'Persian Website',
    'وب‌سایت فارسی',
    'Persian Website',
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO.ENGLISH_WEBSITE': [
    'English Website',
    'وب‌سایت انگلیسی',
    'English Website',
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO.ENGLISH_WEBSITE_HINT': [
    'If the English version of the website for your application is separate from the Persian version, enter its address.',
    'درصورتی که وبسایت انگلیسی برنامه از نسخه‌ی فارسی آن جداست، آدرس آن را وارد نمایید.',
    'If the English version of the website for your application is separate from the Persian version, enter its address.',
  ],
  'APPS.DRAFT.STEPS.SUPPORT_INFO.EMAIL_HINT': [
    'If there is a problem with the application or how it works, the users or the support team will contact you with this email address.',
    'در صورت بروز مشکل درباره برنامه یا نحوه کارکرد آن، کاربران و یا تیم پشتیبانی از طریق این آدرس ایمیل با شما در ارتباط خواهد بود.',
    'If there is a problem with the application or how it works, the users or the support team will contact you with this email address.',
  ],
  'APPS.DRAFT.STEPS.APP_MEDIA': [
    'Upload Images',
    'آپلود تصاویر و آیکون',
    'Upload Images',
  ],
  'APPS.DRAFT.STEPS.APP_MEDIA.APP_ICON': [
    'App Icon',
    'آیکون برنامه',
    'App Icon',
  ],
  'APPS.DRAFT.STEPS.APP_MEDIA.PROMOTION_SCREENSHOTS.DESCRIPTION': [
    '',
    'اسکرین‌شات‌های پروموشن، تصاویری است که از برنامه‌ی شما در ردیف‌های اتوماتیک عکس‌دار بازار، برای مثال لیست «گشت‌وگذار در بازی/برنامه‌های پیشنهادی» نمایش داده می‌شود. با آپلود تصویر مناسب می‌توانید امکان حضور در این سطر را پیدا کنید. در صورتی که چند تصویر آپلود کنید، بین تصاویر بارگذاری‌شده اسلایدشو اتفاق می‌افتد. تصاویری از اسکرین‌شات‌های برنامه‌ی شما که مناسب اسکرین‌شات پروموشن نیز هستند، یک بار به طور اتوماتیک به این بخش منتقل شده‌اند.<br>برای مشاهده‌ی توضیحات کامل‌تر در خصوص اسکرین‌شات‌های پروموشن و مواردی که در خصوص تصاویر بارگذاری شده رعایت شود، <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/screenshot-promotion/">اینجا</a> را ببینید.',
    '',
  ],
  'APPS.DRAFT.STEPS.FINAL_CHECK': [
    'Summary of entered information',
    'خلاصه‌ی اطلاعات وارد شده',
    'Summary of entered information',
  ],
  'APPS.DRAFT.STEPS.FINAL_CHECK_SIDEBAR_TITLE': [
    'Overview',
    'بازبینی اطلاعات',
    'Overview',
  ],
  'APPS.DRAFT.STEPS.FINAL_CHECK.DESCRIPTION': [
    'Before submitting a review request for your app or game, please check the information below and click the "Next step" button if the information is correct.',
    'قبل از ارسال درخواست بررسی برای برنامه یا بازی خود، لطفا اطلاعات زیر را بررسی کرده و در صورت صحیح بودن اطلاعات، روی دکمه‌ی «مرحله‌ی بعد» کلیک کنید.',
    'Before submitting a review request for your app or game, please check the information below and click the "Next step" button if the information is correct.',
  ],
  'APP.DRAFT.STEPS.FINAL_CHECK.PUBLISHING_TYPE': [
    'Publishing Type',
    'نحوه‌ی انتشار',
    'Publishing Type',
  ],
  'APPS.DRAFT.STEPS.FINAL_CHECK.AUTO_PUBLISH_AFTER_APPROVAL': [
    'Automatic Publish (After being approved)',
    'انتشار خودکار (پس از تایید)',
    'Automatic Publish (After being approved)',
  ],
  'APPS.DRAFT.STEPS.FINAL_CHECK.MANUAL_PUBLISH': [
    'Manual Publish',
    'انتشار دستی',
    'Manual Publish',
  ],

  'APP.DRAFT.STEPS.FINAL_CHECK.PUBLISHING_GROUP': [
    'Publishing Group',
    'گروه انتشار',
    'Publishing Group',
  ],

  'APPS.DRAFT.STEPS.FINAL_CHECK.ALPHA': ['Alpha', 'آلفا', 'Alpha'],
  'APPS.DRAFT.STEPS.FINAL_CHECK.BETA': ['Beta', 'بتا', 'Beta'],
  'APPS.DRAFT.STEPS.FINAL_CHECK.PUBLIC': ['Public', 'عمومی', 'Public'],

  'APPS.DRAFT.CREATION_DATE': ['Creation Date', 'تاریخ ایجاد', 'Creation Date'],

  'APPS.LIST.NAME': ['Name', 'نام', '名称'],
  'APPS.LIST.STATUS': ['Status', 'وضعیت', '状态'],
  'APPS.LIST.PRICE': ['Price', 'قیمت', '价格'],
  'APPS.LIST.PRICE.NEW': ['Under review', 'در حال بررسی', '增值税'],
  'APPS.LIST.SALES': ['Sales (count)', 'فروش (تعداد)', '出售（次数'],
  'APPS.LIST.INSTALLED': ['Installed', 'نصب‌شده', '已安装'],
  'APPS.LIST.RATING': ['Rating', 'امتیاز', '评级'],
  'APPS.LIST.ESRA_RATING': [
    'Age rating: {age}',
    'رده‌بندی سنی: {age}',
    '年龄分级：{age}',
  ],
  'APPS.LIST.ESRA_TOOLTIP': [
    "National Computer Games Foundation regulations require games to have an age rating. Set this game's rating from Basic Information.",
    'با توجه به الزام بنیاد ملی بازی‌های رایانه‌ای، لازم است رده‌بندی سنی بازی خود را از طریق بازار در سامانه «اسرا» مشخص کنید. برای این کار، وارد بخش «اطلاعات پایه» شوید.',
    '根据国家电子游戏基金会的规定，游戏必须设置年龄分级。请在“基本信息”中完成设置。',
  ],
  'APPS.LIST.NO_DATA': [
    'No Apps Found.',
    'هیچ برنامه‌ای پیدا نشد.',
    '找不到应用程序',
  ],
  'APPS.LIST.API_ERROR': [
    'Error getting apps list',
    'خطا در دریافت لیست برنامه‌ها',
    '获取应用程序列表时出错',
  ],
  'APPS.PICK_A_CATEGORY': [
    'Pick a category',
    'دسته‌بندی را انتخاب کنید',
    '选择类别',
  ],
  'APPS.PICK_DEVELOPER_TITLE': [
    'Pick developer title.',
    'عنوان توسعه‌دهنده را انتخاب کنید.',
    '选择开发商的名称',
  ],
  'APPS.DASHBOARD.TITLE': ['Dashboard', 'داشبورد', '仪表板'],
  'APPS.DASHBOARD.DAILY_INSTALLS.DESCRIPTION': [
    'Number of installs from Bazaar.',
    'تعداد نصب از بازار.',
    '从集市安装的数量。',
  ],
  'APPS.DASHBOARD.DAILY_INCOME.TITLE': [
    'Daily Income',
    'درآمد روزانه',
    '日常收入',
  ],
  'APPS.DASHBOARD.DAILY_INCOME.DESCRIPTION': [
    'In-app purchases in Rial.',
    'فروش درون‌برنامه‌ای روزانه‌ به ریال.',
    '里亚尔的应用内购买。',
  ],
  'APPS.DASHBOARD.RATINGS.TITLE': ['Ratings', 'امتیازات', '评级'],
  'APPS.DASHBOARD.RATINGS.Y_AXIS_TITLE': ['Rating', 'امتیاز', '评级'],
  'APPS.DASHBOARD.PROGRESS': [
    'vs previous period',
    'نسبت به روز قبل',
    '与上期相比',
  ],
  'APPS.DASHBOARD.CHARTS.Y_AXIS_TITLE': ['Count', 'تعداد', '计数'],
  'APPS.DASHBOARD.CHARTS.X_AXIS_TITLE': ['Date', 'تاریخ', '日期'],
  'APPS.DASHBOARD.CHARTS.DETAILS_TITLE': [
    'See datails',
    'مشاهده جزئیات',
    '查看详细信息',
  ],
  'APPS.DASHBOARD.UNAVAILABLE_MESSAGE': [
    'This graph is unavailable temporarily.',
    'این نمودار موقتا از دسترس خارج است.',
    'This graph is unavailable temporarily.',
  ],
  'APPS.DASHBOARD.NA_PURCHASE_MESSAGE': [
    'This graph is currently under construction; <br>you may access your income through the Finance section of your panel.',
    'این نمودار پس از انجام اصلاحات، مجددا نمایش داده‌خواهدشد.<br> برای مشاهده‌ی آمار دقیق فروش می‌توانید از بخش مالی استفاده کنید.',
    'This graph is currently under construction; <br>you may access your income through the Finance section of your panel.',
  ],
  'APPS.INFO.TITLE': ['Information', 'اطلاعات', '信息'],
  'APPS.INFO.BASIC_INFO': ['Basic Information', 'اطلاعات پایه', '基本信息'],
  'APPS.INFO.BASIC_INFO_DESC': [
    "Edit app's basic information.",
    'اطلاعات پایه‌ی برنامه را ویرایش کنید.',
    '编辑应用基本信息',
  ],
  'APPS.INFO.ESRA.AGE_GROUP': ['Age Group', 'گروه سنی', '年龄分级'],
  'APPS.INFO.ESRA.REQUEST': [
    'Get age rating',
    'دریافت رده‌بندی',
    '获取年龄分级',
  ],
  'APPS.INFO.ESRA.CONTINUE_REQUEST': ['Continue', 'ادامه فرایند', '继续'],
  'APPS.INFO.ESRA.REQUEST_DESCRIPTION': [
    'Select Get age rating to open the ESRA website and specify the age rating for your game.',
    'با کلیک روی دکمه دریافت رده‌بندی وارد سایت «اسرا» شده و رده‌بندی بازی خود را مشخص کنید.',
    '点击“获取年龄分级”进入 ESRA 网站并为游戏设置年龄分级。',
  ],
  'APPS.INFO.ESRA.INCOMPLETE_DESCRIPTION': [
    'Your age-rating process is incomplete. Complete it in the National Computer Games Foundation portal.',
    'فرایند دریافت رده‌بندی شما نیمه‌تمام مانده است. برای دریافت رده‌بندی، آن را در سامانه بنیاد ملی بازی‌های رایانه‌ای تکمیل کنید.',
    '年龄分级流程尚未完成。请前往国家电子游戏基金会系统继续完成。',
  ],
  'APPS.INFO.ESRA.UNAVAILABLE': [
    'The age-rating status is currently unavailable. This section will update after the service is available again.',
    'در حال حاضر امکان دریافت وضعیت رده‌بندی وجود ندارد. پس از برقراری ارتباط با سرویس، این بخش به‌صورت خودکار به‌روزرسانی خواهد شد.',
    '目前无法获取年龄分级状态。服务恢复后，此处将自动更新。',
  ],
  'APPS.INFO.ESRA.REQUEST_FAILED_TITLE': [
    'Request was not submitted',
    'ثبت درخواست انجام نشد',
    '请求未提交',
  ],
  'APPS.INFO.ESRA.REQUEST_FAILED_DESCRIPTION': [
    'An age-rating request cannot be submitted right now. Please try again later.',
    'در حال حاضر امکان ثبت درخواست رده‌بندی وجود ندارد. لطفاً بعداً دوباره تلاش کنید.',
    '目前无法提交年龄分级请求，请稍后重试。',
  ],
  'APPS.INFO.ESRA.ICON_ALT': [
    'ESRA age-rating mark',
    'نشان رده‌بندی سنی اسرا',
    'ESRA 年龄分级标志',
  ],
  'APPS.INFO.SUPPORT_INFO': [
    'Support Information',
    'اطلاعات پشتیبانی',
    '支持信息',
  ],
  'APPS.INFO.SUPPORT_INFO_DESC': [
    "Edit app's support information.",
    'اطلاعات پشتیبانی برنامه را ویرایش کنید.',
    '编辑应用的支持信息',
  ],
  'APPS.INFO.DEVELOPER_INFO': [
    'Developer Information',
    'اطلاعات توسعه‌دهنده',
    '开发商信息',
  ],
  'APPS.INFO.DEVELOPER_INFO_DESC': [
    "Edit app's developer information.",
    'اطلاعات توسعه‌دهنده‌ی برنامه را ویرایش کنید.',
    '编辑开发商信息',
  ],
  'APPS.INFO.CHANGE_PRICE': ['Change Price', 'تغییر قیمت', '更改价格'],
  'APPS.INFO.CHANGE_PRICE_DESC': [
    '- If you consider a price higher than 100,000 IRR for your app, the price must be checked and approved by the support team.<br>\
    - It is not possible to change the price for applications that are published for free. Please specify the price before publishing the app.<br>\
    - If you change the price of your non-free app to zero, it will not be possible to add in-app payment for it and your app will be prevented from being published.<br>\
    - It is possible to add in-app payment for apps that are released for free.',
    '- اگر برای برنامه‌ی خود قیمتی بیشتر از ۱۰ هزار تومان در نظر بگیرید، قیمت آن باید توسط پشتیبانی بررسی و تایید شود. <br>\
    - امکان تغییر قیمت برای برنامه‌هایی که رایگان منتشر شده‌اند، وجود ندارد. لطفا قبل از انتشار برنامه قیمت آن را مشخص کنید. <br>\
    - اگر قیمت برنامه‌ي غیررایگان خود را به صفر تغییر دهید، امکان افزودن پرداخت درون‌برنامه‌ای برای آن وجود نخواهد داشت و از انتشار برنامه‌ی شما جلوگیری خواهد شد.<br>\
    - امکان اضافه کردن پرداخت درون‌برنامه‌ای برای برنامه‌هایی که رایگان منتشر شده‌اند، وجود دارد.',
    '- If you consider a price higher than 100,000 IRR for your app, the price must be checked and approved by the support team.<br>\
    - It is not possible to change the price for applications that are published for free. Please specify the price before publishing the app.<br>\
    - If you change the price of your non-free app to zero, it will not be possible to add in-app payment for it and your app will be prevented from being published.<br>\
    - It is possible to add in-app payment for apps that are released for free.',
  ],
  'APPS.INFO.DEVS_SHARE': [
    'Developers Share',
    'سهم توسعه‌دهنده',
    '开发商收入份额',
  ],
  'APPS.INFO.BAZAAR_SHARE': ['Bazaar Share', 'سهم بازار', '巴扎商店收入份额'],
  'APPS.IN_APP_PRODUCT.LOW_SALES_TITLE': [
    'Sales less than 10 billion rials',
    'فروش کمتر از ۱۰ میلیارد ریال',
    'Sales less than 10 billion rials',
  ],
  'APPS.IN_APP_PRODUCT.HIGH_SALES_TITLE': [
    'Sales more than 10 billion rials',
    'فروش بیش از ۱۰ میلیارد ریال',
    'Sales more than 10 billion rials',
  ],
  'APPS.INFO.VAT_VALUE': ['VAT', 'مالیات', '增值税'],
  'APPS.CATEGORY': ['Category', 'دسته‌بندی', '类别'],
  'APPS.PERSIAN_NAME': ['Persian name', 'نام فارسی', '波斯语名称'],
  'APPS.ENGLISH_NAME': ['English name', 'نام انگلیسی', '英文名称'],
  'APPS.DESCRIPTION_FA': ['Persian description', 'توضیحات فارسی', '波斯语描述'],
  'APPS.DESCRIPTION_EN': ['English description', 'توضیحات انگلیسی', '英文描述'],
  'APPS.SHORT_DESCRIPTION_EN': [
    'English Short Description',
    'توضیحات کوتاه انگلیسی',
    '英文短描述',
  ],
  'APPS.SHORT_DESCRIPTION_FA': [
    'Farsi Short Description',
    'توضیحات کوتاه فارسی',
    '波斯语短描述',
  ],
  'APPS.PACKAGE_NAME': ['Package name', 'نام بسته', '包名'],
  'APP.UPLOADED': ['Uploaded', 'بارگذاری‌شده', '已上转'],
  'APP.NEW': ['New', 'جدید', 'New'],
  'APP.PENDING': ['In Pending Queue', 'در صف انتظار', '在挂起队列中'],
  'APP.REJECTED': ['Rejected', 'ردشده', '拒绝'],
  'APP.READY_TO_PUBLISH': ['Ready to Publish', 'آماده‌ی انتشار', '准备发布'],
  'APP.PUBLISHED': ['Published', 'منتشرشده', '已发布'],
  'APP.PUBLISHED_ONLY_ABROAD': [
    'Published Only Abroad',
    'منتشرشده در خارج',
    '仅在国外出版',
  ],
  'APP.REMOVED': ['Removed', 'حذف‌‌شده', '被删除'],
  'APP.PURCHASE_DISABLED': ['Purchase Disabled', 'غیرقابل‌خرید', '购买已禁用'],
  'APP.NEED_TO_CHANGE': ['Need to Change', 'نیاز به تغییرات', '需要改变'],
  'APP.HIDDEN_FROM_DEV_PANEL': [
    'Hidden from Dev Panel',
    'پنهان از پیشخان توسعه‌دهندگان',
    '从开发面板隐藏',
  ],
  'APP.REMOVED_BY_ERSHAD': [
    'Removed By Ershad',
    'حذف‌شده توسط ارشاد',
    '由Ershad移除',
  ],
  'APP.SUSPENDED': ['Suspended', 'تعلیق‌شده', '暂停的'],
  'APP.STATE_DESCRIPTIONS.TITLE': [
    'App State Descriptions',
    'توضیح حالات مختلف برنامه',
    '应用程序状态描述',
  ],
  'APP.STATE_DESCRIPTIONS.DESC': [
    'Following description helps you understand the current state of your application:',
    'هر برنامه‌ می‌تواند وضعیت‌های مختلفی داشته باشد:',
    '以下说明有助于您了解应用程序的当前状态：',
  ],
  'APP.NEW.DESC': [
    'You\'ve just uploaded your app and haven\'t clicked on "publish request" button yet.',
    'برنامه‌ای که به تازگی بارگذاری شده و هنوز درخواست انتشار برای آن ارسال نشده است. همچنین برنامه‌ای که انتشار آن توسط توسعه‌دهنده لغو شده است نیز در این وضعیت قرار می‌گیرد.',
    '您刚刚上传了应用程序,尚未单击"发布请求"按钮。',
  ],
  'APP.PENDING.DESC': [
    'The developer has just submitted a review request to the Bazaar review team. This review may take up to 3 working days depending on the number of applications in this queue.',
    'برنامه‌ای که توسعه‌دهنده، درخواست بررسی آن را برای تیم بررسی بازار فرستاده است. این بررسی با توجه به تعداد برنامه‌هایی که در این صف حضور دارند، ممکن است تا 3 روزکاری زمان ببرد.',
    'The developer has just submitted a review request to the Bazaar review team. This review may take up to 3 working days depending on the number of applications in this queue.',
  ],
  'APP.NEED_TO_CHANGE.DESC': [
    'In order to publish your app, you need to make some changes which been sent to you by email.',
    'برنامه‌ای که برای انتشار نیاز به تغییراتی دارد. تغییرات مورد نیاز قبل از قرارگیری برنامه در این وضعیت، از طریق ایمیل به اطلاع شما خواهد رسید.',
    '为了发布你的应用程序,你需要做一些更改,这些更改已通过电子邮件发送给你。',
  ],
  'APP.REJECTED.DESC': [
    'Your app was rejected for violating our publishing guideline. You could check your inbox to find more detail.',
    'برنامه‌ای که با شرایط بازار سازگار نیست و انتشار آن منتفی است. دلایل رد برنامه از طریق ایمیل به اطلاع شما می‌رسد.',
    '您的应用程序因违反我们的发布准则而被拒绝。您可以查看收件箱以查找更多详细信息。',
  ],
  'APP.REMOVED.DESC': [
    "An app that has been published before, but it's unpublished by Bazaar now.",
    'برنامه‌ای که قبلاً منتشرشده ولی در حال حاضر انتشار آن توسط بازار متوقف شده است.',
    '以前发布过的应用程序,但现在巴扎还没有发布。',
  ],
  'APP.READY_TO_PUBLISH.DESC': [
    'An app which is ready to be published.',
    'برنامه‌ای که برای انتشار آماده است.',
    '准备发布的应用程序。',
  ],
  'APP.PUBLISHED.DESC': [
    'An app which is published on Bazaar and users have access to it.',
    'برنامه‌ای که منتشر شده و در دسترس کاربران است.',
    '在巴扎商店上发布的应用程序,用户可以访问它。',
  ],
  'APP.ACTIONS.PUBLISH_REQUEST_TITLE': [
    'Request App Publish',
    'درخواست انتشار برنامه',
    '请求应用程序发布',
  ],
  'APP.ACTIONS.CANCEL_PUBLISH_REQUEST_TITLE': [
    'Cancel App Publish Request',
    'لغو درخواست انتشار',
    '取消应用程序发布请求',
  ],
  'APP.ACTIONS.WARNING_REMOVAL_REQUEST_TITLE': [
    'Request Warning Removal',
    'درخواست رفع اخطار',
    '请求删除警告',
  ],
  'APP.ACTIONS.CANCEL_WARNING_REMOVAL_REQUEST_TITLE': [
    'Cancel Warning Removal Request',
    'لغو درخواست رفع اخطار',
    '取消警告删除请求',
  ],
  'APP.ACTIONS.SUSPENSION_REMOVAL_REQUEST_TITLE': [
    'Request Suspension Removal',
    'درخواست رفع تعلیق',
    '请求取消暂停',
  ],
  'APP.ACTIONS.CANCEL_SUSPENSION_REMOVAL_REQUEST_TITLE': [
    'Cancel Suspension Removal Request',
    'لغو درخواست رفع تعلیق',
    '取消暂停删除请求',
  ],
  'APP.ACTIONS.AUTO_PUBLISH': [
    'Automatically Publish App after it is Accepted',
    'انتشار خودکار برنامه پس از تأیید تیم انتشار',
    '接受应用后自动发布',
  ],
  'APP.ACTIONS.HIDE_TITLE': ['Hide App', 'پنهان کردن برنامه', '隐藏应用程序'],
  'APP.ACTIONS.PUBLISH_TITLE': ['Publish App', 'انتشار برنامه', '发布应用程序'],
  'APP.ACTIONS.UNPUBLISH_TITLE': [
    'Unpublish App',
    'لغو انتشار برنامه',
    '取消发布应用程序',
  ],
  'APP.ACTIONS.AUTOPUBLISH_TITLE': [
    'Turn on Automatic Publishing',
    'فعال‌سازی انتشار خودکار',
    '打开自动发布',
  ],
  'APP.ACTIONS.CANCEL_AUTOPUBLISH_TITLE': [
    'Turn off Automatic Publishing',
    'لغو انتشار خودکار',
    '关闭自动发布',
  ],
  'APP.ACTIONS.PUBLISH_REQUEST_DESC': [
    "<ul>\n<li>Publishment of an app lasts&nbsp;3 working days&nbsp;at its peak. (Thurdsdays and Fridays are not&nbsp;working&nbsp;days).</li><li>Please notice that sending emails to Bazaar and mentioning changes in your new package, won't make any changes in publishing process&nbsp;</li>\n<li>Explantations about any changes in app state, will be send to you by an email. Please check the&nbsp;<strong>spams</strong>&nbsp;too.</li>\n<li>Please pay attention that we contact you through the email you register in Bazaar with, not the email you entered in app contact part in developers panel.</li>\n</ul>",
    '<ul>\n<li>&nbsp;انتشار یک برنامه طی حداکثر ۳ روز&nbsp;<strong>کاری</strong>&nbsp;انجام می‌شوند (پنج‌شنبه‌ها و جمعه‌ها روز کاری محسوب نمی‌شوند).<br><br></li>\n<li>توجه کنید که ارسال ایمیل به بازار و اطلاع تغییرات انجام شده در برنامه، تفاوتی در زمان انتشار ایجاد&nbsp;<strong>نخواهد</strong>&nbsp;کرد و انتشار برنامه‌ها پس از هر بار ارسال درخواست، طی ۳ روز کاری انجام می‌شود.<br><br></li>\n<li>توضیحات مربوط به هر تغییری در وضعیت برنامه توسط بازار، در ایمیلی برای شما ارسال خواهد شد. اگر ایمیل به دست شما نرسیده بود، لطفاً پوشه‌ی&nbsp;<strong>اسپم‌</strong>&nbsp;ایمیل‌تان را نیز بررسی کنید.<br><br></li>\n<li>توجه فرمایید که پیام‌ها به آدرس ایمیلی ارسال می‌شود که با آن در بازار عضو شده و به عنوان توسعه‌دهنده ثبت‌نام کرده‌اید و نه ایمیلی که در بخش اطلاعات پشتیبانی کاربر در پیشخان توسعه‌دهندگان وارد کرده‌اید.&nbsp;</li>\n</ul>',
    '一个应用程序的发布在高峰期持续3个工作日。（星期四和星期五不是工作日）。请注意,向Bazaar发送电子邮件并提及新软件包中的更改,不会在发布过程中进行任何更改有关应用程序状态的任何更改的说明将通过电子邮件发送给您。请检查一下水疗中心。请注意,我们通过您在Bazaar注册的电子邮件与您联系,而不是您在"开发人员"面板的"应用程序联系人"部分中输入的电子邮件。',
  ],
  'APP.ACTIONS.PUBLISH_REQUEST_DESC.UPLOAD_FILE': [
    'Add attachment file',
    'افزودن فایل ضمیمه',
    'Add attachment file',
  ],
  'APP.ACTIONS.PUBLISH_REQUEST_DESC.UPLOAD_FILE_EDIT': [
    'Edit attachment file',
    'ویرایش فایل ضمیمه',
    'Edit attachment file',
  ],
  'APP.ACTIONS.DANGEROUS_PERMISSIONS': [
    'Dangerous Permissions',
    'دسترسی‌های خطرناک',
    'Dangerous Permissions',
  ],
  'APP.ACTIONS.DANGEROUS_PERMISSIONS_DESC': [
    'Dear Developer, The following permissions are detected as dangerous in "Bazaar", Please read the relevant descriptions and delete the permissions before submitting the publish request, if it\'s possible. Otherwise, you need to write the reasons for using these permissions in your application in the "Additional information for app reviewer" section.',
    'توسعه‌دهنده‌ی گرامی، دسترسی‌های زیر در «بازار» خطرناک شناسایی شده است. لطفاً توضیحات مربوطه را مطالعه کنید و در صورت امکان، پیش از ارسال درخواست انتشار دسترسی‌های اعلام‌شده را حذف کنید. در غیر این صورت، لازم است دلایل استفاده از این‌ دسترسی‌ها در برنامه‌تان را در قسمت «توضیحات بیشتر برای بررسی‌کننده» بنویسید.',
    'Dear Developer, The following permissions are detected as dangerous in "Bazaar", Please read the relevant descriptions and delete the permissions before submitting the publish request, if it\'s possible. Otherwise, you need to write the reasons for using these permissions in your application in the "Additional information for app reviewer" section.',
  ],
  'APP.ACTIONS.CANCEL_PUBLISH_REQUEST_DESC': [
    'With canceling app publishment request, your app will exit pending queue. Consider that by cancling and requesting publish for your app again, it should join the end of the pending queue again.',
    'با لغو درخواست انتشار، برنامهٔ شما از صف انتظار خارج خواهد شد. توجه کنید که در صورت لغو و ارسال درخواست انتشار مجدد، برنامه به&nbsp;<strong>انتهای&nbsp;</strong>صف انتظار می‌رود.',
    '取消应用程序发布请求,您的应用程序将退出挂起的队列。考虑一下,通过再次取消并请求发布应用程序,它应该再次加入挂起队列的末尾。',
  ],
  'APP.ACTIONS.WARNING_REMOVAL_REQUEST_DESC': ['', '', ''],
  'APP.ACTIONS.CANCEL_WARNING_REMOVAL_REQUEST_DESC': ['', '', ''],
  'APP.ACTIONS.SUSPENSION_REMOVAL_REQUEST_DESC': ['', '', ''],
  'APP.ACTIONS.CANCEL_SUSPENSION_REMOVAL_REQUEST_DESC': ['', '', ''],
  'APP.ACTIONS.HIDE_DESC': [
    "After hiding your app, it will be removed from your apps list. You can revert this using the lnk in the app lists page. Be aware that your app won't be deleted and you&nbsp;<strong>can't</strong>&nbsp;use hidden apps' Package Names in your new apps.",
    'پس از پنهان کردن، برنامه‌ی شما از لیست برنامه‌ها برداشته خواهد شد. شما می‌توانید از طریق لینک موجود در صفحه‌ی لیست برنامه‌ها، برنامه‌ی خود را دوباره در این لیست آشکار کنید. توجه داشته باشید که برنامه‌ی شما حذف نمی‌شود، و <strong>نمی‌توانید</strong> از Package Name (نام بسته) برنامه‌های ‌پنهان‌شده، در برنامه‌های جدید خود استفاده کنید.',
    '隐藏应用程序后,它将从应用程序列表中删除。您可以使用"应用程序列表"页上的链接还原此内容。请注意,您的应用程序不会被删除,并且您不能在新应用程序中使用隐藏的应用程序包名称。',
  ],
  'APP.ACTIONS.PUBLISH_DESC': [
    'Note that due to syncing delays among Bazaar servers it may take up to 1 hour to see your app in Bazaar.',
    'دقت داشته باشید که به دلیل همگام‌سازی سرورهای بازار، ممکن است انتشار برنامه حداکثر یک ساعت به طول بیانجامد.',
    '请注意,由于巴扎商店服务器之间的同步延迟,可能需要1小时才能在商店上看到您的应用程序。',
  ],
  'APP.ACTIONS.UNPUBLISH_DESC': [
    'In the case of unpublishing app, app will be out of publish and its state will be "Ready to publish".',
    'در صورت لغو انتشار، برنامه از انتشار خارج شده و به حالت آماده‌ی انتشار می‌رود.',
    '在取消发布应用程序的情况下,该应用程序将停止发布,其状态将为"准备发布"。',
  ],
  'APP.ACTIONS.AUTOPUBLISH_DESC': [
    'If "Auto Publish" is enabled, your app will be published to users immediately after Bazaar approval.',
    'در صورت فعال‌سازی «انتشار خودکار»، برنامه‌ی شما پس از تأیید بازار بلافاصله برای کاربران منتشر می‌شود.',
    'If "Auto Publish" is enabled, your app will be published to users immediately after Bazaar approval.',
  ],
  'APP.ACTIONS.CANCEL_AUTOPUBLISH_DESC': [
    'In the case of turning off auto-publish, you can publish the app yourself by clicking on “Publich App”.',
    'در صورت لغو انتشار خودکار، با فشردن دکمه‌ی «انتشار برنامه» می‌توانید برنامه را منتشر کنید.',
    '在关闭自动发布的情况下,您可以通过单击"发布应用"自行发布应用。',
  ],
  'APP.ACTIONS.UNVERIFIED_ACCOUNT_J_DESC': [
    'You can only publish free products. Please proceed to «Publisher Info» page and complete your financial information.',
    'برای درخواست انتشار برنامه‌های غیر رایگان، اطلاعات مالی حساب خود را با مراجعه به بخش «اطلاعات ناشر» کامل کنید.',
    '您只能发布免费产品。请进入"出版商信息"页面,填写您的财务信息。',
  ],
  'APP.ACTIONS.UNVERIFIED_ACCOUNT_R_DESC': [
    'Your financial info is under review. The account review process takes up to a week. Please wait until the review process is done.',
    ' برای درخواست انتشار برنامه‌های غیر رایگان اطلاعات مالی حساب شما باید تأیید شده باشد. اطلاعات مالی حساب شما در حال بررسی است. روند بررسی حساب تا یک هفته طول می‌کشد. لطفاً تا زمان اتمام روند بررسی صبر کنید.',
    '你的财务信息正在审查中。帐户审核过程最多需要一周时间。请等待审查过程完成。',
  ],
  'APP.ACTIONS.UNVERIFIED_ACCOUNT_N_DESC': [
    'Your account is in "not reviewed" state. You can not send any application publish request while your account is being reviewed. The account review process takes up to a day. Please wait until the review process is done.',
    'حساب شما در حالت «بررسی‌نشده» قرار دارد. در مدت زمان بررسی حساب شما نمی‌توانید درخواست انتشار برنامه بدهید. روند بررسی حساب تا حداکثر یک روز کاری طول می‌کشد. لطفاً تا زمان اتمام روند بررسی صبر کنید.',
    '您的帐户处于"未审核"状态。在审阅帐户时,您不能发送任何要发布应用程序的请求。帐户审核过程最多需要一天时间。请等待审查过程完成。',
  ],
  'APP.ACTIONS.UNVERIFIED_ACCOUNT_F_DESC': [
    'Your account is in "modified" state. You can not send any application publish request while your account is being reviewed. The account review process takes up to a day. Please wait until the review process is done.',
    'حساب شما در حالت «تغییریافته» قرار دارد. در مدت زمان بررسی حساب، شما نمی‌توانید درخواست انتشار برنامه را ارسال کنید. روند بررسی حساب ممکن است حداکثر یک روز کاری به طول انجامد. لطفاً تا زمان اتمام روند بررسی صبر کنید.',
    '您的帐户处于"已修改"状态。在审核帐户时,不能发送任何发布应用程序的请求。帐户审核过程最多需要一天时间。请等待审查过程完成。',
  ],
  'APP.ACTIONS.UNVERIFIED_ACCOUNT_D_DESC': [
    'Your account is in "defective" state. You can not send any application publish request while your information is defective. Please proceed to developer account page and complete your information.',
    'حساب شما در حالت «ناقص» قرار دارد. تا زمانی که اطلاعات شما ناقص باشد، نمی‌توانید درخواست انتشار برنامه بدهید. لطفاً به صفحه حساب توسعه‌دهنده بروید و اطلاعات خود را کامل کنید.',
    '您的帐户处于"有缺陷"状态。当您的信息有缺陷时,您不能发送任何发布请求的应用程序。请转到开发人员的帐户页并填写您的信息。',
  ],
  'APP.ACTIONS.UNVERIFIED_ACCOUNT_B_DESC': [
    'Your account is in "blocked" state. You can not send any application publish request while your account is blocked.',
    'حساب شما در حالت «تعلیق» قرار دارد. تا زمانی که حساب شما در حالت تعلیق قرار دارد، نمی‌توانید درخواست انتشار برنامه بدهید.',
    '您的帐户处于"阻止"状态。当您的帐户被阻止时,您不能发送任何应用程序来发布请求。',
  ],
  'APP.ACTIONS.ERRORS': [
    'Fix the following items in application information:',
    'موارد زیر را در اطلاعات برنامه اصلاح کنید:',
    '修复应用程序信息中的以下项：',
  ],
  'APP.MEDIA.TITLE': ['Media', 'تصاویر', '图片'],
  'APP.MEDIA.COVER': ['Cover Photo', 'تصویر سرصفحه', '封面照片'],
  'APP.MEDIA.COVER_DESC': [
    'Cover Photo is an image which is shown at the top of the app details page.This image must address this requirements: {imageLimits}',
    'تصویر سرصفحه تصویری است که در بالای صفحه‌ی جزئیات برنامه نمایش داده می‌شود. این تصویر باید دارای این ویژگی‌ها باشد: {imageLimits}',
    '封面照片是在应用程序详细信息页面顶部显示的图像。此图像必须满足以下要求：{imageLimits}',
  ],
  'APP.MEDIA.MIN_WIDTH': ['Minimum Width', 'حداقل طول', '最小宽度'],
  'APP.MEDIA.MIN_HEIGHT': ['Minimum Height', 'حداقل ارتفاع', '最小高度'],
  'APP.MEDIA.ASPECT_RATIO': ['Aspect Ratio', 'نسبت ابعاد', '宽高比'],
  'APP.MEDIA.FILE_TYPE': ['File Type', 'نوع فایل', '文件类型'],
  'APP.MEDIA.CHANGE_ICON': ['App Icon', 'آیکون برنامه', '应用的图表'],
  'APP.MEDIA.CHANGE_ICON_DESC': [
    'To change the application icon, click on the image or drag the desired icon and drop it in the specified location. <br> You can also refer to icon design {docs}  for more information. {imageLimits}',
    'برای تغییر آیکون برنامه، روی تصویر کلیک کنید و یا آیکون موردنظر را کشیده و در محل مشخص شده رها کنید. <br>همچنین می‌توانید برای اطلاعات بیشتر به {docs} طراحی آیکون مراجعه کنید. {imageLimits}',
    'To change the application icon, click on the image or drag the desired icon and drop it in the specified location. <br> You can also refer to icon design {docs}  for more information. {imageLimits}',
  ],
  'APP.MEDIA.MIN_SIZE': ['Minimum Size', 'حداقل ابعاد', 'Minimum Size'],
  'APP.MEDIA.MAX_SIZE': ['Maximum Size', 'حداکثر ابعاد', 'Maximum Size'],
  'APP.MEDIA.MAX_FILE_SIZE': [
    'Maximum File Size',
    'حداکثر حجم فایل',
    '最大文件大小',
  ],
  'APP.MEDIA.SCREENSHOTS': ['Screenshots', 'اسکرین‌شات‌ها', '截图'],
  'APP.MEDIA.PROMOTION_SCREENSHOTS': [
    'Promotion Screenshots',
    'اسکرین‌شات‌های پروموشن',
    'Promotion Screenshots',
  ],
  'APP.MEDIA.PROMOTION_SCREENSHOTS.DESCRIPTION': [
    '',
    'اسکرین‌شات‌های پروموشن، تصاویری است که از برنامه‌ی شما در ردیف‌های اتوماتیک عکس‌دار بازار، برای مثال لیست «گشت‌وگذار در بازی/برنامه‌های پیشنهادی» نمایش داده می‌شود.     با آپلود تصویر مناسب می‌توانید امکان حضور در این سطر را پیدا کنید. در صورتی که چند تصویر آپلود کنید، بین تصاویر بارگذاری‌شده اسلایدشو اتفاق می‌افتد. تصاویری از اسکرین‌شات‌های برنامه‌ی شما که مناسب اسکرین‌شات پروموشن نیز هستند، یک بار به طور اتوماتیک به این بخش منتقل شده‌اند. تصاویر بارگذاری‌شده باید دارای این ویژگی‌ها باشند:  {imageLimits}\
    برای مشاهده‌ی توضیحات کامل‌تر در خصوص اسکرین‌شات‌های پروموشن و مواردی که در خصوص تصاویر بارگذاری شده رعایت شود، <a class="link" href="{docLink}" target="_blank">اینجا</a> را ببینید.',
    '',
  ],
  'APP.MEDIA.ASPECT_RATIO_16_9': [
    'The aspect ratio of the image must be 16/9',
    'نسبت ابعاد تصویر باید 16/9 باشد',
    'The aspect ratio of the image must be 16/9',
  ],
  'APP.MEDIA.NO_SCREENSHOTS': [
    'No screenshots uploaded for this app.',
    'هیچ اسکرین‌شاتی برای این برنامه آپلود نشده است.',
    '没有为这个应用上传的截图。',
  ],
  'APP.MEDIA.SCREENSHOTS_DROP_TO_UPLOAD': [
    'Drop image here to upload',
    'برای آپلود، تصویر را اینجا رها کنید',
    '将图像放到此处上转',
  ],
  'APP.MEDIA.VIDEO_SHOTS': ['Video-shots', 'ویدئوشات', '视频拍摄'],
  'APP.MEDIA.VIDEO_SHOTS_DESC': [
    'Video URL must be from aparat.com',
    ' آدرس ویدئو باید از aparat.com باشد.',
    '视频URL必须来自aparat.com',
  ],
  'APP.MEDIA.VIDEO_SHOTS_URL_EN': [
    'English video-shot URL',
    'آدرس ویدئوی انگلیسی',
    '英文视频快照URL',
  ],
  'APP.MEDIA.VIDEO_SHOTS_URL_FA': [
    'Farsi video-shot URL',
    'آدرس ویدئوی فارسی',
    '波斯语视频快照URL',
  ],
  'APP.MEDIA.INVALID_APARAT_URL': [
    'Please enter a valid URL from aparat.com',
    'لطفاً یک آدرس معتبر از aparat.com وارد کنید.',
    '请输入来自aparat.com的有效URL',
  ],
  'APP.RELEASES.TITLE': ['Releases', 'رهانش‌ها', 'Releases'],
  'APP.RELEASES.ALPHA_RELEASE.TITLE': [
    'Alpha Release',
    'رهانش آلفا',
    'Alpha Release',
  ],
  'APP.RELEASES.ALPHA_RELEASE.DESCRIPTION': [
    'Alpha Release Description',
    'رهانش آلفا (Alpha release) مرحله‌ای در فرآیند انتشار است که به شما این امکان را می‌دهد تا قابلیت‌های کاملاً جدید یا تغییرات عمده محصول خود را در یک محیط کنترل‌شده آزمایش کنید. شما می‌توانید گروه‌های محدود و انتخابی (تا ۱۰۰ نفر) از کاربران مورد اعتماد (آلفا تسترها) را برای بررسی عمیق و تخصصی تعیین کنید.',
    'Alpha Release Description',
  ],
  'APP.RELEASES.ALPHA_RELEASE.NO_GROUPS': [
    'There is no alpha group',
    'شما هنوز گروهی برای رهانش‌های آلفا نساخته‌اید!',
    '没有Alpha组',
  ],
  'APP.RELEASES.BETA_RELEASE.TITLE': [
    'Beta Release',
    'رهانش بتا',
    'Beta Release',
  ],
  'APP.RELEASES.BETA_RELEASE.DESCRIPTION': [
    'Beta Release Description',
    'رهانش بتا (Beta release) به شما اجازه می‌دهد تا محصول خود را در معرض دید جامعه‌ای گسترده‌تر و داوطلب از کاربران واقعی قرار دهید. هدف این فاز، جمع‌آوری بازخورد کمی و کیفی در مقیاس وسیع از کاربران با دستگاه‌ها، شبکه‌ها و الگوهای استفاده متنوع است. با فعال‌سازی رهانش بتا، بنری در صفحه برنامه شما در بازار برای جذب داوطلبان قرار خواهد گرفت.',
    'Beta Release Description',
  ],
  'APP.RELEASES.MANAGEMENT': [
    'Release Management',
    ' مدیریت رهانش‌ها',
    'Release Management',
  ],
  'APPS.RELEASES..RELEASE_GROUP': [
    'Release Group',
    'گروه‌های رهانش',
    'Release Group',
  ],
  'APP.RELEASES.ALPHA': ['Alpha', 'آلفا', 'Alpha'],
  'APP.RELEASES.BETA': ['Beta', 'بتا', 'Beta'],
  'APP.RELEASES.PUBLIC': ['PUBLIC', 'عمومی', 'PUBLIC'],
  'APP.RELEASES.PACKAGES': [
    'Release Packages',
    'بسته‌های رهانش',
    'Release Packages',
  ],
  'APP.RELEASES.PACKAGE_UPLOAD_DATE': [
    'Package Upload Date',
    'تاریخ بارگذاری بسته',
    'Package Upload Date',
  ],
  'APP.RELEASES.VERSION': ['Version', 'نسخه', '版本'],
  'APP.RELEASES.UPLOAD_DATE': [
    'Release Creation Date',
    'تاریخ ایجاد رهانش',
    'Release Creation Date',
  ],
  'APP.RELEASES.STATE': ['State', 'وضعیت', '状态'],
  'APP.RELEASES.GROUP': ['GROUP', 'گروه', '版本'],
  'APP.RELEASES.PUBLISH': ['Publish', 'انتشار', '发布'],
  'APP.RELEASES.ARE_YOU_SURE': ['Are you sure?', 'آیا مطمئن هستید؟', '确定？'],
  'APP.RELEASES.STATE.NEW': ['New', 'جدید', '新'],
  'APP.RELEASES.PUBLISHED': ['Published', 'منتشرشده', '已发布'],
  'APP.RELEASES.REJECTED': ['Rejected', 'رد شده‌', '拒绝'],
  'APP.RELEASES.ACCEPTED': ['Accepted', 'تأییدشده', '认可的'],
  'APP.RELEASES.REMOVED': ['Removed', 'حذف‌‌شده', '被删除'],
  'APP.RELEASES.CHANGELOGS_FA': [
    'Changelogs in Persian',
    'تغییرات جدید (فارسی)',
    'Changelogs in Persian',
  ],
  'APP.RELEASES.CHANGELOGS_EN': [
    'Changelogs in English',
    'تغییرات جدید (انگلیسی)',
    'Changelogs in English',
  ],
  'APP.RELEASES.DESCRIPTION_FA': [
    'Persian description',
    'توضیحات فارسی',
    '波斯语描述',
  ],
  'APP.RELEASES.DESCRIPTION_EN': [
    'English description',
    'توضیحات انگلیسی',
    '英语描述',
  ],
  'APP.RELEASES.DETAIL_PACKAGE_BTN': ['Details', 'جزئیات', '细节'],
  'APP.RELEASES.DOWNLOAD_PACKAGE': ['Download', 'دانلود', 'Download'],
  'APP.RELEASES.DETAIL_MODAL_TITLE': ['APK Detail', 'جزئیات APK', 'APK细节'],
  'APP.RELEASES.DETAIL_OBB_PACKAGES': [
    'Expansion Files',
    'فایل‌های پیوست',
    'Expansion Files',
  ],
  'APP.RELEASES.APK_VERSION_CODE': ['Version Code', 'شماره‌ی نسخه', '版本号码'],
  'APP.RELEASES.APK_VERSION_NAME': ['Version Name', 'عنوان نسخه', '版本名称'],
  'APP.RELEASES.APK_VERSION_SIZE': ['Size', 'حجم', '大小'],
  'APP.RELEASES.APK_MIN_SDK_VERSION': [
    'Min SDK Version',
    'حداقل نسخه‌ی SDK',
    '最低SDK版本',
  ],
  'APP.RELEASES.APK_STATE': ['State', 'وضعیت', '状态'],
  'APP.RELEASES.APK_UPLOAD_DATE': ['Upload Date', 'تاریخ بارگذاری', '上转日期'],
  'APP.RELEASES.APK_PUBLISH_DATE': ['Publish Date', 'تاریخ انتشار', '发布日期'],
  'APP.RELEASES.EDIT': ['Edit', 'ویرایش', '编辑'],
  'APP.RELEASES.APK_FILE': ['APK File', 'فایل APK', 'APK文件'],
  'APP.RELEASES.APK_OR_AAB_FILE': [
    '"apk" or "aab" File',
    'فایل «apk» یا «aab»',
    '"apk" or "aab" File',
  ],
  'APP.RELEASES.DEVELOPER_NOTE': [
    'Additional information for app reviewer',
    'توضیحات بیشتر برای بررسی کننده',
    'Additional information for app reviewer',
  ],
  'APP.RELEASES.NO_PACKAGES': [
    'No package found.',
    'هیچ بسته‌ای پیدا نشد.',
    '未找到安装包',
  ],
  'APP.RELEASES.AUTO_PUBLISH': [
    'Auto publish the release',
    'انتشار خودکار رهانش',
    'Auto publish the release',
  ],
  'APP.RELEASES.DISABLE_AUTO_PUBLISH_TITLE': [
    'Disable Auto Publish',
    'خاموش کردن انتشار خودکار',
    'Disable Auto Publish',
  ],
  'APP.RELEASES.DISABLE_AUTO_PUBLISH_DESC': [
    'After the release is approved, the new version will not be visible to users until you manually publish it.',
    'پس از تایید شدن رهانش، نسخه‌ی جدید تا زمانی که به صورت دستی آن را منتشر نکنید برای کاربران قابل مشاهده نخواهد بود.',
    'After the release is approved, the new version will not be visible to users until you manually publish it.',
  ],
  'APP.RELEASES.DISABLE_PUBLISH_ERROR': [
    'Releases which have been accepted before 1 month ago, can not be published',
    'رهانش‌های منتشرنشده‌ای که بیش از ۱ ماه از تأیید آنها می‌گذرد، امکان انتشار ندارند',
    'Releases which have been accepted before 1 month ago, can not be published',
  ],
  'APP.RELEASES.MIN_SDK': ['Min SDK', 'حداقل SDK', '最低SDK版本'],
  'APP.RELEASES.TARGET_SDK': ['Target SDK', 'SDK هدف', '目标SDK'],
  'APP.RELEASES.CPU_ARCHITECTURE': [
    'CPU Architecture',
    'معماری پردازنده',
    'CPU体系结构',
  ],
  'APP.RELEASES.DEACTIVATE_RELEASE': [
    'Deactivate the release',
    'غیرفعال کردن رهانش',
    '停用版本',
  ],
  'APP.RELEASES.REMOVE_PACKAGE': [
    'Remove package',
    'حذف بسته',
    'Remove package',
  ],
  'APP.RELEASES.REMOVE_PACKAGE_CONFIRMATION': [
    'Are you sure to remove this package?',
    'آیا از حذف این بسته مطمئنید؟',
    'Are you sure to remove this package?',
  ],
  'APP.RELEASES.OBB': ['Expansion file', 'فایل پیوست', 'Expansion file'],
  'APP.RELEASES.OBB.SELECT_OBB': [
    'Select OBB file ...',
    'انتخاب فایل پیوست ...',
    'Select OBB file ...',
  ],
  'APP.RELEASES.OBB.NO_FILE': [
    'No expansion file',
    'بدون فایل پیوست',
    'No expansion file',
  ],
  'APP.RELEASES.ADD_OBB': [
    'Add expansion file',
    'افزودن فایل پیوست',
    'Add expansion file',
  ],
  'APP.RELEASES.EDIT_OBB': [
    'Edit expansion file',
    'ویرایش فایل پیوست',
    'Edit expansion file',
  ],
  'APP.RELEASES.MAIN_OBB': [
    'Main expansion file',
    'فایل پیوست اصلی',
    'Main expansion file',
  ],
  'APP.RELEASES.OBB.UPLOAD_NEW_FILE': [
    'Upload new file',
    'بارگذاری فایل جدید',
    'Upload new file',
  ],
  'APP.RELEASES.PATCH_OBB': [
    'Patch expansion file',
    'فایل پیوست ضمیمه',
    'Patch expansion file',
  ],
  'APP.RELEASES.MAIN_OBB.UPLOAD_DESCRIPTION': [
    'Click to select the main expansion file or drag and drop the file here',
    'برای انتخاب فایل پیوست اصلی کلیک کنید و یا آن را کشیده و اینجا رها کنید',
    'Click to select the main expansion file or drag and drop the file here',
  ],
  'APP.RELEASES.PATCH_OBB.UPLOAD_DESCRIPTION': [
    'Click to select the patch expansion file or drag and drop the file here',
    'برای انتخاب فایل پیوست ضمیمه کلیک کنید و یا آن را کشیده و اینجا رها کنید',
    'Click to select the patch expansion file or drag and drop the file here',
  ],
  'APP.RELEASES.ADD_PACKAGE': ['Add package', 'افزودن بسته', 'Add Pacakge'], // Add another package = 添加其他包
  'APP.RELEASES.ADD_APK_OR_AAB': [
    'While creating a new release, you can upload one "aab" or multiple "apk" files.',
    'شما می‌توانید هنگام ایجاد رهانش جدید، یک فایل «aab» و یا چند فایل «apk» بارگذاری کنید.',
    'While creating a new release, you can upload one "aab" or multiple "apk" files.',
  ],
  'APP.RELEASES.ADD_APK': ['Add apk file', 'افزودن فایل apk', 'Add apk file'],
  'APP.RELEASES.NEW': ['New release', 'رهانش جدید', '新版本'],
  'APP.RELEASES.UNCOMMITTED': ['New release', 'رهانش جدید', '未承诺释放'],
  'APP.RELEASES.COMMIT_WARNING': [
    'By confirming this, you won’t be able to add any new packages to this release',
    'در صورت فشردن دکمه‌ی تأیید، هیچ بسته‌ی جدیدی نمی‌تواند به این رهانش اضافه شود.',
    '确认后,您将无法向此版本添加新包,您的版本将被发送以进行评估',
  ],
  'APP.RELEASES.COMMIT': ['Publishing Request', 'درخواست انتشار', '发布请求'],
  'APP.RELEASES.CONTINUE': ['Continue', 'ادامه', 'Continue'],
  'APP.RELEASES.DEACTIVE_WARNING': [
    'By clicking this, if your release is published it will be unpublished, otherwise, it won’t be publishable in future. This action is irreversible.',
    'با غیرفعال کردن، رهانش منتشرشده از انتشار خارج می‌شود و رهانش منتشرنشده، غیر قابل انتشار می‌شود. این عمل قابل بازگشت نیست.',
    '单击此按钮,如果您的版本已发布,则它将无法发布,否则,它将无法在将来发布。这个动作是不可逆转的。',
  ],
  'APP.RELEASES.INACTIVE': ['Inactive', 'غیرفعال', '无活动'],
  'APP.RELEASES.WAITING': ['Waiting', 'در صف انتظار', '等候名单'],
  'APP.RELEASES.INCOMPLETE_ACCEPTED': [
    'Incomplete Accepted',
    'تأیید ناقص',
    '不完全接受',
  ],
  'APP.RELEASES.EDITING': ['Editung', 'در حال ویرایش', 'Editing'],
  'APP.RELEASES.PUBLISH_RELEASE': [
    'Publish release',
    'انتشار رهانش',
    '发布版本',
  ],
  'APP.RELEASES.RESEND_PUBLISH_REQUEST': [
    'Resend Publish Request',
    'درخواست انتشار مجدد',
    'Resend Publish Request',
  ],
  'APP.RELEASES.STAGED_ROLLOUT': [
    'Staged Rollout',
    'رهانش تدریجی',
    'Staged Rollout',
  ],
  'APP.RELEASES.STAGED_ROLLOUT.INSTALLS_LIMIT': [
    'The active installs count of this app is less than the minimum required to use staged roll-out feature',
    'تعداد نصب فعال شما کمتر از حداقل میزان لازم برای رهانش تدریجی می‌باشد',
    'The active installs count of this app is less than the minimum required to use staged roll-out feature',
  ],
  'APP.RELEASES.STAGED_ROLLOUT.HELP': [
    'Specify what percentage of your users can receive the new release',
    'مشخص کنید چند درصد از کاربران شما رهانش جدید را دریافت کنند',
    'Specify what percentage of your users can receive the new release',
  ],
  'APP.RELEASES.STAGED_ROLLOUT.SLIDER_TOOLTIP': [
    '{percent}% of your app users (almost {users} user)',
    '{percent}٪ از کاربران برنامه شما (حدود {users} کاربر)',
    '{percent}% of your app users (almost {users} user)',
  ],
  'APP.RELEASES.STAGED_ROLLOUT.ALL_USERS': [
    'All Users',
    'تمام کاربران',
    'All Users',
  ],
  'APP.RELEASES.STAGED_ROLLOUT.MIN_VALUE': [
    'The minimum value for staged rollout is {minValue}%',
    'حداقل مقدار برای رهانش تدریجی {minValue}٪ می‌باشد',
    'The minimum value for staged rollout is {minValue}%',
  ],
  'APP.RELEASES.STAGED_ROLLOUT.NO_DECREASE': [
    'It is not possible to reduce the registered value',
    'امکان کاهش دادن مقدار ثبت شده وجود ندارد',
    'It is not possible to reduce the registered value',
  ],
  'APP.RELEASES.STAGED_ROLLOUT.INCREASE': [
    'Increase Release Percentage',
    'افزایش درصد رهانش',
    'Increase Release Percentage',
  ],
  'APP.RELEASES.NEW_RELEASE_WARN': [
    'You have a waiting release. By creating a new release, the waiting release will be rejected. Are you sure about this?',
    'شما یک رهانش در دست بررسی دارید. با ایجاد رهانش جدید، رهانش در دست بررسی قبلی رد خواهد شد. آیا از این کار اطمینان دارید؟',
    'You have a waiting release. By creating a new release, the waiting release will be rejected. Are you sure about this?',
  ],
  'APP.RELEASES.DEACTIVATE_WAITING_RELEASE': [
    'Reject Current Waiting Release',
    'رد کردن رهانش در دست بررسی',
    'Reject Current Waiting Release',
  ],
  'APP.RELEASES.CANCELATION_WARNING': [
    'By canceling the review request, your release will be removed from the review queue and its status will be changed to rejected. If you wish, you can send a review request for this release further.',
    'با لغو درخواست بررسی، رهانش شما از صف بررسی خارج شده و وضعیت آن به رد شده تغییر می کند. در صورت تمایل می‌توانید درخواست بررسی مجدد را برای همین رهانش ارسال نمایید.',
    'By canceling the review request, your release will be removed from the review queue and its status will be changed to rejected. If you wish, you can send a review request for this release further.',
  ],
  'APP.RELEASES.BUNDLE_FILE': ['Bundle File', 'فایل باندل', 'Bundle File'],
  'APP.RELEASES.BUNDLE.IS_PROCESSING': [
    'File is processing',
    'در حال پردازش فایل',
    'File is processing',
  ],
  'APP.RELEASES.BUNDLE.UPLOAD_SIGN': [
    'Click to select the signature file or drag and drop the file here',
    'برای انتخاب فایل امضا کلیک کنید و یا آن را کشیده و اینجا رها کنید.',
    'Click to select the signature file or drag and drop the file here',
  ],
  'APP.RELEASES.BUNDLE.SIGN_DESCRIPTION': [
    'Encrypt your application’s aab file using <a class="link" target="_blank" href="https://github.com/cafebazaar/bundle-signer/releases">this tool</a> and upload the (.bin) output file.<br>You can also check <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/app_bundle/">the guide</a> for more details.',
    'فایل aab برنامه خود را با استفاده از <a class="link" target="_blank" href="https://github.com/cafebazaar/bundle-signer/releases">این ابزار</a> رمز نگاری کرده و فایل خروجی با پسوند bin را بارگذاری نمایید. <br>برای توضیحات بیشتر می‌توانید به <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/app_bundle/">راهنما</a> مراجعه کنید.',
    'Encrypt your application’s aab file using <a class="link" target="_blank" href="https://github.com/cafebazaar/bundle-signer/releases">this tool</a> and upload the (.bin) output file.<br>You can also check <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/app_bundle/">the guide</a> for more details.',
  ],
  'APP.RELEASES.BUNDLE.DOWNLOAD_AAB': [
    'Download the uploaded aab file',
    'دانلود فایل aab آپلود شده',
    'Download the uploaded aab file',
  ],
  'APP.RELEASES.PACKAGE_ERROR': [
    'Package error: {name}',
    'خطای بسته: {name}',
    'Package error: {name}',
  ],
  'APPS.SUPPORT.TITLE': ['support users', 'پشتیبانی کاربران', ''],
  'DROPPABLE_FILE_SELECTOR.HINT': [
    'Drag the desired files from your computer and drop them in this box<br> or select the files via the following button',
    'فایل‌ یا فایل‌های مورد نظر خود را از روی رایانه بکشید و اینجا رها کنید<br>و یا از طریق دکمه‌ی زیر اقدام به انتخاب فایل کنید',
    'Drag the desired files from your computer and drop them in this box<br> or select the files via the following button',
  ],
  'DROPPABLE_FILE_SELECTOR.CHOOSE_FILE': [
    'Choose Files',
    'انتخاب فایل',
    'Choose Files',
  ],
  'DROPPABLE_FILE_SELECTOR.INVALID_FILE': [
    'File {fileName} does not have the correct format',
    'فایل {fileName} دارای فرمت صحیح نمی‌باشد',
    'File {fileName} does not have the correct format',
  ],
  'DROPPABLE_FILE_SELECTOR.INVALID_FILES': [
    'Files {fileNames} do not have the correct format',
    'فایل‌های {fileNames} دارای فرمت صحیح نمی‌باشند',
    'Files {fileNames} do not have the correct format',
  ],
  'DROPPABLE_UPLOADER.ERROR_IN_FILE': [
    'Failed to upload "{fileName}"',
    'آپلود فایل "{fileName}" انجام نشد',
    'Failed to upload "{fileName}"',
  ],
  'DROPPABLE_UPLOADER.CANCEL_UPLOAD': [
    'Cancel upload process',
    'لغو فرایند بارگذاری',
    'Cancel upload process',
  ],
  'DROPPABLE_UPLOADER.UPLOADING_FILE_INDEX': [
    'Uploading file {current} of {total}',
    'درحال آپلود فایل {current} از {total}',
    'Uploading file {current} of {total}',
  ],
  'DROPPABLE_UPLOADER.SUCCESS_UPLOAD_MESSAGE': [
    'File "{name}" uploaded successfully',
    'فایل «{name}» با موفقیت باگذاری شد',
    'File "{name}" uploaded successfully',
  ],
  'APP.RELEASES.PUBLISH_RULES': [
    'Publish Rules',
    'قوانین انتشار',
    'Publish Rules',
  ],
  'APP.RELEASES.PUBLISH_RULES.CONFIRM': [
    'Understood',
    'متوجه شدم',
    'Understood',
  ],
  'APP.RELEASES.PUBLISH_RULES.DONT_SHOW_AGAIN': [
    "Don't show again",
    'دیگر به من نمایش نده',
    "Don't show again",
  ],
  'APP.TRANSACTIONS.TITLE': ['Transactions', 'تراکنش‌ها', '交易'],
  'APP.TRANSACTIONS.NO_TRANSACTIONS': [
    'No transactions found.',
    'هیچ تراکنشی پیدا نشد.',
    '未找到交易',
  ],
  'APP.TRANSACTIONS.FILTER_RESULT': ['search', 'جستجو', '探索'],
  'APP.TRANSACTIONS.PURCHASES_USER': [
    'Email/Phone',
    'ایمیل/شماره تلفن',
    '电子邮件或电话号码',
  ],
  'APP.TRANSACTIONS.PURCHASES_SKU': [
    'Product/Service',
    'محصول/خدمت',
    '产品/服务',
  ],
  'APP.TRANSACTIONS.DEVELOPER_PAYLOAD': [
    'Developer Payload',
    'داده توسعه‌دهنده',
    'Developer Payload',
  ],
  'APP.TRANSACTIONS.PURCHASES_AMOUNT': ['Amount', 'مبلغ', '金额'],
  'APP.TRANSACTIONS.PURCHASES_Time': ['Time', 'زمان', '时间'],
  'APP.TRANSACTIONS.PURCHASES_TOKEN': ['Token', 'توکن', '代币'],
  'APP.TRANSACTIONS.PURCHASES_SUBSCRIPTION_TOKEN': [
    'Subscription Token',
    'توکن اشتراک',
    '订阅代币',
  ],
  'APP.TRANSACTIONS.PURCHASES_RENEWAL_TOKEN': [
    'Subscription Renewal Token',
    'توکن تمدید اشتراک',
    '订阅更新代币',
  ],
  'APP.TRANSACTIONS.PURCHASES': ['Purchases', 'خریدها', '购买'],
  'APP.TRANSACTIONS.PURCHASES.REFUNDS': ['Refunds', 'استرداد', 'Refunds'],
  'APP.TRANSACTIONS.PURCHASES.REFUNDS.DATE': [
    'Refunded in {date}',
    'استرداد شده در تاریخ {date}',
    'Refunded in {date}',
  ],
  'APP.TRANSACTIONS.SUB-PURCHASES': ['Subscriptions', 'اشتراک‌ها', '订阅'],
  'APP.TRANSACTIONS.API_ERROR': [
    'Error fetching transactions',
    'خطا در دریافت تراکنش ها',
    'Error fetching transactions',
  ],
  'APP.TRANSACTIONS.MONTHLY_CSV_EXPORT': [
    'Monthly CSV Export',
    'خروجی csv ماهانه',
    'Monthly CSV Export',
  ],
  'APP.TRANSACTIONS.SELECT_MONTH_TO_EXPORT': [
    'Select the desired month for export',
    'ماه مورد نظر برای دریافت خروجی را مشخص کنید',
    'Select the desired month for export',
  ],
  'APP.TRANSACTIONS.TRANSACTION_TYPE': [
    'Transactions Type',
    'نوع تراکنش‌ها',
    'Transactions Type',
  ],
  'APP.TRANSACTIONS.PURCHASES_TRANSACTIONS': [
    'Purchases Transactions',
    'تراکنش‌های خرید',
    'Purchases Transactions',
  ],
  'APP.TRANSACTIONS.REFUND': ['Refund', 'ریفاند', 'Refund'],
  'APP.TRANSACTIONS.SEND_TO_EMAIL': [
    'Send to Email',
    'ارسال به ایمیل',
    'Send to Email',
  ],
  'APP.TRANSACTIONS.EMAIL_SENT_SUCCESSFULLY': [
    'Your requested report will be emailed within the next half hour.',
    'گزارش درخواستی شما، طی نیم‌ساعت آینده ایمیل خواهد شد.',
    'Your requested report will be emailed within the next half hour.',
  ],
  'APP.IAB.TITLE': ['In-app Purchases', 'پرداخت درون‌برنامه‌ای', '应用内计费'],
  'APP.IAB.DESC': [
    'In-app purchases enables purchasing digital content inside the app. With this feature, you can sell content such as music, video, images, PDF files, consumable products such as coins or gems, and non-consumable products such as version update. For more information, read <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/docs/iab/">this document</a>.',
    'پرداخت درون‌برنامه‌ای، فروش محتوای دیجیتال را درون برنامه ممکن می‌سازد. از این سرویس می‌توانید برای فروش محتوا مانند موسیقی،‌ ویدئو، تصاویر و فایل‌های PDF و محصولات مصرفی مانند سکه یا جم و محتوای غیرمصرفی مانند ارتقا‌ء نسخه استفاده کنید. برای توضیحات بیشتر، به <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/docs/iab/">صفحه پرداخت درون‌برنامه‌ای</a> مراجعه کنید.',
    'In-app purchases enables purchasing digital content inside the app. With this feature, you can sell content such as music, video, images, PDF files, consumable products such as coins or gems, and non-consumable products such as version update. For more information, read <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/docs/iab/">this document</a>.',
  ],
  'APP.IAB.RSA_TITLE': ['RSA Key', 'کلید RSA', 'RSA密钥'],
  'APP.IAB.RSA_DESC': [
    'Base64-encoded key, include it in your source code according to the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/in-app-billing/implementation/kotlin">documentation</a>.',
    'کلید رمزشده به طریق Base64. آن را طبق <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/implementation/kotlin">مستندات</a> در متن برنامه‌تان قرار دهید.',
    'Base64编码的密钥,根据 <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/in-app-billing/implementation/kotlin">文档</a> 将其包含在源代码中。',
  ],
  'APP.IAB.DYNAMIC_PRICE_KEY_TITLE': [
    'Dynamic Discount JWT Key',
    'کلید JWT تخفیف پویا',
    'Dynamic Discount JWT Key',
  ],
  'APP.IAB.RENEW_DYNAMIC_PRICE_KEY_BTN': [
    'Revoke Key',
    'بازنشانی کلید',
    'Revoke Key',
  ],
  'APP.IAB.DYNAMIC_PRICE_DESC': [
    'You can use this feature in order to specify a dynamic price for a product, on the fly. For more information please refer to the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/dynamic-discount/">documentation</a>',
    'با استفاده از این کلید و مطابق با <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/dynamic-discount/">مستندات</a>، می‌توانید قیمت یک شناسه محصول را در فرآیند پرداخت تغییر دهید.',
    'You can use this feature in order to specify a dynamic price for a product, on the fly. For more information please refer to the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/in-app-billing/dynamic-discount/">文档</a>',
  ],
  'APP.IAB.PRODUCTS_TITLE': ['Products', 'محصولات', '产品'],
  'APP.IAB.PRODUCTS_DESC': ['', '', ''],
  'APP.IAB.PRODUCT_SKU': ['SKU', 'شناسه‌ی کالا', 'SKU'],
  'APP.IAB.PRODUCT_TITLE': ['Title', 'عنوان', '名称'],
  'APP.IAB.PRODUCT_TITLE_FA': [
    'Title (Persian)',
    'عنوان (فارسی)',
    '名称（波斯语）',
  ],
  'APP.IAB.PRODUCT_TITLE_EN': [
    'Title (English)',
    'عنوان (انگلیسی)',
    '名称（英语）',
  ],
  'APP.IAB.PRODUCT_DESC_FA': [
    'Description (Persian)',
    'توضیح (فارسی)',
    '描述（波斯语）',
  ],
  'APP.IAB.PRODUCT_DESC_EN': [
    'Description (English)',
    'توضیح (انگلیسی)',
    '描述（英语）',
  ],
  'APP.IAB.PRODUCT_PRICE': ['Price', 'قیمت', '价格'],
  'APP.IAB.PRODUCT_KIND': ['Kind', 'نوع', '种类'],
  'APP.IAB.PRODUCT_STATE': ['State', 'وضعیت', '状态'],
  'APP.IAB.NEW_PRODUCT_BTN': ['New Product', 'محصول جدید', '新产品'],
  'APP.IAB.EDIT_PRODUCT_BTN': ['Edit', 'ویرایش', '编辑'],
  'APP.IAB.APPLY_PRODUCT_BTN': ['Apply Changes', 'اعمال تغییرات', '应用更改'],
  'APP.IAB.ADD_PRODUCT_BTN': ['Add Product', 'افزودن محصول', '添加产品'],
  'APP.IAB.NO_PRODUCTS': [
    'No products found.',
    'هیچ محصولی پیدا نشد.',
    '未找到产品',
  ],
  'APP.IAB.API_ERROR': [
    'Error fetching products list',
    'خطا در دریافت لیست محصولات',
    '获取产品列表时出错',
  ],
  'APP.IAB.PURCHASABLE': ['OneTime Purchase', 'یک‌بار خرید', '可购买'],
  'APP.IAB.SUBSCRIPTION_PROMOTE.TITLE': [
    'Subscripition',
    'اشتراک مدت‌دار',
    'Subscripition',
  ],
  'APP.IAB.SUBSCRIPTION_PROMOTE.DESCRIPTION': [
    'You have not defined any shared product yet. Take advantage of its special benefits by using the subscription service.',
    'شما تاکنون هیچ محصول اشتراکی تعریف نکرده‌اید. با استفاده از سرویس اشتراک، از مزایای ویژه آن بهره‌مند شوید.',
    'You have not defined any shared product yet. Take advantage of its special benefits by using the subscription service.',
  ],
  'APP.IAB.SUBSCRIPTION_PROMOTE.CREATE_BTN': [
    'Create your first subscription',
    'ساخت اولین اشتراک مدت‌دار',
    'Create your first subscription',
  ],
  'APP.IAB.SUBSCRIPTION_PROMOTE.MORE_INFO': [
    'More info',
    'مشاهده اطلاعات بیشتر',
    'More info',
  ],
  'APP.IAB.5_MINUTES_SUBSCRIBE': [
    '5 Minutes Subscription (For Developer Test)',
    'اشتراک ۵ دقیقه‌ای (برای تست توسعه‌دهنده)',
    '5 Minutes Subscription (For Developer Test)',
  ],
  'APP.IAB.1_DAY_SUBSCRIBE': [
    '1 Day Subscription',
    'اشتراکی | یک روزه',
    '1 Day Subscription',
  ],
  'APP.IAB.7_DAY_SUBSCRIBE': [
    '7 Days Subscription',
    'اشتراکی | هفت روزه',
    '7 Days Subscription',
  ],
  'APP.IAB.30_DAYS_SUBSCRIBE': [
    '30 Days Subscription',
    'اشتراکی | ۳۰ روزه',
    '30 Days Subscription',
  ],
  'APP.IAB.60_DAYS_SUBSCRIBE': [
    '60 Days Subscription',
    'اشتراکی‌ | ۶۰ روزه',
    '60 Days Subscription',
  ],
  'APP.IAB.90_DAYS_SUBSCRIBE': [
    '90 Days Subscription',
    'اشتراکی | ۹۰ روزه',
    '90 Days Subscription',
  ],
  'APP.IAB.180_DAYS_SUBSCRIBE': [
    '180 Days Subscription',
    'اشتراکی | ۱۸۰ روزه',
    '180 Days Subscription',
  ],
  'APP.IAB.365_DAYS_SUBSCRIBE': [
    '365 Days Subscription',
    'اشتراکی | ۳۶۵ روزه',
    '365 Days Subscription',
  ],
  'APP.IAB.PRODUCT_TYPES.ONLY_ACTIVES': [
    'Only Show Actives',
    'فقط محصولات فعال',
    'Only Show Actives',
  ],
  'APP.IAB.PRODUCT_TYPES.SUBSCRIPTION': [
    'Subscription',
    'اشتراکی',
    'Subscription',
  ],
  'APP.IAB.PRODUCT_TYPE': ['Product Type', 'نوع محصول', 'Product Type'],
  'APP.IAB.ADD_PRODUCT': ['New Product', 'محصول جدید', '新产品'],
  'APP.IAB.EDIT_PRODUCT': ['Edit Product', 'ویرایش محصول', '编辑产品'],
  'APP.IAB.SUBSCRIPTION_TYPE': [
    'Subsciption type',
    'نوع اشتراک',
    'Subscription type',
  ],
  'APP.IAB.TRIAL_SUBSCRIPTION_TITLE': [
    'Trial Subscription',
    'اشتراک آزمایشی (Trial)',
    'Trial Subscription',
  ],
  'APP.IAB.TRIAL_SUBSCRIPTION_DESCRIPTION': [
    'By activating this option, the user is given the opportunity to use all the monetary features for a specified period of time, which you have specified, at no cost and only to test and evaluate your product. Refer to the {link} to learn more about the trial subscription',
    'با فعال بودن این گزینه این امکان به کاربر داده می‌شود تا به مدت معلومی که توسط خود شما مشخص شده است از تمامی امکانات پولی بدون پرداخت هیچ هزینه‌ای و تنها برای تست و ارزیابی محصول شما استفاده کند. برای آشنایی با نحوه استفاده از اشتراک آزمایشی به {link} مربوطه مراجعه کنید.',
    'By activating this option, the user is given the opportunity to use all the monetary features for a specified period of time, which you have specified, at no cost and only to test and evaluate your product. Refer to the {link} to learn more about the trial subscription',
  ],
  'APP.IAB.ACTIVATE_TRIAL_SUBSCRIPTION': [
    'Activate trial subscription',
    'فعال‌سازی اشتراک آزمایشی (Trial)',
    'Activate trial subscription',
  ],
  'APP.REVIEWS.TITLE': ['Reviews', 'نظرات', '评论'],
  'APP.REVIEWS.STATUS': ['Status', 'وضعیت', 'Status'],
  'APP.REVIEWS.STATUS.INVALID': ['Invalid', 'نامعتبر', 'Invalid'],
  'APP.REVIEWS.STATUS.PUBLISHED': ['Published', 'منتشر شده', 'Published'],
  'APP.REVIEWS.STATUS.PENDING': ['Pending...', 'در دست بررسی...', 'Pending...'],
  'APP.REVIEWS.REPLY_STATUS': ['Reply Status', 'وضعیت پاسخ', 'Reply Status'],
  'APP.REVIEWS.REPLY_STATUS.PUBLISHED': ['Published', 'منتشر شده', 'Published'],
  'APP.REVIEWS.REPLY_STATUS.PENDING': ['Pending', 'در دست بررسی', 'Pending'],
  'APP.REVIEWS.REPLY_STATUS.REJECTED': ['Rejected', 'نامعتبر', 'Rejected'],
  'APP.REVIEWS.REPLY_STATUS.REMOVED': ['Removed', 'حذف شده', 'Removed'],
  'APP.REVIEWS.FILTERS': ['Filters', 'فیلتر‌ها', '过滤'],
  'APP.REVIEWS.REVIEW_FILTER': ['Reviews filter', 'فیلتر نظرات', '评论过滤'],
  'APP.REVIEWS.FILTER_BY_REPLY': [
    'Filter by reply',
    'فیلتر براساس پاسخ',
    'Filter by reply',
  ],
  'APP.REVIEWS.FILTERS.ALL': ['All', 'همه', '全部'],
  'APP.REVIEWS.FILTERS.WITH_REPLY': ['With reply', 'دارای پاسخ', 'With reply'],
  'APP.REVIEWS.FILTERS.WITHOUT_REPLY': [
    'Without reply',
    'بدون پاسخ',
    'Without reply',
  ],
  'APP.REVIEWS.FILTERS.DATE_RANGE': [
    'Date Range',
    'بازه‌ی زمانی',
    'Date Range',
  ],
  'APP.REVIEWS.FILTERS.CUSTOM_RANGE': [
    'Custom Range',
    'بازه‌ی دلخواه',
    'Custom Range',
  ],
  'APP.REVIEWS.FILTERS.IS_REPLIED': [
    'Comments with replied',
    'فقط نظرات دارای پاسخ',
    'Comments with replied',
  ],
  'APP.REVIEWS.FILTERS.IS_NOT_REPLIED': [
    'Comments witout reply',
    'فقط نظرات بدون پاسخ',
    'Comments witout reply',
  ],
  'APP.REVIEWS.FILTERS.APP_VERSION': [
    'Application version',
    'نسخه‌ی برنامه',
    '应用版本',
  ],
  'APP.REVIEWS.FILTERS.SDK_VERSION': [
    'Android version (API level)',
    'نسخه‌ی اندروید (نسخه‌ی ‌API)',
    '安卓版本（API级别）',
  ],
  'APP.REVIEWS.FILTERS.ANDROID_VERSION': [
    'Android version',
    'نسخه‌ی اندروید',
    '安卓版本',
  ],
  'APP.REVIEWS.FILTERS.RATING': ['Rating', 'امتیاز', '评级'],
  'APP.REVIEWS.FILTERS.RATE_RATE': ['Rate range', 'بازه‌ی امتیاز', '评级范围'],
  'APP.REVIEWS.REVIEWS_TITLE': ['Reviews', 'نظر', '评论'],
  'APP.REVIEWS.NO_REVIEWS_TITLE': ['No Reviews', 'بدون نظر', '没有评论'],
  'APP.REVIEWS.NO_REVIEWS': [
    'No reviews found.',
    'هیچ نظری برای این برنامه ارسال نشده است.',
    '未找到评论',
  ],
  'APP.REVIEWS.API_ERROR': [
    'Error fetching reviews',
    'خطا در دریافت لیست نظرات',
    '获取评论时出错',
  ],
  'APP.RATING_SUMMARY.API_ERROR': [
    'Error fetching rating summary',
    'خطا در دریافت آمار امتیازات',
    'Error fetching rating summary',
  ],
  'APP.REVIEWS.NO_REVIEWS_WITH_APPLIED_FILTER': [
    'No reviews found with applied filters.',
    'هیچ نظری با فیلترهای اعمال‌شده یافت نشد.',
    '未找到应用筛选器的评论',
  ],
  'APP.REVIEWS.NEW': ['New', 'جدید', '新'],
  'APP.REVIEWS.REMOVED': ['Removed', 'حذف‌شده', '远离的'],
  'APP.REVIEWS.AUTO_REMOVED': [
    'Automatically Removed',
    'حذف‌شده خودکار',
    '自动远离的',
  ],
  'APP.REVIEWS.PUBLISHED': ['Published', 'منتشرشده', '发布的'],
  'APP.REVIEWS.AUTO_PUBLISHED': [
    'Automatically Published',
    'منتشرشده خودکار',
    '自动发布的',
  ],
  'APP.REVIEWS.REPORT': ['Report', 'گزارش تخلف', '报告'],
  'APP.REVIEWS.CANCEL_REPORT': ['Cancel Report', 'لغو گزارش تخلف', '取消报告'],
  'APP.REVIEWS.REPORT_BOX_TITLE': [
    'Report Comment',
    'گزارش تخلف در نظر',
    '报告评论',
  ],
  'APP.REVIEWS.REPORT_BOX_ALERT': [
    'Consider that comments against your app are not necessarily inappropriate.',
    'توجه فرمایید، نظرات مخالف برنامه لزوماً نظرات نامناسب یا نامربوط نیستند.',
    '请注意,对你的应用的评论并不一定不合适。',
  ],
  'APP.REVIEWS.API_LEVEL': ['API Level', 'سطح API', 'API级别'],
  'APP.REVIEWS.APP_VERSION': ['App Version', 'نسخه‌ی برنامه', '应用版本'],
  'APP.REVIEWS.REPLY_DESC': [
    'Note that your reply will be sent to the user and also be available in the app reviews list.',
    'توجه: پاسخ شما برای کاربر ارسال خواهد شد و برای عموم کاربران نیز قابل مشاهده است.',
    '请注意,您的回复将发送给用户,并在应用程序评论列表中提供。',
  ],
  'APP.REVIEWS.REPLY_BY': ['Reply by', 'پاسخ توسط', '答复者'],
  'APP.REVIEWS.REPLY': ['Reply', 'پاسخ', '答复'],
  'APP.SALES_REPORT.TITLE': ['Sales Report', 'گزارش فروش', 'Sales Report'],
  'APP.SALES_REPORT.DESCRIPTION': [
    'You can download the Excel file, containing sales information of this app within the selected time interval. The maximum selected time range is 3 months.',
    'شما می‌توانید از این قسمت فایل اکسل حاوی اطلاعات فروش این برنامه ‌را در بازه‌ی زمانی دلخواه دریافت کنید. بازه‌ی انتخابی می‌تواند حداکثر سه ماه باشد.',
    'You can download the Excel file, containing sales information of this app within the selected time interval. The maximum selected time range is 3 months.',
  ],
  'APP.API_AGENTS.TITLE': ['Pishkhan API', 'API پیشخان', 'Pishkhan API'],
  'APP.API_AGENTS.DELETE': [
    'Are you sure to delete this token?',
    'آیا از حذف این توکن اطمینان دارید؟',
    'Are you sure to delete this token?',
  ],
  'APP.API_AGENTS.GUIDE_MESSAGE': [
    'With this API, you can manage your app releases without visiting Bazaar developers Panel. Use this token based on the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/feature/pishkhan-api">documentation</a>.',
    'با استفاده از این API‌ می‌توانید رهانش‌های برنامه خود را بدون مراجعه به پیشخان بازار مدیریت نمایید. از این توکن مطابق <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/feature/pishkhan-api">مستندات</a> استفاده کنید.',
    'With this API, you can manage your app releases without visiting Bazaar developers Panel. Use this token based on the <a class="link" target="_blank" href="https://developers.cafebazaar.ir/en/guidelines/feature/pishkhan-api">documentation</a>.',
  ],
  'APP.API_AGENTS.TOKEN': ['Token', 'Token', 'Token'],
  'APP.API_AGENTS.ARE_YOU_SURE_TO_REGENERATE': [
    'Are you sure you want to regenerate the token?',
    'آیا از دریافت توکن جدید اطمینان دارید؟',
    'Are you sure you want to regenerate the token?',
  ],
  'APP.API_AGENTS.REGENERATE_TOKEN': [
    'Regenerate token',
    'دریافت توکن جدید',
    'Regenerate token',
  ],
  'APP.API_AGENTS.ADD_NEW_TOKEN': [
    'Create new token',
    'ایجاد توکن جدید',
    'Create new token',
  ],
  'APP.OAUTH.TITLE': [
    'Login with Bazaar',
    'ورود با بازار',
    'Login with Bazaar',
  ],
  'APP.OAUTH.SHOW_SECRET': ['Show', 'نمایش', 'Show'],
  'APP.OAUTH.CLIENT_ID': ['ClientID', 'ClientID', 'ClientID'],
  'APP.OAUTH.SECRET': ['Secret', 'Secret', 'Secret'],
  'APP.OAUTH.GUIDE_MESSAGE': [
    'Login with Bazaar helps you access users’ information without sending email or SMS to authenticate users.',
    'با قابلیت ورود با بازار، بدون نیاز به پیاده‌سازی فرآیند ورود کاربران و ارسال ایمیل یا پیامک، همیشه به کاربر خود دسترسی خواهید داشت. برای راهنمایی بیشتر <a class="link" target="_blank" href="https://developers.cafebazaar.ir/fa/guidelines/feature/bazaar-login">ورود با بازار</a> را بخوانید.',
    'Login with Bazaar helps you access users’ information without sending email or SMS to authenticate users.',
  ],
  'APP.OAUTH.REDIRECT_URLS.SINGLE_REDIRECT_URL': [
    'Redirect URL',
    'Redirect URL',
    'Redirect URL',
  ],
  'APP.OAUTH.REDIRECT_URLS.NEW_REDIRECT_URL': [
    'Add Redirect URL',
    'افزودن Redirect URL',
    'Add Redirect URL',
  ],
  'APP.OAUTH.REDIRECT_URLS.REDIRECT_URL_CREATED': [
    'New Redirect URL was successfuly created.',
    'Redirect URL جدید با موفقیت ایجاد شد.',
    'New Redirect URL was successfuly created.',
  ],
  'APP.STATS_BUILDER.ERROR': [
    'Error in retrieving chart data',
    'خطا در دریافت اطلاعات نمودار',
    '检索图表数据时出错',
  ],
  'APP.STATS_BUILDER.RANGE': ['Range', 'بازه', '范围'],
  'APP.STATS_BUILDER.SAME_SCALE': [
    'Show charts in same scale',
    'نمایش نمودارها در مقیاس برابر',
    'Show charts in same scale',
  ],
  'APP.STATS_BUILDER.SAME_SCALE.DISABLE_REASON_TOOLTIP': [
    'Same-scale option is only enabled when at least two charts exist',
    'قابلیت برابرسازی مقیاس برای حداقل دو نمودار یا بیشتر فعال میشود',
    'Same-scale option is only enabled when at least two charts exist',
  ],
  'APP.STATS_BUILDER.CHART_TYPE': ['Chart type', 'نوع نمودار', '图表类型'],
  'APP.STATS_BUILDER.ADD_CHART': ['Add chart', 'افزودن نمودار', '添加图表'],
  'APP.STATS_BUILDER.TITLE': ['Stats Builder', 'آمار', '统计生成器'],
  'APP.STATS_BUILDER.NEW_INSTALLS': ['New installs', 'نصب جدید', '新安装'],
  'APP.STATS_BUILDER.NEW_INSTALLS.DESCRIPTION': [
    'Number of daily installs from Bazaar.',
    'تعداد نصب روزانه‌ی جدید از بازار.',
    '在巴扎商店的新每日安装数',
  ],
  'APP.STATS_BUILDER.ACTIVE_INSTALLS': [
    'Active installs',
    'نصب فعال',
    '活跃安装',
  ],
  'APP.STATS_BUILDER.ACTIVE_INSTALLS.DESCRIPTION': [
    'Number of detected installs on devices which have Bazaar and connected to the internet.',
    'تعداد نصب برنامه بر روی دستگاه‌های متصل به اینترنت که «بازار» را نصب دارند.',
    'Number of detected installs on devices which have Bazaar and connected to the internet.',
  ],
  'APP.STATS_BUILDER.VISIT': ['Visit', 'بازدید', '访问'],
  'APP.STATS_BUILDER.VISIT.DESCRIPTION': [
    'Number of app details page visits based on reffered page.',
    'بازدید روزانه از صفحه‌ی جزئيات برنامه براساس درگاه ورودی.',
    '基于引用页的应用程序详细信息页访问次数。',
  ],
  'APP.STATS_BUILDER.RATING_AVERAGE': [
    'Rating average',
    'میانگین امتیاز',
    '平均评级',
  ],
  'APP.STATS_BUILDER.RATING_AVERAGE.DESCRIPTION': [
    'Average of scores, before deleting inappropriate and fake comments.',
    'میانگین امتیاز دریافتی از کاربران بر اساس تمامی نظرات ثبت شده‌ی کاربران.',
    '删除不适当和虚假评论前的平均得分',
  ],
  'APP.STATS_BUILDER.RATING_COUNT': ['Rating number', 'تعداد امتیاز', '评级数'],
  'APP.STATS_BUILDER.RATING_COUNT.DESCRIPTION': [
    'Number of scores, before deleting inappropriate and fake comments.',
    'تعداد و نوع امتیازی که کاربران داده‌اند، بر اساس تمامی نظرات ثبت شده‌ی کاربران.',
    '删除不适当和虚假评论之前的评级数量。',
  ],
  'APP.STATS_BUILDER.PURCHASES': ['Purchases', 'فروش', '出售'],
  'APP.STATS_BUILDER.PURCHASE_AMOUNT': [
    'Sales in Rial',
    'فروش ریالی',
    '里亚尔销售额',
  ],
  'APP.STATS_BUILDER.PURCHASE_AMOUNT.DESCRIPTION': [
    'In-app purchases in Rial',
    'فروش روزانه‌ برنامه یا محصول درون‌برنامه‌ای به ریال',
    '里亚尔的应用内购买',
  ],
  'APP.STATS_BUILDER.PURCHASE_COUNT': [
    'Sales number',
    'فروش تعدادی',
    '出售次数',
  ],
  'APP.STATS_BUILDER.PURCHASES_PURCHASE_COUNT.DESCRIPTION': [
    'Quantity of sold apps or SKUs.',
    'تعداد فروش برنامه یا محصول درون‌برنامه‌ای.‌',
    '已售出应用程序或SKU的数量。',
  ],
  'APP.STATS_BUILDER.INSTALLS': ['Installs', 'نصب', '安装'],
  'APP.STATS_BUILDER.RATING': ['Ratings', 'امتیازات', '评级'],
  'APP.STATS_BUILDER.APP_VERSION': [
    'App version',
    'نسخه‌ی برنامه',
    '应用程序的版本',
  ],
  'APP.STATS_BUILDER.SDK_VERSION': ['SDK version', 'نسخه‌ی SDK', 'SDK的版本'],
  'APP.STATS_BUILDER.PROVINCE': ['Province', 'منطقه', '省'],
  'APP.STATS_BUILDER.DEVICE_PRODUCT_ID': [
    'Device product id',
    'مدل دستگاه',
    '设备产品ID',
  ],
  'APP.STATS_BUILDER.UPDATES': ['Update', 'بروزرسانی', '更新'],
  'APP.STATS_BUILDER.UPDATES.DESCRIPTION': [
    'Number of installed updates on devices which have Bazaar and connected to the internet.',
    'تعداد آپدیت‌های روزانه‌ی نصب‌شده روی دستگاه‌های متصل به اینترنت که «بازار» را نصب دارند.',
    '在有巴扎商店并连接到网络的设备上安装的更新数。',
  ],
  'APP.STATS_BUILDER.DOWNLOADS': ['Download', 'دانلود', '下载'],
  'APP.STATS_BUILDER.DOWNLOADS.DESCRIPTION': [
    'Number of successful complete downloads.',
    'تعداد دانلودهای موفقیت‌آمیز از بازار.',
    '成功完成下载的次数',
  ],
  'APP.STATS_BUILDER.REMOVES': ['Remove', 'حذف', '删除'],
  'APP.STATS_BUILDER.REMOVES.DESCRIPTION': [
    'Number of daily uninstalls on devices which have Bazaar and connected to the internet.',
    'تعداد حذف روزانه روی دستگاه‌های متصل به اینترنت که «بازار» را نصب دارند.',
    '在具有巴扎商店并连接到网络的设备上每日卸载的次数。',
  ],
  'APP.STATS_BUILDER.SKU': ['SKU', 'SKU', 'SKU'],
  'APP.STATS_BUILDER.SINGLE_HELPER_TEXT': [
    '{primary_name} chart',
    'نمودار {primary_name}',
    '{primary_name} 图表',
  ],
  'APP.STATS_BUILDER.DOUBLE_HELPER_TEXT': [
    '{primary_name} and {secondary_name} chart',
    'نمودار {primary_name} و {secondary_name}',
    '{primary_name} 和 {secondary_name} 图表',
  ],
  'APP.STATS_BUILDER.SINGLE_WITH_TAG_HELPER_TEXT': [
    '{primary_name} based on {tag_name}',
    'نمودار {primary_name} براساس {tag_name}',
    '{primary_name}基于{tag_name}',
  ],
  'APP.STATS_BUILDER.VISIT_DESCRIPTION': [
    'Number of app details page visits based on reffered page',
    'بازدید روزانه از صفحه‌ی جزئيات برنامه براساس درگاه ورودی ',
    '基于引用页面的应用程序详细信息页面访问次数',
  ],
  'APP.STATS.TITLE': ['Stats', 'آمار', '统计'],
  'APP.STATS.FILTERS.RANGE.TITLE': ['Range', 'بازه', '范围'],
  'APP.STATS.FILTERS.RANGE.LAST_TWO_DAYS': [
    'Last two days',
    'دو روز گذشته',
    'Last two days',
  ],
  'APP.STATS.FILTERS.RANGE.LAST_WEEK': ['Last week', 'هفته گذشته', '上星期'],
  'APP.STATS.FILTERS.RANGE.LAST_MONTH': ['Last month', 'ماه گذشته', '上月'],
  'APP.STATS.FILTERS.RANGE.LAST_TWO_MONTHS': [
    'Last two months',
    'دو ماه اخیر',
    '最近两个月',
  ],
  'APP.STATS.FILTERS.RANGE.LAST_THREE_MONTHS': [
    'Last three months',
    'سه ماه گذشته',
    '过去三个月',
  ],
  'APP.STATS.FILTERS.RANGE.LAST_SIX_MONTHS': [
    'Last six months',
    'شش ماه اخیر',
    '过去六个月',
  ],
  'APP.STATS.FILTERS.RANGE.LAST_YEAR': ['Last year', 'سال اخیر', '去年'],
  'APP.STATS.FILTERS.TAG.TITLE': ['Tag', 'تگ', '标签'],
  'APP.STATS.FILTERS.TAG.PROVINCE': ['Province', 'منطقه', '省'],
  'APP.STATS.FILTERS.TYPE.TITLE': ['Type', 'برحسب', '类型'],
  'APP.STATS.FILTERS.TYPE.AMOUNT': ['Sum', 'مبلغ فروش', '销售金额'],
  'APP.STATS.FILTERS.TYPE.COUNT': ['Count', 'تعداد فروش', '计数'],
  'APP.STATS.VISITS.TITLE': ['App Visits', 'بازدید برنامه', '应用程序访问'],
  'APP.STATS.VISITS.REFERRERS': ['Referrers', 'ارجاع‌دهندگان', '推荐人'],
  'APP.STATS.VISITS.COUNT': ['Visits count', 'تعداد بازدید', '访问数'],
  'APP.STATS.REVIEWS.TITLE': ['Stats Reviews', 'نظرات', '统计评论'],
  'APP.STATS.REVIEWS.COUNT': ['Reviews count', 'تعداد نظرات', '评论数'],
  'APP.STATS.REVIEWS.RATE': ['Rate', 'امتیاز', '评级'],
  'APP.STATS.REVIEWS.TOTAL_RATING': [
    'Total Rating',
    'امتیاز کل',
    'Total Rating',
  ],
  'APP.STATS.RETRY': ['Retry', 'تلاش مجدد', '重试'],
  'APP.STATS.INSTALLS.COUNT': ['Installs count', 'تعداد نصب', '安装数'],
  'APP.STATS.GET_CHART_ERROR': [
    "Can't get chart",
    'خطا در گرفتن نمودار',
    '无法获取图表',
  ],
  'APP.STATS.GET_TABLE_ERROR': [
    "Can't get table",
    'خطا در گرفتن جدول',
    '无法获取表格',
  ],
  'APP.STATS.EXPORT_CSV': ['Export as CSV', 'خروجی CSV', '导出为CSV'],
  'APP.STATS.FIRST_CHART': ['First chart', 'نمودار اول', '第一图表'],
  'APP.STATS.SECOND_CHART': ['Second chart', 'نمودار دوم', '第二图表'],
  'APP.STATS.FINANCE_CHART.WARNING': [
    'This is an approximate stats, the basis for financial calculations is the information provided in the {invoice}.',
    'این آمار تقریبی است. مبنای محاسبات مالی، اطلاعات ارائه شده در {invoice} می‌باشد.',
    '这是一个近似统计,财务计算的基础是{invoice}中提供的信息。',
  ],
  'APP.STATS.ANNOUNCEMENT_BUTTON': [
    'What’s new?',
    'تغییرات جدید',
    'What’s new?',
  ],
  'APP.STATS.ANNOUNCEMENT_SUBMIT': ['Got it', 'متوجه شدم', 'Got it'],
  'APP.STATS.ANNOUNCEMENT_TITLE.NEW_INSTALL': [
    'Why has the new installation decreased?',
    'چرا نصب جدید کم شده است؟',
    'Why has the new installation decreased?',
  ],
  'APP.STATS.ANNOUNCEMENT.NEW_INSTALL': [
    '<p>The count of the new installation has become more detailed and currently this number by definition is:</p>' +
      '<p>The number of installs your app has received from Bazaar Application.</p>',
    '<p>نحوه‌ی شمارش نصب جدید دقیق شده‌است و در حال حاضر، این آمار، مطابق تعریف،برابر است با:</p>' +
      '<p>«تعداد نصب‌هایی که برنامه‌ی شما در بازار گرفته‌است.»</p>',
    '<p>The count of the new installation has become more detailed and currently this number by definition is:</p>' +
      '<p>The number of installs your app has received from Bazaar Application.</p>',
  ],
  'APP.FESTIVAL.TITLE': [
    'Iran Web and Mobile Festival',
    'جشنواره وب و موبایل',
    '伊朗网络与移动节',
  ],
  'APP.FESTIVAL.REGISTER': [
    'Sign up for Iran Web and Mobile Festival',
    'ثبت‌نام جشنواره وب و موبایل',
    '报名参加伊朗网络与手机节',
  ],
  'APP.FESTIVAL.CATEGORY': ['Category', 'دسته‌بندی', '类别'],
  'APP.FESTIVAL.EMAIL': ['Email', 'ایمیل', '电子邮件'],
  'APP.FESTIVAL.REGISTER_BTN': ['Register', 'ثبت‌نام', '报名'],
  'APP.FESTIVAL.REGISTER_DESC': [
    "Note: by pressing the registration button, The app's information including name, description, icon and screenshots will be posted on the festival website.",
    'توجه: با فشردن دکمه ثبت نام اطلاعات این برنامه شامل نام، توضیحات، آیکون و اسکرین‌شات به وب‌سایت جشنواره ارسال خواهد شد.',
    '注意：按注册按钮,应用程序的信息,包括名称、描述、图标和截图将发布在节日网站上。',
  ],
  'APP.FESTIVAL.DESC': [
    'You can view additional information at iwmf.ir',
    'برای شرکت در چهاردهمین دوره جشنواره وب و موبایل ایران تا ۲۱ اسفند ۱۴۰۰ فرصت دارید تا از این صفحه، برنامه‌ی خود را وارد جشنواره کنید. اطلاعات تکمیلی را در سایت iwmf.ir می‌توانید مشاهده کنید.',
    '您可以在iwmf.ir上查看其他信息。',
  ],
  'APP.FESTIVAL.WEBSITE': ['Website', 'وب‌سایت', 'Website'],
  'APP.FESTIVAL.DESCRIPTION': ['Description', 'توضیحات', 'Description'],
  'APP.FESTIVAL.EMAIL_DESCRIPTION': [
    '',
    'در صورتی که قبلا اکانتی برای جشنواره ثبت کرده‌اید، لطفا آدرس ایمیل آن را اینجا وارد کنید. در غیر این صورت، اکانت جدیدی برای شما ساخته خواهد شد.',
    '',
  ],
  'APP.FESTIVAL.WEBSITE_DESCRIPTION': [
    '',
    'در صورتی که قبلا برای ایمیل ذکرشده در بالا، وب‌سایتی ثبت کرده‌اید، اینجا وارد کنید. در غیر این صورت می‌توانید ابتدا در وب‌سایت جشنواره، آدرس وب‌سایت خود را ثبت نمایید یا این فیلد را خالی بگذارید.',
    '',
  ],
  'APP.FESTIVAL.APPDESCRIPTION_DESCRIPTION': [
    '',
    'لطفا خلاصه‌ی فارسی معرفی برنامه‌ی خود را در حداکثر ۲۰۰ کاراکتر در این بخش وارد کنید.',
    '',
  ],
  'APP.VIGMA_FESTIVAL.TITLE': ['VIGMA', 'ویگما', 'VIGMA'],

  'TAP_TO_SELECT': ['Tap to select', 'برای انتخاب لمس کنید', '点击选择'],
  'DELETE_ITEM_WARNING': [
    'This will permanently delete the item. Continue?',
    'آیا از حذف این مورد اطمینان دارید؟',
    '这将永久删除该项。继续？',
  ],
  'WEBSITE_FA': ['Persian Website', 'وب‌سایت فارسی', '波斯语网站'],
  'WEBSITE_EN': ['English Website', 'وب‌سایت انگلیسی', '英文网站'],
  'PHONE': ['Phone', 'تلفن', '电话号码'],
  'MOBILE_PHONE': ['Cellphone number', 'شماره موبایل', '手机号码'],
  'POSTAL_CODE': ['Postal Code', 'کدپستی', '邮政编码'],
  'PROVINCE': ['Province', 'استان', '省份'],
  'CITY': ['City', 'شهر', 'City'],
  'ADDRESS': ['Address', 'آدرس', '地址'],
  'DESCRIPTION': ['Description', 'توضیح', '描述'],
  'EDIT': ['Edit', 'ویرایش', '编辑'],
  'SAVE': ['Save', 'ذخیره', '保存'],
  'SAVE_CHANGES': ['Save Changes', 'ذخیره تغییرات', 'Save Changes'],
  'REMOVE': ['Remove', 'حذف', '删除'],
  'UPLOAD': ['Upload', 'بارگذاری', '上转'],
  'SAVED': ['Saved', 'ذخیره شد', '已保存'],
  'DELETE_IT': ['Delete it', 'حذفش کن!', '删除吧'],
  'REPORT_IT': ['Report it', 'گزارشش کن!', '报告！'],
  'WARNING': ['Warning', 'هشدار', '警示'],
  'CLOSE': ['Close', 'بستن', 'Close'],
  'GOT_IT': ['Got it', 'متوجه شدم', 'Got it'],
  'CANCEL': ['Cancel', 'انصراف', '取消'],
  'NATURAL': ['Personal', 'حقیقی', '自然人'],
  'LEGAL': ['Company', 'حقوقی', '法人'],
  'ABOUT_US': ['About Us', 'درباره‌ی ما', '关于我们'],
  'SITE_COPYRIGHT': [
    '© {year} Café Bazaar',
    '© {year} کافه‌بازار',
    '© {year} 巴扎商店',
  ],
  'SUBMIT': ['Submit', 'ارسال', '提交'],
  'CREDENTIALS_ERROR': [
    'Invalid email or password.',
    'ایمیل یا رمز عبور اشتباه است.',
    '无效的电子邮件或密码。',
  ],
  'CHOOSE': ['Choose', 'انتخاب کنید', '选择'],
  'CONTRACT': ['Contract', 'قرارداد', '合同'],
  'REMEMBER_ME': ['Remember me', 'مرا به خاطر بسپار', '记住我'],
  'VALIDATION_MORE_THAN_ZERO': [
    'Value should be greater than zero.',
    'مقدار این فیلد باید بیشتر از ۰ باشد.',
    '该值应大于零。',
  ],
  'PASSWORD_VALIDATION_ERR': [
    'Password must have at least 8 characters, including one uppercase letter and one digit.',
    'رمز عبور باید حداقل ۸ کاراکتر و شامل حداقل یک کاراکتر بزرگ انگلیسی و یک رقم باشد.',
    '密码必须至少有8个字符,包括一个大写字母和一个数字。',
  ],
  'PASSWORD_LENGTH_VALIDATION': [
    'have at least 8 characters',
    'حداقل ۸ کاراکتر باشد',
    '至少有8个字符',
  ],
  'PASSWORD_LETTER_VALIDATION': [
    'including one uppercase letter and one digit',
    'شامل حداقل یک کاراکتر بزرگ انگلیسی و یک رقم باشد',
    '包括一个大写字母和一个数字',
  ],
  'VALIDATION_REQUIRED_ERR': [
    'This field is required.',
    'وارد کردن این فیلد ضروری است.',
    '此字段必填。',
  ],
  'VALIDATION_NO_ZERO': [
    'Value must be greater than zero.',
    'مقدار وارد شده باید بزرگتر از صفر باشد.',
    '值必须大于零',
  ],
  'INVALID_INPUT_VALUE': [
    'The value is invalid.',
    'مقدار واردشده نامعتبر است.',
    '值无效',
  ],
  'VALIDATION_FILE_REQUIRED_ERR': [
    'No file was uploaded.',
    'فایلی بارگذاری نشده است.',
    '没有文件上转的',
  ],
  'INVALID_INPUT_VALUE_EMAIL': [
    'The email address is invalid.',
    'آدرس ایمیل واردشده نامعتبر است.',
    '此电子邮件地址无效',
  ],
  'INVALID_INPUT_VALUE_URL': [
    'The entered url is invalid.',
    'آدرس واردشده نامعتبر است.',
    'The entered url is invalid.',
  ],
  'INVALID_INPUT_VALUE_NATIONAL_CODE': [
    'The national code is invalid.',
    'کد ملی واردشده نامعتبر است.',
    '国民识别号码无效',
  ],
  'INVALID_INPUT_VALUE_CHECK_PASS': [
    "Two inputs don't match.",
    'دو ورودی یکسان نیستند.',
    '两个输入不匹配',
  ],
  'AGENTS.TITLE': ['Agents', 'کارپردازان', '代理人'],
  'AGENTS.DESC': [
    'You can define your agents in this page. Agents are your representatives that can access your account with the restrictions that you may define for them.',
    'شما می‌توانید در این صفحه، برای حساب خود کارپردازانی تعریف کنید. کارپردازان، نمایندگان شما در پیشخان توسعه‌دهندگان هستند، که می‌توانند با دسترسی‌های تعریف‌شده توسط شما، به جای حساب اصلی شما در پیشخان فعالیت کنند.',
    '您可以在此页上定义代理。代理是您的代表,可以使用您为其定义的限制访问您的帐户。',
  ],
  'AGENTS.AGENTS_INFO': [
    'Agents Information',
    'اطلاعات کارپردازان',
    '代理信息',
  ],
  'AGENTS.AGENTS_INFO_DESC': [
    'Manage your agents information.',
    'اطلاعات کارپردازان خود را مدیریت کنید.',
    '管理代理信息',
  ],
  'AGENTS.AGENT_TITLE': ['Title', 'عنوان', '标题'],
  'AGENTS.ADD_AGENT_TITLE': ['Add New Agent', 'افزودن کارپرداز', '添加新代理'],
  'AGENTS.ADD_AGENT_DESC': ['', '', ''],
  'AGENTS.ADD_AGENT_BTN': ['Add Agent', 'ایجاد کارپرداز', '添加代理'],
  'AGENTS.NEW_AGENT_BTN': ['New Agent', 'کارپرداز جدید', '新代理人'],
  'AGENTS.PENDING_INVITATION': [
    'Pending approval',
    'در انتظار تأیید',
    '待批准',
  ],
  'AGENTS.API_ERROR': [
    'Error fetching agents list',
    'خطا در دریافت لیست کارپردازان',
    '获取代理列表时出错',
  ],
  'AGENTS.NO_DATA': [
    'No agents found.',
    'هیچ کارپردازی پیدا نشد.',
    '找不到代理人',
  ],
  'AGENTS.AGENT_ADDED': [
    'The agent has been added.',
    'کارپرداز با موفقیت اضافه شد.',
    '已添加代理。',
  ],
  'AGENTS.APPLY_PERMISSIONS_BTN': [
    'Edit and Apply Permissions',
    'ذخیره و اعمال دسترسی‌ها',
    'Edit and Apply Permissions',
  ],
  'AGENTS.PERMISSIONS_UPDATED': [
    'The permissions have been updated.',
    'دسترسی‌ها با موفقیت به‌روزرسانی شد.',
    '权限已更新。',
  ],
  'AGENTS.EDIT_PERMISSIONS_BTN': [
    'Edit Permissions',
    'ویرایش دسترسی‌ها',
    '编辑权限',
  ],
  'AGENTS.EDIT_PERMISSION.TITLE': [
    'Edit Permissions',
    'تنظیم دسترسی‌ها',
    'Edit Permissions',
  ],
  'AGENTS.GENERAL_PERMISSIONS.TITLE': [
    'General permissions and viewing of apps',
    'دسترسی عمومی و مشاهده برنامه‌ها',
    'General permissions and viewing of apps',
  ],
  'AGENT.GENERAL_PERMISSIONS.GROUP_TITLE': [
    'Agent Dashboard Permissions',
    'دسترسی‌های داشبورد کارپرداز',
    'Agent Dashboard Permissions',
  ],
  'AGENT.APP_PERMISSIONS.GROUP_TITLE': [
    'Dedicated Permissions for Each Application',
    'دسترسی‌های اختصاصی هر برنامه',
    'Dedicated Permissions for Each Application',
  ],
  'AGENT.APP_PERMISSIONS.SEARCH_PLACEHOLDER': [
    'Search in the applications...',
    'جستجو در نام برنامه‌ها...',
    'Search in the applications...',
  ],
  'AGENT.PERMISSIONS.PERMISSION_TYPE': [
    'Permission Type:',
    'نوع دسترسی:',
    'Permission Type:',
  ],
  'AGENT.PERMISSIONS.SELECT_ALL': [
    'Select All Permissions',
    'انتخاب تمام دسترسی‌ها',
    'Select All Permissions',
  ],
  'AGENT.PERMISSIONS.DESELECT_ALL': [
    'Remove All Permissions',
    'حذف تمام دسترسی‌ها',
    'Remove All Permissions',
  ],
  'AGENTS.FINANCE_PERMISSIONS.TITLE': [
    'Finance and Reporting Permissions',
    'دسترسی مالی و گزارش‌گیری',
    'Finance and Reporting Permissions',
  ],
  'AGENTS.GENERAL_PERMISSIONS.ADD_APP': [
    'Adding application',
    'افزودن برنامه',
    '添加应用程序',
  ],
  'AGENTS.GENERAL_PERMISSIONS.ADD_APP_DESCRIPTION': [
    'Permission to add new application in "Bazaar"',
    'اجازه برای ایجاد برنامه جدید در «بازار»',
    'Permission to add new application in "Bazaar"',
  ],
  'AGENTS.GENERAL_PERMISSIONS.CHANGE_PUBLIC_INFO': [
    'Changing public information',
    'تغییر اطلاعات عمومی',
    '改变公众信息',
  ],
  'AGENTS.GENERAL_PERMISSIONS.CHANGE_PUBLIC_INFO_DESCRIPTION': [
    'Permission to edit contact info, national code, address and... of publisher',
    'اجازه ویرایش اطلاعات تماس، کد ملی، نشانی پستی و… ناشر',
    'Permission to edit contact info, national code, address and... of publisher',
  ],
  'AGENTS.GENERAL_PERMISSIONS.VIEW_FINANCIAL_INFO': [
    'Viewing financial information',
    'مشاهده اطلاعات مالی',
    '查看财务信息',
  ],
  'AGENTS.GENERAL_PERMISSIONS.VIEW_FINANCIAL_INFO_DESCRIPTION': [
    'Permission to view the sales invoice, sales chart and billing history',
    'اجازه مشاهده فاکتور فروش، نمودار فروش و تاریخچه تصفیه‌حساب',
    'Permission to view the sales invoice, sales chart and billing history',
  ],
  'AGENTS.GENERAL_PERMISSIONS.CHANGE_FINANCIAL_INFO': [
    'Changing financial information',
    'تغییر اطلاعات مالی',
    '改变财务信息',
  ],
  'AGENTS.GENERAL_PERMISSIONS.CHANGE_FINANCIAL_INFO_DESCRIPTION': [
    'Permission to change the overnight number and its settings',
    'اجازه تغییر شماره شبای دریافت وجه و تنظیمات آن',
    'Permission to change the overnight number and its settings',
  ],
  'AGENTS.GENERAL_PERMISSIONS.DEVELOPERS_API': [
    'Changing developers API',
    'تغییر API توسعه‌دهندگان',
    '改变开发商的API',
  ],
  'AGENTS.GENERAL_PERMISSIONS.DEVELOPERS_API_DESCRIPTION': [
    'Permission to add and edit clients using the "Pishkhan API"',
    'اجازه اضافه کردن و ویرایش کلاینت‌های استفاده کننده از «API پیشخان»',
    'Permission to add and edit clients using the "Pishkhan API"',
  ],
  'AGENTS.APP_PERMISSIONS.TITLE': [
    'App Permissions',
    'دسترسی‌های برنامه',
    '应用程序的权限',
  ],
  'AGENTS.APP_PERMISSIONS.APP_TITLE': ['Apps', 'برنامه‌ها', '应用程序'],
  'AGENTS.APP_PERMISSIONS.ALL_APPS': [
    'All Apps',
    'همه‌ی برنامه‌ها',
    '所有应用程序',
  ],
  'AGENTS.APP_PERMISSIONS.CHANGE_APP_INFO': [
    'App Info',
    'اطلاعات برنامه',
    '应用程序信息',
  ],
  'AGENTS.APP_PERMISSIONS.CHANGE_APP_INFO_DESCRIPTION': [
    'Permission to view and edit app names, support information, pricing and app images',
    'اجازه مشاهده و ویرایش عنوان، اطلاعات پشتیبانی، قیمت و تصاویر برنامه ',
    'Permission to view and edit app names, support information, pricing and app images',
  ],
  'AGENTS.APP_PERMISSIONS.PUBLISH': ['Publish', 'انتشار', '发布'],
  'AGENTS.APP_PERMISSIONS.PUBLISH_DESCRIPTION': [
    'Permission to send application requests and hide the application in the application list',
    'اجازه ارسال درخواست انتشار برای برنامه و یا پنهان کردن برنامه در لیست برنامه‌ها',
    'Permission to send application requests and hide the application in the application list',
  ],
  'AGENTS.APP_PERMISSIONS.STATISTICS': ['Stats', 'آمار', '统计'],
  'AGENTS.APP_PERMISSIONS.STATISTICS_DESCRIPTION': [
    'Allows viewing and reporting of installation and visit statistics and user ratings to the app',
    'اجازه مشاهده و گزارش‌گیری از آمار نصب و بازدید و امتیازات کاربران به برنامه',
    'Allows viewing and reporting of installation and visit statistics and user ratings to the app',
  ],
  'AGENTS.APP_PERMISSIONS.SUPPORT': ['Support', 'پشتیبانی', '支持'],
  'AGENTS.APP_PERMISSIONS.SUPPORT_DESCRIPTION': [
    "Permission to view users' comments and respond to them",
    'امکان مشاهده نظرات کاربران و پاسخگویی به آنها',
    "Permission to view users' comments and respond to them",
  ],
  'AGENTS.APP_PERMISSIONS.DEVELOPMENT': ['Development', 'توسعه', '发展'],
  'AGENTS.APP_PERMISSIONS.DEVELOPMENT_DESCRIPTION': [
    'Allow uploading new version of the application and managing the in-app payment section',
    'اجازه بارگذاری نسخه‌ی جدید برنامه و مدیریت قسمت پرداخت درون‌برنامه‌ای',
    'Allow uploading new version of the application and managing the in-app payment section',
  ],
  'AGENTS.APP_PERMISSIONS.ADVERTISEMENT': ['Advertisement', 'تبلیغات', '广告'],
  'AGENTS.APP_PERMISSIONS.ADVERTISEMENT_DESCRIPTION': [
    'Permission to access advertisement section',
    'اجازه دسترسی به بخش تبلیغات',
    'Permission to access advertisement section',
  ],
  'AGENTS.APP_PERMISSIONS.VIEW_FINANCE': ['Finance', 'مالی', 'Finance'],
  'AGENTS.APP_PERMISSIONS.VIEW_FINANCE_DESCRIPTION': [
    'Allows view of user purchases and transactions in the application',
    'اجازه مشاهده خریدها و تراکنش‌های انجام شده کاربر در برنامه',
    'Allows view of user purchases and transactions in the application',
  ],
  'DEVELOPER_TITLES.TITLE': [
    'Developer Titles',
    'عناوین توسعه‌دهنده',
    '开发商名称',
  ],
  'DEVELOPER_TITLES.DEVELOPER_TITLE': [
    'Developer Title',
    'عنوان توسعه‌دهنده',
    '开发商名称',
  ],
  'DEVELOPER_TITLES.SLUG': ['Slug', 'شناسه‌ی توسعه‌دهنده', '开发商的标识号'],
  'DEVELOPER_TITLES.WEBSITE': ['Website', 'وبگاه', '网站'],
  'DEVELOPER_TITLES.EDIT_DEVELOPER_DETAIL': [
    'Edit Developer Detail',
    'ویرایش مشخصات',
    '编辑开发商信息',
  ],
  'DEVELOPER_TITLES.EDIT_DEVELOPER_SLUG': [
    'Edit Developer slug',
    'ویرایش شناسه',
    '编辑开发商的标识号',
  ],
  'DEVELOPER_TITLES.FA_TITLE': [
    "Developer's Persian Title",
    'عنوان فارسی توسعه‌دهنده',
    '开发商波斯名称',
  ],
  'DEVELOPER_TITLES.FA_WEBSITE': [
    'Farsi Website',
    'وب‌سایت فارسی',
    '波斯文网站',
  ],
  'DEVELOPER_TITLES.EN_TITLE': [
    "Developer's English Title",
    'عنوان انگلیسی توسعه‌دهنده',
    '开发商英语名称',
  ],
  'DEVELOPER_TITLES.EN_WEBSITE': [
    'English Website',
    'وب‌سایت انگلیسی',
    '英文网站',
  ],
  'DEVELOPER_TITLES.ADD_DEVELOPER_TITLE': [
    'Add new developer title',
    'افزودن عنوان توسعه دهنده جدید',
    'Add new developer title',
  ],
  'DEVELOPER_TITLES.NAME_INPUT_DESC': [
    'A unique title with less than 32 characters, consisting only of Persian and English letters, numbers, spaces and half-spaces.',
    'عنوانی یکتا با طول حداکثر 32 حرف، متشکل از حروف فارسی و انگلیسی، اعداد، فاصله و نیم‌فاصله.',
    '只有不到32个字符的唯一名称,仅由波斯语和英语字母、数字和空格组成。',
  ],
  'DEVELOPER_TITLES.REQUESTED_DEVELOPER_ID': [
    'Requested Developer ID',
    'شناسه‌ی درخواستی',
    '请求之开发人员的ID',
  ],
  'DEVELOPER_TITLES.REQUESTED_DEVELOPER_ID_DESC': [
    "A unique Developer ID including just a-z, 0-9, '_' and '-'.\nYou can't change your Developer ID after it's approved.",
    'شناسهٔ توسعه‌دهنده باید عبارتی با حدّاقل طول ۵ حرف باشد که از حروف a-z و اعداد 0-9، «-» و «ـ» تشکیل شده باشد.\nبعد از به تأیید رسیدن شناسه‌ی انتخابی دیگر نمی‌توانید آن‌را تغییر دهید.',
    '唯一的开发人员ID,仅包括a-z、0-9、"_"和" - "。\n您不能在开发人员的ID被批准后更改它。',
  ],
  'DEVELOPER_TITLES.SLUG.NEW': ['Under review', 'در حال بررسی', '审查中'],
  'DEVELOPER_TITLES.SLUG.REJECTED': ['Rejected', 'رد‌شده', '被拒绝'],
  'DEVELOPER_TITLES.SLUG.ACCEPTED': ['Accepted', 'تأیید‌شده', '认可的'],
  'DEVELOPER_TITLES.NO_DEVELOPER': [
    'No developer found.',
    'توسعه‌دهنده‌ای پیدا نشد.',
    '找不到开发商',
  ],
  'DEVELOPER_TITLES.API_ERROR': [
    'Error fetching developers list',
    'خطا در دریافت لیست توسعه‌دهنده‌ها',
    '获取开发商列表时出错',
  ],
  'PERMISSIONS': ['Permissions', 'دسترسی‌ها', '权限'],
  'GENERAL': ['General', 'عمومی', '总则'],
  'SEARCH': ['Search', 'جستجو', '探索'],
  'DELETE_COMPLETED': ['Delete completed', 'با موفقیت حذف شد.', '删除完成'],
  'ERROR_OCCURRED': [
    'An error occurred',
    'خطا در برقراری ارتباط با سرور',
    '发生错误',
  ],
  'PISHKHAN': [
    'Bazaar Developers Panel',
    'پیشخان توسعه‌دهندگان بازار',
    '巴扎商店的开发商面板',
  ],
  'PAGE_TITLE': ['Page Title', 'عنوان صفحه', '页面标题'],
  'SHEBA_NUMBER': ['Sheba Number', 'شماره‌ی شبا', 'Sheba号码'],
  'SHEBA_HELP_TEXT': [
    'Your sheba number that bank gave you e.g: IR123456789012345678901234',
    'شماره شبا شما که بانک به شما داده است. برای مثال: IR123456789012345678901234',
    '银行给你的Sheba号码,例如：IR1234567890123456789012345678901234',
  ],
  'SETTINGS': ['Settings', 'تنظیمات', '财务'],
  'AUTO_SETTLE': [
    'Automatic settlement: Settle my settleable amount to my sheba number on 1st of each month. For more information see.',
    'تصفیه‌حساب خودکار (مبلغ قابل تصفیه، یکُم هر ماه به حساب من واریز شود)',
    '自动结算：每月一日将我的可结算金额结算到我的Sheba号码。有关详细信息,请参阅。',
  ],
  'AUTO_SETTLE_HELP_TEXT': [
    'If set to true, will automatically create a settlement request for your account.',
    'در صورت فعال بودن به طور خودکار برای شما درخواست تصفیه‌حساب می‌سازد.',
    '如果设置为"开",将自动为您的帐户创建结算请求。',
  ],
  'ON': ['ON', 'روشن', '开'],
  'OFF': ['OFF', 'خاموش', '关'],
  'REPORTS': ['Reports', 'گزارش‌ها', '报告'],
  'MISC': [
    'Reconciliation transactions',
    'تراکنش‌های مغایرت‌گیری',
    '对帐交易记录',
  ],
  'FINANCE': ['Finance', 'مالی', '财务'],
  'DATE_RANGE': ['Date Range', 'بازه‌ی زمانی', '日期范围'],
  'PICK_A_DATE_RANGE': [
    'Pick a date range.',
    'یک بازه‌ی زمانی انتخاب کنید.',
    '选择日期范围',
  ],
  'PICK_A_ALPHA_GROUP': [
    'Pick a alpha group',
    'یک گروه آلفا انتخاب کنید.',
    'Pick a alpha group',
  ],
  'ADD_ALPHA_GROUP': [
    'add a alpha group',
    'افزودن گروه آلفا',
    'add a alpha group',
  ],
  'GROUP_NAME': ['Group Name', 'نام گروه', 'Group Name'],
  'NEW_GROUP': ['NEW GROUP', 'گروه جدید', 'NEW Group'],
  'INVITED_TIME': ['Time Invited', 'تاریخ دعوت', 'Time Invited'],

  'NUMBER_MEMBERS': [
    'Number Members',
    'شماره موبایل اعضای گروه ',
    'Number Members',
  ],
  'MEMBER_COUNT': ['Member Count', 'تعداد اعضا', 'Member Count'],
  'GROUP_MIN_MEMBER_REQUIRED': [
    'Group must have at least one member',
    'گروه تستی تعریف شده حداقل باید داری یک عضو باشد',
    'Group must have at least one member',
  ],
  'CREATED_DATE': ['Created Date', 'تاریخ ساخت', 'Created Date'],
  'PICK_DATE': ['Pick a date', 'انتخاب تاریخ', '选择日期'],
  'DOWNLOAD_FILE': ['Download File', 'دریافت فایل', '下载文件'],
  'FROM_DATE': ['From Date', 'از تاریخ', '从'],
  'TO_DATE': ['To Date', 'تا تاریخ', '到'],
  'DOWNLOAD_INVOICE': ['Download Invoice', 'دریافت فاکتور', '下载发票'],
  'UNTITLED': ['(Untitled)', '(بدون عنوان)', '无标题'],
  'SALES': ['Sales', 'فروش', '出售'],
  'SALES_IN_TOMANS': ['Sales (Tomans)', 'فروش (تومان)', '出售（Tomans）'],
  'SUM': ['Sum', 'مجموع', ''],
  'FINANCE.SETTLEMENT.TITLE': ['Settlement', 'تصفیه‌حساب', '结算'],
  'FINANCE.SETTLEMENT_HISTORY.TITLE': ['History', 'تاریخچه', '历史记录'],
  'FINANCE.SETTLEMENT_HISTORY.API_ERROR': [
    'Error fetching history list',
    'خطا در دریافت تاریخچه',
    '获取历史记录列表时出错',
  ],
  'FINANCE.SETTLEMENT_HISTORY.NO_DATA': [
    'No history found.',
    'تاریخچه‌ای پیدا نشد.',
    '找不到历史记录',
  ],
  'FINANCE.SETTLEMENT_SETTINGS.TITLE': ['Settings', 'تنظیمات', '设置'],
  'FINANCE.SETTLEMENT_TAX_HISTORY.TITLE': [
    'Tax History',
    'تاریخچه‌ی مالیاتی',
    '纳税记录',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_TYPE': [
    'Tax Invoice Type',
    'نوع فاکتور مالیاتی',
    '税务发票类型',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.CHECK_DATE': [
    'Invoice Last Check Date',
    'تاریخ آخرین بررسی فاکتور',
    '发票上次检查日期',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_NUMBER': [
    'Invoice Number',
    'شماره‌ی فاکتور',
    '发票号码',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_DATE': [
    'Invoice Date',
    'تاریخ فاکتور',
    '发票日期',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_ERROR_MESSAGE': [
    'Invoice Error Message',
    'پیغام خطای فاکتور',
    '发票错误消息',
  ],
  'FINANCE.SETTLEMENT_SETTINGS.DESCRIPTION': [
    'Minimum necessary amount for settlement is 500,000 Rials, less amounts  due to developer request will be refined end of year.<br>If you pursue montly settlment to a specified Sheba, you\'ll need activate auto settle and enter your account.<br>Provided Sheba could be change until any end of month and monthly payments deposit to last given Sheba,<br>Settle will be made based on settleable amount, at the beginning of day one and a maximum of 5 working days.<br>All the sections of your "publisher information" should be verifed to settle',
    'حداقل مبلغ مورد نیاز برای تصفیه، ۵۰۰٬۰۰۰ ریال است. مبالغ کمتر از این، بنا به درخواست توسعه‌دهنده، در پایان سال تصفیه خواهند شد.<br>در صورتی که می‌خواهید هر ماه تصفیه‌حساب شما به یک شبای ثابت انجام شود، می‌بایست تصفیه‌حساب خودکار را فعال نموده و شبای خود را وارد نمائید.<br>شبای اعلامی تا پایان هر ماه قابل تغییر است و پرداخت‌های هر ماه به آخرین شبای واردشده در سیستم واریز می‌شود.<br>پرداخت بر اساس مبلغ قابل تصفیه شما در ابتدای روز یکم و به فاصله‌ی حداکثر ۵ روز کاری صورت می‌گیرد.<br>برای انجام تصفیه‌حساب لازم است تمامی بخش‌های «اطلاعات ناشر» شما تأیید شده باشد.<br>شبا ارائه شده توسط توسعه‌دهنده باید متعلق به شخص حقیقی/حقوقی ‌باشد  که  بخش اطلاعات ناشر با اطلاعات وی تکمیل شده است.',
    '结算所需的最低金额为500000里亚尔,开发商要求的较少金额将成为完善的年终结算。<br>如果您追求每月结算到指定的谢巴,您将需要激活自动结算并输入您的帐户。<br>前提是Sheba可以更改到月底和每月付款存款最后给Sheba,<br>根据结算金额,在第一天开始,最多5个工作日。应验证您的"发布者信息"的所有部分以解决。',
  ],
  'FINANCE.SETTLEMENT_SETTINGS.WARNING': [
    'Any changes to your publisher and financial information during the period\
    It will be checked for at least 12 hours, so the failure to confirm your information in\
    Clearing time frame, especially the last day of each month in process\
    The liquidation of the account will be effective and may be out of the liquidation procedure\
    become',
    'هر گونه اعمال تغییرات در اطلاعات ناشر و مالی شما در بازه‌ی زمانی\
  حداقل ۱۲ ساعته بررسی خواهد شد، بنابراین عدم تایید اطلاعات شما در\
  بازه زمانی تصفیه، به خصوص روز انتهایی هر ماه در فرآیند\
  تصفیه‌حساب تاثیرگذار خواهد بود و ممکن است از روال تصفیه خارج\
  شوید.',
    'Any changes to your publisher and financial information during the period\
  It will be checked for at least 12 hours, so the failure to confirm your information in\
  Clearing time frame, especially the last day of each month in process\
  The liquidation of the account will be effective and may be out of the liquidation procedure\
  become',
  ],
  'FINANCE.SETTLEMENT_SETTINGS.SHEBA.ACCEPTED': [
    'Accepted',
    'تأییدشده',
    '认可的',
  ],
  'FINANCE.SETTLEMENT_SETTINGS.SHEBA.REJECTED': ['Rejected', 'رد شده', '拒绝'],
  'FINANCE.SETTLEMENT_SETTINGS.SHEBA.PENDING': [
    'Pending',
    'در حال بررسی',
    '待定',
  ],
  'FINANCE.SETTLEMENT.SETTLEABLE_AMOUNT': [
    'Settleable amount  <small>Note that this number is updated every 24 hours.</small>',
    'مبلغ قابل تصفیه  <small>این عدد هر ۲۴ ساعت به‌روز می‌شود.</small>',
    'Settleable amount  <small>Note that this number is updated every 24 hours.</small>',
  ],
  'FINANCE.SETTLEMENT.NON_DIGITAL_DESC': [
    'This account is a non-digital payment method and 100% of the payment will be deposited to your account daily.',
    'این حساب از نوع پرداخت غیر دیجیتال است و ۱۰۰٪ مبلغ پرداختی کاربران روزانه به حساب شما واریز خواهد شد.',
    '此账户为非数字支付方式,付款的100%将每天存入您的账户。',
  ],
  'FINANCE.SETTLEMENT.IN-PROGRESS_REQUEST': [
    'In-Progress Settlement Request',
    'درخواست‌های تصفیه‌حساب جاری',
    '进行中结算请求',
  ],
  'FINANCE.SETTLEMENT.STATUS': ['Status', 'وضعیت', '状态'],
  'FINANCE.SETTLEMENT.AMOUNT': ['Amount', 'مبلغ', '数量'],
  'FINANCE.SETTLEMENT.REQUEST_DATE': [
    'Request Date',
    'تاریخ ارسال درخواست',
    '请求日期',
  ],
  'FINANCE.SETTLEMENT_MISC.TITLE': [
    'Reconciliation Transactions',
    'تراکنش‌های مغایرت‌گیری',
    '对帐交易记录',
  ],
  'FINANCE.SETTLEMENT_MISC.AMOUNT': ['Amount', 'مبلغ', '数量'],
  'FINANCE.SETTLEMENT_MISC.DATE': ['Date', 'زمان', '日期'],
  'FINANCE.SETTLEMENT_MISC.DESC': ['Description', 'توضیح', '说明'],
  'FINANCE.SETTLEMENT.PAYMENT_ACCOUNT': [
    'Payment Account',
    'حساب مقصد',
    '付款帐户',
  ],
  'FINANCE.SETTLEMENT.RECEIPT': ['Receipt', 'رسید', '收据'],
  'FINANCE.SETTLEMENT.RECEIPT_LINK': ['Show receipt', 'نمایش رسید', '显示收据'],
  'FINANCE.SALES_CHART.TITLE': ['Sales Chart', 'نمودار فروش', '销售图表'],
  'FINANCE.SALES_CHART.DESC': ['', '', ''],
  'FINANCE.SALES_CHART.SALES': ['Sale', 'فروش', '销售'],
  'FINANCE.SALES_CHART.REFUNDS': ['Refund', 'بازگشت از فروش', '退款'],
  'FINANCE.SALES_CHART.AMOUNT': ['Amount', 'مبلغ', '数量'],
  'FINANCE.SALES_CHART.DISAGGREGATED_SALES': [
    'Disaggregated Sales',
    'به تفکیک',
    '分类销售',
  ],
  'FINANCE.SALES_CHART.TOTAL_SALE': ['Total Sale', 'فروش کل', '总销售额'],
  'FINANCE.SALES_CHART.TOTAL_REFUNDS': [
    'Total Refund',
    'مجموع بازگشت از فروش',
    '全额退款',
  ],
  'FINANCE.SALES_CHART.FILTER': ['Filters', 'فیلتر‌ها', '过滤器'],
  'FINANCE.SALES_CHART.NO_DATA': [
    'No sales data in the current date range.',
    'در این بازه‌ی زمانی فروشی انجام نشده است.',
    '当前日期范围内没有销售数据',
  ],
  'FINANCE.SALES_CHART.API_ERROR': [
    'Error getting sales data',
    'خطا در دریافت اطلاعات فروش',
    '获取销售数据时出错',
  ],
  'FINANCE.SALES_INVOICE.TITLE': [
    'Sales Reports',
    'گزارش‌های فروش',
    '销售报告',
  ],
  'FINANCE.SALES_INVOICE.INVOICE_TITLE': [
    'Sales Invoice',
    'فاکتور فروش',
    '销售发票',
  ],
  'FINANCE.SALES_INVOICE.INVOICE_DESC': [
    'You can receive your unofficial sales invoices from this section. Iranian legal developers are required to issue an invoice to "Bazaar" based on the information in these files after each account settlement.',
    'شما می‌توانید از این قسمت، فاکتورهای غیررسمی فروش خود را دریافت کنید. توسعه‌دهندگان حقوقی ایرانی ملزم‌اند پس از هر تصفیه‌حساب، بر اساس اطلاعات این فایل‌ها، برای «بازار» فاکتور صادر کنند.',
    'You can receive your unofficial sales invoices from this section. Iranian legal developers are required to issue an invoice to "Bazaar" based on the information in these files after each account settlement.',
  ],
  'FINANCE.SALES_INVOICE.FILE_TITLE': ['Sales File', 'فایل فروش', '销售档案'],
  'FINANCE.SALES_INVOICE.FILE_DESC': [
    'You can download the Excel file, containing sales information of all your apps within the selected time interval. The maximum selected time range is 3 months.',
    'شما می‌توانید از این قسمت فایل اکسل حاوی اطلاعات فروش تمام برنامه‌های خود ‌را در بازه‌ی زمانی دلخواه دریافت کنید. بازه‌ی انتخابی می‌تواند حداکثر سه ماه باشد.',
    '您可以下载Excel文件,其中包含选定时间间隔内所有应用程序的销售信息。最大选择时间范围为3个月。',
  ],
  'SETTINGS.AGENT_INFORMATION.TITLE': [
    'Agent Information',
    'اطلاعات کارپرداز',
    '代理人信息',
  ],
  'SETTINGS.CHANGE_PASSWORD.TITLE': [
    'Change Password',
    'تغییر رمز عبور',
    '更改密码',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.TITLE': [
    '2-Step Verification',
    'تایید دومرحله‌ای',
    '2-Step Verification',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.STATUS_INACTIVE': [
    '2-step verification is not active for your account!',
    'تایید دومرحله‌ای برای حساب شما فعال نمی‌باشد!',
    '2-step verification is not active for your account!',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.STATUS_ACTIVE': [
    '2-step verification is active for your account!',
    'تایید دومرحله‌ای برای حساب شما فعال می‌باشد.',
    '2-step verification is active for your account!',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.RECOMMEND_TO_ACTIVE': [
    'We recommend you enable two-step verification to increase the security of your account and prevent unauthorized access.',
    'پیشنهاد می‌کنیم برای افزایش امنیت حساب کاربری خود و جلوگیری از دسترسی غیرمجاز، تایید دومرحله‌ای را فعال کنید.',
    'We recommend you enable two-step verification to increase the security of your account and prevent unauthorized access.',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.DESCRIPTION': [
    'Two-step verification adds a new layer of security to your account when logging in. With two-step verification enabled, \
    after entring your username and password in login page, you need to receive and enter the one-time password from the password generator application.<br>\
    The advantage of this method is that even if your username and password are leaked, it will not be possible for unauthorized people to access the account, \
    and only you will be able to login to the panel using a one-time password.',
    'تایید دومرحله‌ای در هنگام ورود به حساب کاربری، یک لایه امنیتی جدید به حساب کاربری شما اضافه می‌کند. با فعال‌سازی تایید دومرحله‌ای، پس از وارد\
    کردن نام کاربری و رمز عبور در هنگام ورود به پنل، لازم است کد یکبار مصرفی را از اپلیکیشن تولید رمز دریافت کرده و وارد کنید.<br>\
    مزیت این روش این است که حتی در صورت دسترسی به نام کاربری و رمز عبور شما، ورود به حساب توسط افراد غیرمجاز ممکن نخواهد بود و تنها شما با استفاده از رمز یکبار مصرف قادر به ورود به پنل خواهید بود.',
    'Two-step verification adds a new layer of security to your account when logging in. With two-step verification enabled, \
    after entring your username and password in login page, you need to receive and enter the one-time password from the password generator application.<br>\
    The advantage of this method is that even if your username and password are leaked, it will not be possible for unauthorized people to access the account, \
    and only you will be able to login to the panel using a one-time password.',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.ACTIVATE': [
    'Activate 2-Step Verification',
    'فعال‌سازی تایید دومرحله‌ای',
    'Activate 2-Step Verification',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.ACTIVATE_GUIDE': [
    'To set up two-step verification, you need to do the following steps in order:<br>\
    1- First, intsall the <a href="https://cafebazaar.ir/app/com.google.android.apps.authenticator2" target="_blank" class="link">Google Authenticator</a> from Bazaar.<br>\
    2- Using the application, scan the opposite QR code to add Pishkhan settings to the application.<br>\
    3- Enter the code generated by the application in the opposite field and press the "check code" button.',
    'برای راه‌اندازی تایید دومرحله‌ای لازم است مراحل زیر را به ترتیب انجام دهید:<br>\
    ۱- ابتدا اپلیکیشن <a href="https://cafebazaar.ir/app/com.google.android.apps.authenticator2" target="_blank" class="link">Google Authenticator</a> را از بازار دانلود و نصب کنید.<br>\
    ۲- با استفاده از اپلیکیشن، QR کد مقابل را اسکن کنید تا تنظیمات پیشخان به اپلیکیشن اضافه شود.<br>\
    ۳- کد تولیدشده توسط اپلیکیشن را در فیلد روبرو وارد کنید و دکمه‌ی «بررسی کد» را بزنید. ',
    'To set up two-step verification, you need to do the following steps in order:<br>\
    1- First, intsall the <a href="https://cafebazaar.ir/app/com.google.android.apps.authenticator2" target="_blank" class="link">Google Authenticator</a> from Bazaar.<br>\
    2- Using the application, scan the opposite QR code to add Pishkhan settings to the application.<br>\
    3- Enter the code generated by the application in the opposite field and press the "check code" button.',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.DEACTIVATE': [
    'Disable 2-Step Verification',
    'غیرفعال‌ کردن تایید دومرحله‌ای',
    'Disable 2-Step Verification',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.DEACTIVATE_HELP': [
    'To disable 2-step verification, the one-time password generated by the application is required:',
    'برای غیر فعال کردن تایید دومرحله‌ای، رمز یکبار مصرف تولید‌شده توسط اپلیکیشن را وارد کنید:',
    'To disable 2-step verification, the one-time password generated by the application is required:',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.DEACTIVATE_WARNING': [
    'Warning: Disabling two-step verification will increase the vulnerability of your account to unauthorized access!',
    'توجه: غیرفعال کردن تایید دومرحله‌ای باعث افزایش آسیب‌پذیری حساب کاربری شما در برابر دسترسی افراد غیرمجاز خواهد شد!',
    'Warning: Disabling two-step verification will increase the vulnerability of your account to unauthorized access!',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.ENTER_CODE': [
    'Please enter the one-time password generated by the application:',
    'لطفا رمز یکبارمصرف تولید شده توسط اپلیکیشن را وارد کنید:',
    'Please enter the one-time password generated by the application:',
  ],
  'SETTINGS.TWO_STEP_VERIFICATION.CHECK_CODE': ['Verify', 'بررسی کد', 'Verify'],
  'SETTINGS.DEVELOPERS_API.TITLE': [
    'Developers API',
    'API توسعه‌دهندگان',
    '开发商的API',
  ],
  'SETTINGS.DEVELOPERS_API.DESC': [
    'Here you can create a new client to access Developers API or remove existing clients.',
    'در اینجا شما می‌توانید یک کلاینت جدید برای دسترسی به API توسعه‌دهندگان بسازید و یا کلاینت‌های قبلی را پاک کنید.',
    '在这里,您可以创建一个新的客户端来访问开发API或删除现有客户端',
  ],
  'SETTINGS.DEVELOPERS_API.SETTINGS': [
    'Developers API Settings',
    'تنظیمات API توسعه‌دهندگان',
    '开发人员API设置',
  ],
  'SETTINGS.DEVELOPERS_API.API_ERROR': [
    'Error fetching client list',
    'خطا در دریافت لیست کلاینت‌ها',
    '新客户端列表时出错',
  ],
  'SETTINGS.DEVELOPERS_API.NO_DATA': [
    'No clients found.',
    'هیچ کلاینتی پیدا نشد.',
    '找不到客户端',
  ],
  'SETTINGS.DEVELOPERS_API.NEW_CLIENT_BTN': [
    'New Client',
    'کلاینت جدید',
    '新客户',
  ],
  'SETTINGS.DEVELOPERS_API.ADD_CLIENT_TITLE': [
    'Add New Client',
    'افزودن کلاینت',
    '添加新客户端',
  ],
  'SETTINGS.DEVELOPERS_API.ADD_CLIENT_BTN': [
    'Add Client',
    'ایجاد کلاینت',
    '添加客户端',
  ],
  'SETTINGS.DEVELOPERS_API.CLIENT_CREATED': [
    'The client has been created.',
    'کلاینت با موفقیت ایجاد شد.',
    '客户端已创建',
  ],
  'SETTINGS.DEVELOPERS_API.CLIENT_ID': ['Client Id', 'Client Id', '客户端ID'],
  'SETTINGS.DEVELOPERS_API.CLIENT_SECRET': [
    'Client Secret',
    'Client Secret',
    '客户机密',
  ],
  'SETTINGS.DEVELOPERS_API.CLIENT_URI': [
    'Client URI',
    'Client URI',
    '客户端URI',
  ],
  'SUPPORT.SUBJECT': ['Subject', 'موضوع', '主题'],
  'SUPPORT.SUPPORT_INFO': [
    "To contact Developers' Support team of Bazaar, please call the fallowing number Saturday to Thursday, between 8am-6pm (Iran Time).</br></br><strong>Contact Info:</strong></br>Phone: 021-91009798</br>Email: developers@cafebazaar.ir",
    'برای ارتباط با واحد پشتیبانی توسعه‌دهندگان بازار، می‌توانید در روز‌های کاری از ساعت ۸ تا ۱۸ با شماره زیر تماس بگیرید.</br></br><strong>اطلاعات تماس</strong>:</br>تلفن: ۹۱۰۰۹۷۹۸-۰۲۱</br>ایمیل: developers@cafebazaar.ir</br>',
    '要联系巴扎商店的开发者支持团队,请在周六至周四上午8点至下午6点（伊朗时间）之间拨打以下电话。</br></br><strong>联系信息：</strong></br>电话：021-91009798电子 </br>邮件：developers@cafebazaar.ir',
  ],
  'SUPPORT.SUBSUBJECT': ['Subsubject', 'زیرموضوع', '副主题'],
  'SUPPORT.TICKET_MODAL_TIPS': [
    'If you’ve modified your application and sent a review request for it, you don’t need to send us a ticket and describe the modifications.',
    'اگر در برنامه خود تغییراتی به ‌وجود ‌آورده‌ و برای آن درخواست بررسی ارسال کرده‌اید، نیازی به ارسال تیکت و توضیح این تغییرات نیست.',
    'If you’ve modified your application and sent a review request for it, you don’t need to send us a ticket and describe the modifications.',
  ],
  'SUPPORT.TICKET': ['Ticket', 'تیکت', 'Ticket'],
  'SUPPORT.TICKET.INTRO': [
    'You can see the recurring tickets and their responses by changing the following category and subcategory. If you didn’t get your answer, send us a ticket.',
    'شما می‌توانید ابتدا با تغییر دسته و زیر‌دسته، تیکت‌ها و توضیحات پرتکرار را مشاهده کنید و درصورتی‌که با مطالعه‌ی این بخش پاسخ خود را نگرفتید، تیکت ارسال کنید.',
    'You can see the recurring tickets and their responses by changing the following category and subcategory. If you didn’t get your answer, send us a ticket.',
  ],
  'SUPPORT.NEW_TICKET': ['New Ticket', 'تیکت جدید', 'New Ticket'],
  'SUPPORT.TICKET_DETAILS': ['Ticket Details', 'مشخصات تیکت', 'Ticket Details'],
  'SUPPORT.TICKET.SUBJECT_TIP': [
    'Insert a subject based on your issue. Please avoid using short subjects such as: Help, Question, Needing assistance, etc. and insert some information about your request instead.',
    '«موضوع» را مطابق با متن ارسالی تنظیم کنید. عبارت‌هایی مانند: سؤال، کمک، راهنمایی و...در «موضوع» مناسب نیستند.',
    'Insert a subject based on your issue. Please avoid using short subjects such as: Help, Question, Needing assistance, etc. and insert some information about your request instead.',
  ],
  'SUPPORT.TICKET.ID': ['Ticket ID', 'شناسه تیکت', 'Ticket ID'],
  'SUPPORT.TICKET.STATUS': ['Status', 'وضعیت', 'Status'],
  'SUPPORT.TICKET.SUBJECT': ['Subject', 'موضوع', 'Subject'],
  'SUPPORT.TICKET.APP_NAME': ['Application Name', 'نام برنامه', '应用程序名称'],
  'SUPPORT.TICKET.MESSAGE': ['Message', 'پیغام', '消息'],
  'SUPPORT.TICKET.SEND_TICKET': [
    'Submit Ticket',
    'ارسال تیکت',
    'Submit Ticket',
  ],
  'SUPPORT.TICKET.CATEGORY': ['Category', 'دسته', 'Category'],
  'SUPPORT.TICKET.SUBCATEGORY': ['Sub-category', 'زیردسته', 'Sub-category'],
  'SUPPORT.TICKET.PACKAGE_NAME': ['Package Name', 'نام بسته', 'Package Name'],
  'SUPPORT.TICKET.CREATION_DATE': [
    'Creation Date',
    'تاریخ ایجاد',
    'Creation Date',
  ],
  'SUPPORT.TICKET.LAST_REPLY': ['Last reply', 'تاریخ آخرین جواب', 'Last reply'],
  'SUPPORT.TICKET.SUBMIT': ['SUBMIT', 'ارسال', 'SUBMIT'],
  'SUPPORT.TICKET_LIST': ['Ticket list', 'لیست تیکت‌ها', 'Ticket list'],
  'SUPPORT.NO_TICKET_EXIST': [
    'Ticket list is empty',
    'تیکتی وجود ندارد',
    'Ticket list is empty',
  ],
  'SUPPORT.TICKET.UNDER_REVIEW': [
    'Pending Support Team',
    'در انتظار پاسخ پشتیبان',
    'Pending Support Team',
  ],
  'SUPPORT.TICKET.PENDING_DEVELOPER': [
    'Pending Developer',
    'در انتظار پاسخ توسعه‌دهنده',
    'Pending Developer',
  ],
  'SUPPORT.TICKET.RESOLVED': ['Resolved', 'حل شده', 'Resolved'],
  'SUPPORT.TICKET.RESOLVED_ERROR': [
    'Ticket has been resolved.',
    'تیکت حل شده است.',
    'Ticket has been resolved.',
  ],
  'SUPPORT.TICKET.REOPEN': ['Reopen', 'بازگشایی مجدد', 'Reopen'],
  'SUPPORT.TICKET.SHOW_MORE': [
    'Show Previous messages',
    'نمایش پیام‌های پیشین',
    'Show Previous messages',
  ],
  'SUPPORT.TICKET.SHOW_LESS': [
    'Hide pervious messages',
    'پنهان کردن پیام‌های پیشین',
    'Hide pervious messages',
  ],
  'SUPPORT.TICKET.INVALID_ATTACHMENT': [
    'the {name} is bigger the 2MB',
    'پیوست {name} بیشتر از ۲ مگابایت می‌باشد',
    'the {name} is bigger the 2MB',
  ],
  'SUPPORT.TICKET.SEARCH': [
    'Search in subject',
    'جستجو در موضوع',
    'Search in subject',
  ],
  'SHEBA_NUMBER_ERROR': [
    'Entered SHEBA number is invalid',
    'شماره‌ی شبا واردشده اشتباه است.',
    '输入的Sheba号码无效',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY': ['Discovery', 'گشت‌وگذار', 'Discovery'],
  'ADVERTISEMENT.CAMPAIGNS.BASIC': ['Smart', 'هوشمند', 'Smart'],
  'ADVERTISEMENT.CAMPAIGNS.SMART': ['Smart', 'هوشمند', 'Smart'],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH': ['Search', 'جستجو', 'Search'],
  'ADVERTISEMENT.BASIC_ADS_INFORMATION_HYPERLINK': [
    "The smart advertising service is currently in beta and is active for a percentage of the developers' panel. Please contact the developer support to create a campaign.",
    'در حال حاضر سرویس تبلیغات هوشمند در مرحله‌ی بتا قرار دارد و برای درصدی از پنل پیشخان توسعه‌دهندگان فعال است. لطفا برای ساخت کمپین با پشتیبانی توسعه‌دهندگان تماس بگیرید.',
    "The smart advertising service is currently in beta and is active for a percentage of the developers' panel. Please contact the developer support to create a campaign.",
  ],
  'ADVERTISEMENT.TITLE': ['Advertisement', 'تبلیغات', '广告'],
  'ADVERTISEMENT.BACK_ICON': [
    'navigate_before',
    'navigate_next',
    'navigate_next',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BACK': [
    'Back to Campaigns',
    'بازگشت به لیست کمپین‌ها',
    '返回活动列表',
  ],
  'ADVERTISEMENT.OVERVIEW.TITLE': ['Overview', 'دید کلی', 'Overview'],
  'ADVERTISEMENT.OVERVIEW.CHART_SAME_AXIS': [
    'Display chart series in real scale',
    'نمایش نمودارها در مقیاس واقعی',
    'Display chart series in real scale',
  ],
  'ADVERTISEMENT.OVERVIEW.SERIES_SELECTION_LIMIT': [
    'Can not select more than two charts',
    'امکان مقایسه بیش از دو نمودار وجود ندارد',
    'Can not select more than two charts',
  ],
  'ADVERTISEMENT.OVERVIEW.SELECT_APP': [
    'Select your app to manage its campaigns:',
    'برنامه خود را برای مدیریت کمپین‌ها انتخاب کنید:',
    'Select your app to manage its campaigns:',
  ],
  'ADVERTISEMENT.MANAGE_CAMPAIGNS.TITLE': [
    'Manage Campaigns',
    'مدیریت کمپین‌ها',
    'Manage Campaigns',
  ],
  'ADVERTISEMENT.MANAGE_CAMPAIGNS.FILTER_BY_TYPE': [
    'Campaigin Type',
    'نوع کمپین',
    'Campaigin Type',
  ],
  'ADVERTISEMENT.MANAGE_CAMPAIGNS.FILTER_BY_STATUS': [
    'Status',
    'وضعیت',
    'Status',
  ],
  'ADVERTISEMENT.REPORTING.TITLE': ['Reporting', 'گزارش‌گیری', 'Reporting'],
  'ADVERTISEMENT.REPORTING.CAMPAIGNS_REPORTING': [
    'Campaigns Reporting',
    'گزارش‌گیری کمپین‌ها',
    'Campaigns Reporting',
  ],
  'ADVERTISEMENT.REPORTING.KEYWORDS_REPORTING': [
    'Keywords Reporting',
    'گزارش‌گیری کلمات',
    'Keywords Reporting',
  ],
  'ADVERTISEMENT.REPORTING.KEYWORDS_REPORTING.DESCRIPTION': [
    'Some of the selected campaigns are of the search type, you can see the report about them in this section.',
    'برخی از کمپین‌های انتخاب‌شده از نوع جستجو هستند، می‌توانید گزارش مربوط به آن‌ها رو در این قسمت مشاهده کنید..',
    'Some of the selected campaigns are of the search type, you can see the report about them in this section.',
  ],
  'ADVERTISEMENT.REPORTING.DESCRIPTION': [
    'In this section, you can compare all the information of different campaigns separately or see all the information together.',
    'در این قسمت می‌توانید تمام اطلاعات کمپین‌های مختلف را صورت جدا مقایسه کنید و یا جمع اطلاعات را در کنار هم ببینید.',
    'In this section, you can compare all the information of different campaigns separately or see all the information together.',
  ],
  'ADVERTISEMENT.REPORTING.HELP': [
    'To view the report, select your desired campaigns from the top menu.',
    'برای مشاهده گزارش، از منوی بالا کمپین‌های موردنظر خود را انتخاب کنید.',
    'To view the report, select your desired campaigns from the top menu.',
  ],
  'ADVERTISEMENT.REPORTING.GENERATE_REPORT': [
    'Generate Report',
    'ایجاد گزارش',
    'Generate Report',
  ],
  'ADVERTISEMENT.REPORTING.SHOW_REPORT': [
    'Show Report',
    'نمایش گزارش',
    'Show Report',
  ],
  'ADVERTISEMENT.REPORTING.SELECT_CAMPAIGNS': [
    'Select campaigns...',
    'انتخاب کمپین‌ها...',
    'Select campaigns...',
  ],
  'ADVERTISEMENT.REPORTING.REPORT_DATE': [
    'Report Date',
    'تاریخ گزارش',
    'Report Date',
  ],
  'ADVERTISEMENT.REPORTING.CHART_SERIES_MODE': [
    'Chart Display Mode',
    'نحوه‌ی نمایش نمودارها',
    'Chart Display Mode',
  ],
  'ADVERTISEMENT.REPORTING.CHART_SERIES_MODE.AGGREGATED': [
    'Aggregated',
    'تجمیعی',
    'Aggregated',
  ],
  'ADVERTISEMENT.REPORTING.CHART_SERIES_MODE.SEPARATED': [
    'Separated',
    'به تفکیک',
    'Separated',
  ],
  'ADVERTISEMENT.REPORTING.DOWNLOAD_REPORT': [
    'Download Report',
    'دانلود گزارش',
    'Download Report',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN': ['New Campaign', 'کمپین جدید', 'New Campaign'],
  'ADVERTISEMENT.SEARCH_ADS.CAMAPGIN_INFO_TITLE': [
    'Campaign Info',
    'اطلاعات کمپین',
    'Campaign Info',
  ],
  'ADVERTISEMENT.SEARCH_ADS_CAMPAINGS_LIST_TITLE': [
    'Search Ads',
    'تبلیغات جستجو',
    'Search Ads',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS_CAMPAINGS_LIST_TITLE': [
    'Discovery Ads',
    'تبلیغات گشت‌و‌گذار',
    'Discovery Ads',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_SEARCH_ADS': [
    'Create Search Campaign',
    'ساخت کمپین جستجو',
    'Create Search Campaign',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY': [
    'Create "Discovery" Campaign',
    'ساخت کمپین گشت‌و‌گذار',
    'Create "Discovery" Campaign',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.TARGET_CPI': [
    'Average bid price for each full installation (Rials)',
    'قیمت متوسط هر نصب کامل (ریال)',
    'Average bid price for each full installation (Rials)',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.BUDGET': [
    'Total campaign budget (Rials)',
    'بودجه کل کمپین (ریال)',
    'Total campaign budget (Rials)',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.DAILY_CAP': [
    'Maximum daily budget (Rials)',
    'حداکثر بودجه روزانه (ریال)',
    'Maximum daily budget (Rials)',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.SET_DAILY_CAP': [
    'Set limit for daily budget',
    'تعیین سقف برای بودجه روزانه',
    'Set limit for daily budget',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.AVAILABLE_TRACKERS': [
    'You can use Adjust, AdTrace, Metrix, AppMetrica and Chabok trackers in Discovery Ads.',
    'در حال حاضر می‌توانید از ترکرهای adjust ،AdTrace، متریکس، AppMetrica و چابک استفاده کنید.',
    'You can use Adjust, AdTrace, Metrix, AppMetrica and Chabok trackers in Discovery Ads.',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.ADD_CAMPAIGN': [
    'Create Campaign',
    'ساخت کمپین',
    'Create Campaign',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.PREVIOUS_STEP': [
    'Previous Step',
    'مرحله قبل',
    'Previous Step',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.STEPS.GENERAL_INFO': [
    'General information',
    'جزییات عمومی',
    'General information',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.STEPS.SET_PRICE': [
    'Set price',
    'تنظیم قیمت',
    'Set price',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.NEXT_STEP_CITY_AND_PRICE': [
    'Next step - (Set price)',
    'مرحله بعد - (تنظیم قیمت)',
    'Next step - (Set price)',
  ],
  'ADVERTISEMENT.DELETE_CAMPAIGN': [
    'Are you sure you want to delete "{campaignName}"?',
    'آیا از حذف کمپین «{campaignName}» اطمینان دارید؟',
    'Are you sure you want to delete "{campaignName}"?',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_BTN': [
    'Create Campaign',
    'ساخت کمپین',
    '创建活动',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN.CLONE_FROM': [
    'Copy Keywords from Previous Campaigns',
    'کپی کردن Keyword از کمپین‌های پیشین',
    'Copy Keywords from Previous Campaigns',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN.CLONE_FROM_DESCRIPTION': [
    'You can copy Keywords from another campaign in this section.',
    'در این بخش شما می‌توانید Keywordهای موجود در یک کمپین دیگرتان را کپی کرده و برای کمپین جدیدتان استفاده کنید.',
    'You can copy Keywords from another campaign in this section.',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.SEARCH_ADS': [
    'Search Ads',
    'تبلیغات جستجو',
    'Search Ads',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.SEARCH_ADS_DESCRIPTION': [
    'With the help of this campaign, you can have a better position in the competition between businesses on the search page and increase your market share.',
    'به کمک این کمپین می‌توانید در رقابت بین کسب‌و‌کارها در صفحه‌ی جستجو، جایگاه بهتری داشته باشید و سهم بازار خود را بیشتر کنید.',
    'With the help of this campaign, you can have a better position in the competition between businesses on the search page and increase your market share.',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.DISCOVERY': [
    'Discovery Ads',
    'تبلیغات گشت‌و‌گذار',
    'Discovery Ads',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.DISCOVERY_DESCRIPTION': [
    'This campaign helps to show your ads in the app details.',
    'این کمپین، تبلیغات برنامه شما را در قسمت جزئیات برنامه‌های مرتبط و صفحات مختلف نمایش می‌دهد.',
    'This campaign helps to show your ads in the app details.',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.MORE_INFO_ACTION': [
    'View tutorials',
    'مشاهده آموزش',
    'View tutorials',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.MORE_INFO_DESCRIPTION': [
    'ٔNeed more help?',
    'نیاز به راهنمایی بیشتری دارید؟',
    'Need more help?',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.SELECT': [
    'Create new campaign',
    'ساخت کمپین جدید',
    'Create new campaign',
  ],
  'ADVERTISEMENT.CONTRACT.TITLE': [
    'Advertisement Contract',
    'شرایط عمومی و شرایط اختصاصی محصولات تبلیغاتی بازار',
    'Advertisement Contract',
  ],
  'ADVERTISEMENT.CONTRACT.DUE_DATE_DESCRIPTION': [
    'The present contract will replace the electronic advertising contracts in the market from 1400/05/10. If you want to continue using Bazaar advertising products, please accept the contract by the above date. In case of cancellation or non-acceptance by {date}, your access to the Advertisement Panel will be limited until the acceptance of this contract.',
    'قرارداد حاضر از تاریخ ۱۴۰۰/۰۵/۱۰ جایگزین قراردادهای الکترونیکی تبلیغات در بازار خواهد شد. چنانچه مایل به ادامه استفاده از محصولات تبلیغاتی بازار هستید، لطفاً قرارداد را تا موعد فوق مورد پذیرش قرار دهید. در صورت انصراف از پذیرش یا عدم پذیرش تا تاریخ {date}، دسترسی شما به پیشخان تبلیغات تا زمان پذیرش این قرارداد محدود خواهد شد.',
    'The present contract will replace the electronic advertising contracts in the market from 1400/05/10. If you want to continue using Bazaar advertising products, please accept the contract by the above date. In case of cancellation or non-acceptance by {date}, your access to the Advertisement Panel will be limited until the acceptance of this contract.',
  ],
  'ADVERTISEMENT.CONTRACT.ACCEPTED_TITLE': [
    'Advertisement Contract (Accepted at {date})',
    'شرایط عمومی و شرایط  اختصاصی محصولات تبلیغاتی بازار (پذیرفته شده در {date})',
    'Advertisement Contract (Accepted at {date})',
  ],
  'ADVERTISEMENT.CONTRACT.ACTION': [
    'I have read this document in its entirety and accept its contents',
    'این سند را به صورت کامل مطالعه کردم و مفاد آن را می‌پذیرم',
    'I have read this document in its entirety and accept its contents',
  ],
  'ADVERTISEMENT.CONTRACT.CLOSE': ['Close', 'بستن', 'Close'],
  'ADVERTISEMENT.CONTRACT.DOWNLOAD': [
    'Download PDF',
    'دانلود PDF قرارداد',
    'Download PDF',
  ],
  'ADVERTISEMENT.KEYWORD': ['Keyword', 'کلیدواژه', 'Keyword'],
  'ADVERTISEMENT.KEYWORDPLANNER.TITLE': [
    'Keyword Planner',
    'ابزار پیشنهاد کلیدواژه',
    'Keyword Planner',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.INSIDE_TITLE': [
    'The keyword planner tool for campaigns',
    'ابزار پیشنهاد کلیدواژه برای کمپین‌ها',
    'The keyword planner tool for campaigns',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.INSIDE_DESCRIPTION': [
    'By entering your desired keyword in this tool, you can get the volume of competition and the average impression of each keyword. Also see a list of keywords related to the selected topic.',
    'با وارد کردن کلیدواژه‌ی مورد نظر خود در این ابزار، می‌توانید حجم رقابت و میانگین بازدید هر کلیدواژه را بدست بیاورید. به علاوه لیستی از کلیدواژه‌های مرتبط با موضوع انتخاب شده را ببینید.',
    'By entering your desired keyword in this tool, you can get the volume of competition and the average impression of each keyword. Also see a list of keywords related to the selected topic.',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.SEARCH_PLACEHOLDER': [
    'Enter keywords related to your application or campaign',
    'کلیدواژه مرتبط به برنامه‌ و یا کمپین خود را وارد کنید',
    'Enter keywords related to your application or campaign',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.SEARCH_HELP': [
    'After entering each keyword, press Enter.',
    'بعد از وارد کردن هر کلیدواژه، Enter را بزنید.',
    'After entering each keyword, press Enter.',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.EXTRA_HINT': [
    'The suggested keywords are based on impression, conversion rate, competition volume and value.',
    'کلیدواژه‌های پیشنهاد داده شده براساس تعداد بازدید، نرخ تبدیل، حجم رقابت و ارزش  کلیدواژه است.',
    'The suggested keywords are based on impression, conversion rate, competition volume and value.',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.SELECTED_KEYWORDS': [
    '{count} Keywords Selected',
    '{count} کلیدواژه انتخاب شده',
    '{count} Keywords Selected',
  ],
  'ADVERTISEMENT.POPOVER_ACTION_FORM.BACK_TO_MENU': [
    'Back to Menu',
    'بازگشت به منو',
    'Back to Menu',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.CHOOSE_MATCH_TYPE': [
    'Choose Match Type',
    'انتخاب Match Type',
    'Choose Match Type',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_TO_CAMPAIGN': [
    'Add to Campaign',
    'اضافه کردن به کمپین',
    'Add to Campaign',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.KEYWORD_PRICE': [
    'Price of Each Keyword',
    'قیمت هر کلیدواژه',
    'Price of Each Keyword',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.COLUMNS_VALUE': ['Value', 'ارزش', 'Value'],
  'ADVERTISEMENT.KEYWORDPLANNER.COLUMNS_AVERAGE_IMPRESSION': [
    'Average Impression',
    'میانگین بازدید',
    'Average Impression',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.COLUMNS_COMPETITION': [
    'Competition Level',
    'حجم رقابت',
    'Competition Level',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.COLUMNS_AVERAGE_OTHERS_PRICE': [
    'The Average Price of Others',
    'میانگین قیمت دیگران',
    'The Average Price of others',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.SUGGESTED_KEYWORDS_ROW_HEADING': [
    'Keywords suggested by "Bazaar" system to increase campaign efficiency',
    'کلیدواژه‌های پیشنهادی سیستم «بازار» برای بالا رفتن کارایی کمپین',
    'Keywords suggested by "Bazaar" system to increase campaign efficiency',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.SELECTED_KEYWORDS_ROW_HEADING': [
    'Statistics and status of your chosen keywords',
    'آمار و وضعیت کلیدواژه‌های انتخابی شما',
    'Statistics and status of your chosen keywords',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.COMPETITION_HIGH': ['High', 'زیاد', 'High'],
  'ADVERTISEMENT.KEYWORDPLANNER.COMPETITION_MEDIUM': [
    'Medium',
    'متوسط',
    'Medium',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.COMPETITION_LOW': ['Low', 'کم', 'Low'],
  'ADVERTISEMENT.KEYWORDPLANNER.SELECT_ACTION': [
    'Select Action',
    'انتخاب عملیات',
    'Select Action',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_KEYWORD_ALERT': [
    'All selected keywords except the following keywords were successfully added to the campaign.',
    'تمامی کلیدواژه‌های انتخابی به جز کلیدواژه‌های‌ زیر با موفقیت به کمپین اضافه شدند.',
    'All selected keywords except the following keywords were successfully added to the campaign.',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_KEYWORD_ERROR_TITLE': [
    'Error adding the following keywords to the campaign',
    'خطا در افزودن کلیدواژه‌های زیر به کمپین',
    'Error adding the following keywords to the campaign',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_KEYWORD_ERROR_DESCRIPTION': [
    'The following keywords are already available in your campaign. To edit their price and MatchType, go to the keyword management section of your campaign.',
    'کلیدواژه‌های زیر از قبل در کمپین شما موجود است. برای ویرایش قیمت و MatchType آنها به قسمت مدیریت کلیدواژه‌ها در کمپین خود بروید.',
    'The following keywords are already available in your campaign. To edit their price and MatchType, go to the keyword management section of your campaign.',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_KEYWORD_ERROR_KEYWODS_TITLE': [
    'Duplicate Keywords:',
    'کلیدواژه‌های تکراری:',
    'Duplicate Keywords:',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ALERT': [
    'All selected negative keywords except the following negative keywords were successfully added to the campaign.',
    'تمامی کلیدواژه‌های منفی انتخابی به جز کلیدواژه‌های منفی‌ زیر با موفقیت به کمپین اضافه شدند.',
    'All selected negative keywords except the following negative keywords were successfully added to the campaign.',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ERROR_TITLE': [
    'Error adding the following negative keywords to the campaign',
    'خطا در افزودن کلیدواژه‌های منفی زیر به کمپین',
    'Error adding the following negative keywords to the campaign',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ERROR_DESCRIPTION': [
    'The following negative keywords are already available in your campaign. To remove them, go to the management of negative keywords in your campaign.',
    'کلیدواژه‌های منفی زیر از قبل در کمپین شما موجود است. برای حذف آنها به قسمت مدیریت کلیدواژه‌های منفی در کمپین خود بروید.',
    'The following negative keywords are already available in your campaign. To remove them, go to the management of negative keywords in your campaign.',
  ],
  'ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ERROR_KEYWODS_TITLE': [
    'Duplicate Negative Keywords:',
    'کلیدواژه‌های منفی تکراری:',
    'Duplicate Negative Keywords:',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TITLE': ['Campaigns', 'کمپین‌ها', '活动列表'],
  'ADVERTISEMENT.CAMPAIGNS.CREATE_CAMPAIGN': [
    'Create Campaign',
    'ایجاد کمپین',
    'Create Campaign',
  ],
  'ADVERTISEMENT.CAMPAIGNS.CREATED_CAMPAIGNS': [
    'Created Campaigns',
    'کمپین‌های ایجادشده',
    'Created Campaigns',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SHOW_CONTRACT': [
    'Show Contract',
    'مشاهده قرارداد',
    'Show Contract',
  ],
  'ADVERTISEMENT.CAMPAIGNS.API_ERROR': [
    'Error getting campaigns list',
    'خطا در دریافت لیست کمپین‌ها',
    '获取活动列表时出错',
  ],
  'ADVERTISEMENT.CAMPAIGNS.NO_DATA': [
    'No campaigns found.',
    'هیچ کمپینی یافت نشد.',
    '找不到活动。',
  ],
  'ADVERTISEMENT.CAMPAIGNS.NAME': ['Name', 'نام', '名称'],
  'ADVERTISEMENT.CAMPAIGNS.PACKAGE_NAME': ['Package Name', 'نام بسته', '包名'],
  'ADVERTISEMENT.CAMPAIGNS.BUDGET': ['Budget', 'بودجه (ریال)', '预算'],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_CAMPAIGNS': [
    '"Search Ads" Campaigns List',
    'لیست کمپین‌های «تبلیغات جستجو»',
    '"Search Ads" Campaigns List',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_INSTALL_STATS': [
    'Installs',
    'تعداد نصب',
    'Installs',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_AVERAGE_INSTALL_STATS': [
    'Average Daily Installs',
    'میانگین نصب روزانه',
    'Average Daily Installs',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_‌BUDGET_STATS': [
    'Spent budget',
    'کل بودجه مصرف شده',
    'Spent Budget',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_‌DAILY_BUDGET_STATS': [
    'Average Daily Cost',
    'میانگین هزینه روزانه',
    'Average Daily Cost',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TODAY_SPENT_BUDGET': [
    "Today's Spent Budget",
    'بودجه مصرفی امروز',
    "Today's Spent Budget",
  ],
  'ADVERTISEMENT.CAMPAIGNS.TOTAL_IMPRESSIONS_COUNT': [
    'Total Impressions Count',
    'میزان بازدید تبلیغات',
    'Total Impressions Count',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TOTAL_IMPRESSIONS': [
    'Total Impressions',
    'تعداد نمایش',
    'Total Impressions',
  ],
  'ADVERTISEMENT.CAMPAIGNS.CONVERSION_RATE': [
    'Conversion Rate',
    'Conversion Rate',
    'Conversion Rate',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TOTAL_CLICKS': [
    'Total Clicks',
    'کلیک کل',
    'Total Clicks',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TOTAL_INSTALLS': [
    'Total Installs',
    'نصب کل',
    'Total Installs',
  ],
  'ADVERTISEMENT.CAMPAIGNS.AVERAGE_COST': [
    'Average Cost',
    'میانگین هزینه',
    'Average Cost',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TOTAL_COST': [
    'Overall Cost',
    'هزینه کل',
    'Overall Cost',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_OVERVIEW_TITLE': [
    'Overview of search campaigns',
    'نگاه کلی در کمپین‌های جستجو',
    'Overview of search campaigns',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_‌CHART_TITLE': [
    'Advertisement Impressions and Conversion Rates',
    'وضعیت بازدید تبلیغات و نرخ تبدیل',
    'Advertisement Impressions and Conversion Rates',
  ],
  'ADVERTISEMENT.BUDGET.FINAL_AMOUNT': [
    'Budget Amount (Rials)',
    'بودجه (ریال)‌',
    '预算金额（里亚尔）',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SPENT_BUDGET': [
    'Spent Budget',
    'بودجه مصرف شده (ریال)',
    '支出预算',
  ],
  'ADVERTISEMENT.CAMPAIGNS.START_DATE': [
    'Start Date',
    'تاریخ آغاز',
    '开始日期',
  ],
  'ADVERTISEMENT.CAMPAIGNS.END_DATE': ['End Date', 'تاریخ پایان', '结束日期'],
  'ADVERTISEMENT.CAMPAIGNS.IMPRESSION_TRACKER_LINK': [
    'Tracker Impression Link',
    'لینک اثرگذاری Tracker',
    '跟踪器印象链接',
  ],
  'ADVERTISEMENT.CAMPAIGNS.AVAILABLE_TRACKERS': [
    'Available trackers are Adjust, AdTrace, and Metrix.',
    'ترکرهای موجود Adjust ،AdTrace، و Metrix می‌باشند.',
    '可用的跟踪器有Adjust、AdTrace和Metrix。',
  ],
  'ADVERTISEMENT.CAMPAIGNS.STATUS': ['Status', 'وضعیت', '地位'],
  'ADVERTISEMENT.CAMPAIGNS.STATUS_SEARCH_DESCRIPTION': [
    '<b> Not started: </b> Your campaign has not started yet due to the specified schedule. <br /> <br /> <b> End budget: </b> The budget allocated to the campaign has been consumed. <br /> <br /> <b> Low budget: </b> You will not participate in the auction. <br /> <br /> <b> Ended: </b> Your campaign has run out of time. <br /> <br /> <b> Active: </b> Your campaign is attracting users. <br /> <br /> <b> Paused: </b> The campaign has been stopped by you. <br /> <br /> <b> Daily cap reached: </b> The campaign has reached and stopped with the daily consumption limit specified in the financial section.',
    '<b>آغاز نشده:</b> کمپین شما با توجه به زمان‌بندی مشخص شده هنوز شروع نشده است. <br /><br /> <b>اتمام بودجه:</b> بودجه تخصیص داده شده به کمپین تمام شده است. <br /><br /> <b>کمبود بودجه:</b> شما در حراجی شرکت داده نخواهید شد. <br /><br /> <b>پایان یافته:</b> زمان اجرای کمپین شما به اتمام رسیده است. <br /><br /> <b>فعال:</b> کمپین شما در حال جذب کاربر است. <br /><br /> <b>متوقف:</b> کمپین توسط شما متوقف شده است. <br /><br /> <b>متوقف با سقف مصرف روزانه:</b> کمپین به سقف مصرف روزانه‌ی مشخص شده در قسمت مالی رسیده و متوقف شده است.',
    '<b> Not started: </b> Your campaign has not started yet due to the specified schedule. <br /> <br /> <b> End budget: </b> The budget allocated to the campaign has been consumed. <br /> <br /> <b> Low budget: </b> You will not participate in the auction. <br /> <br /> <b> Ended: </b> Your campaign has run out of time. <br /> <br /> <b> Active: </b> Your campaign is attracting users. <br /> <br /> <b> Paused: </b> The campaign has been stopped by you. <br /> <br /> <b> Daily cap reached: </b> The campaign has reached and stopped with the daily consumption limit specified in the financial section.',
  ],
  'ADVERTISEMENT.CAMPAIGNS.STATUS_DISCOVERY_DESCRIPTION': [
    '<b> Not started: </b> Your campaign has not started yet due to the specified schedule. <br /> <br /> <b> End budget: </b> The budget allocated to the campaign has been consumed. <br /> <br /> <b> Low budget: </b> You will not participate in the auction. <br /> <br /> <b> Ended: </b> Your campaign has run out of time. <br /> <br /> <b> Active: </b> Your campaign is attracting users. <br /> <br /> <b> Paused: </b> The campaign has been stopped by you.',
    '<b>آغاز نشده:</b> کمپین شما با توجه به زمان‌بندی مشخص شده هنوز شروع نشده است. <br /><br /> <b>اتمام بودجه:</b> بودجه تخصیص داده شده به کمپین تمام شده است. <br /><br /> <b>کمبود بودجه:</b> شما در حراجی شرکت داده نخواهید شد. <br /><br /> <b>پایان یافته:</b> زمان اجرای کمپین شما به اتمام رسیده است. <br /><br /> <b>فعال:</b> کمپین شما در حال جذب کاربر است. <br /><br /> <b>متوقف:</b> کمپین توسط شما متوقف شده است.',
    '<b> Not started: </b> Your campaign has not started yet due to the specified schedule. <br /> <br /> <b> End budget: </b> The budget allocated to the campaign has been consumed. <br /> <br /> <b> Low budget: </b> You will not participate in the auction. <br /> <br /> <b> Ended: </b> Your campaign has run out of time. <br /> <br /> <b> Active: </b> Your campaign is attracting users. <br /> <br /> <b> Paused: </b> The campaign has been stopped by you.',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TARGETED_CPI': [
    'Maximum bid price for each full installation (Rials)',
    'حداکثر قیمت پیشنهادی به ازای هر نصب کامل (ریال)',
    'Maximum bid price for each full installation (Rials)',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DAILY_CAP': [
    'Daily Capacity',
    'حداکثر بودجه روزانه (ریال)',
    'Daily Capacity',
  ],
  'ADVERTISEMENT.CAMPAIGNS.INSTALL_COUNT': [
    'Full Installation',
    'Full Installation',
    'Full Installation',
  ],
  'ADVERTISEMENT.CAMPAIGNS.IMPRESSION_COUNT': [
    'Impression',
    'Impression',
    'Impression',
  ],
  'ADVERTISEMENT.CAMPAIGNS.PAUSED': ['Paused', '‌متوقف‌شده', '暂停'],
  'ADVERTISEMENT.CAMPAIGNS.ACTIVE': ['Active', 'فعال', '活性'],
  'ADVERTISEMENT.CAMPAIGNS.AVG_INSTALL_COST': ['Avg CPI', 'Avg CPI', 'Avg CPI'],
  'ADVERTISEMENT.CAMPAIGNS.NOT_STARTED': ['Not Started', 'آغازنشده', '未开始'],
  'ADVERTISEMENT.CAMPAIGNS.ENDED': ['Ended', 'پایان‌یافته', '结束了'],
  'ADVERTISEMENT.CAMPAIGNS.NO_BUDGET': ['No Budget', 'اتمام بودجه', '没有预算'],
  'ADVERTISEMENT.CAMPAIGNS.LOW_BUDGET': [
    'Low Budget',
    'کمبود بودجه',
    'Low Budget',
  ],
  'ADVERTISEMENT.CAMPAIGNS.PAUSE': [
    'Pause the Campaign',
    'متوقف کردن کمپین',
    'Pause the Campaign',
  ],
  'ADVERTISEMENT.CAMPAIGNS.PAUSE_WARNING': [
    'Are you sure to pause this campaign?',
    'از توقف این کمپین اطمینان دارید؟',
    'Are you sure to pause this campaign?',
  ],
  'ADVERTISEMENT.CAMPAIGNS.ACTIVATE_GUIDE': [
    'You can always reactivate inactive campaigns by selecting the activation option.',
    'همواره می‌توانید کمپین‌های غیرفعال را از طریق انتخاب گزینه‌ی فعال‌سازی، مجدداً فعال کنید.',
    'You can always reactivate inactive campaigns by selecting the activation option.',
  ],
  'ADVERTISEMENT.CAMPAIGNS.ACTIVATE': [
    'Activate the Campaign',
    'فعال کردن کمپین',
    'Activate the Campaign',
  ],
  'ADVERTISEMENT.CAMPAIGNS.RECHED_DAILY_CAP': [
    'Daily Cap Reached',
    'متوقف با سقف مصرف روزانه',
    '达到每日上限',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.NAME': ['Name', 'نام', '名称'],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.PACKAGE_NAME': [
    'Package Name',
    'نام بسته',
    '包名',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.BUDGET': [
    'Budget',
    'بودجه (ریال)',
    '预算',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.SPENT_BUDGET': [
    'Spent Budget',
    'بودجه مصرف شده (ریال)',
    '支出预算',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.DAILY_CAP': [
    'Daily Capacity',
    'حداکثر بودجه روزانه (ریال)',
    'Daily Capacity',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.TARGETED_CPI': [
    'Average bid price for each full installation (Rials)',
    'قیمت متوسط هر نصب کامل (ریال)',
    'Average bid price for each full installation (Rials)',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.START_DATE': [
    'Start Date',
    'تاریخ آغاز',
    '开始日期',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.END_DATE': [
    'End Date',
    'تاریخ پایان',
    '结束日期',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATUS': ['Status', 'وضعیت', '地位'],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.IMPRESSION_TRACKER_LINK': [
    'Tracker Click Link',
    'لینک کلیک Tracker',
    'Tracker Click Link',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.TRACKER_STATUS': [
    'Integrate with tracker',
    'همگام سازی با Tracker',
    '与跟踪器集成',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATS.DATE': ['Date', 'تاریخ', 'Date'],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATS.CPI': [
    'CPI (Rials)',
    'CPI (ریال)',
    'CPI (Rials)',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATS.INSTALLS': [
    'Installs',
    'تعداد نصب کامل',
    'Installs',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATS.CHART.INSTALLS': [
    'Installs',
    'نصب کامل',
    'Installs',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATS.DAILY_USAGE': [
    'Daily spent budget (Rials)',
    'بودجه‌ی مصرفی روز (ریال)',
    'Daily spent budget (Rials)',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATS.TITLE': [
    'Daily stats',
    'آمار روزانه',
    'Daily stats',
  ],
  'ADVERTISEMENT.CAMPAIGNS_LIST.DESC': [
    'Here you can create ad campaigns. Watch tutorials on {link}.',
    'در این قسمت شما می‌توانید کمپین ایجاد کنید؛ برای دیدن مطالب آموزشی تبلیغاتی روی {link} کلیک کنید.',
    'Here you can create ad campaigns. Watch tutorials on {link}.',
  ],
  'ADVERTISEMENT.CAMPAIGNS_LIST.DISCOVERY.TITLE': [
    '"Discovery Ads" Campaigns',
    'کمپین‌‌های «تبلیغات گشت‌و‌گذار»',
    '"Discovery Ads" Campaigns',
  ],
  'ADVERTISEMENT.CAMPAIGNS.RUN': [
    'Resume Campaign',
    'فعال کردن کمپین',
    '继续活动',
  ],
  'ADVERTISEMENT.CAMPAIGNS.CHOOSE_TO_HAVE_TRACKER': [
    'I am using tracker',
    'از Tracker استفاده می‌کنم.',
    '我在用追踪器',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TRACKER_STATUS': [
    'Integrate with tracker',
    'همگام‌سازی با Tracker',
    '与跟踪器集成',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DOESNT_HAVE_TRACKER': [
    "Haven't done yet",
    'انجام نشده',
    '还没做完',
  ],
  'ADVERTISEMENT.CAMPAIGNS.HAS_TRACKER': ['Done', 'انجام شده', '完成'],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY_BANNER.TITLE': [
    "Discovery Ads' New Service",
    'سرویس جدید تبلیغات گشت‌وگذار',
    "Discovery Ads' New Service",
  ],
  'ADVERTISEMENT.CAMPAIGNS.DISCOVERY_BANNER.DESCRIPTION': [
    'Advertising, even more targeted than before! With this service, show your application to users in the details page of Bazaar\'s applications. You can now create your first Discovery Ads Campaign by clicking "Create New Campaign".',
    'تبلیغات، حتی هدفمندتر از گذشته! با این سرویس برنامهٔ خود را در صفحهٔ جزییات برنامه‌های بازار به کاربران نمایش دهید. هم اکنون می‌توانید با کلیک بر روی "ساخت کمپین جدید" اولین کمپین تبلیغات گشت‌وگذار خود را راه‌اندازی کنید.',
    'Advertising, even more targeted than before! With this service, show your application to users in the details page of Bazaar\'s applications. You can now create your first Discovery Ads Campaign by clicking "Create New Campaign".',
  ],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.TITLE': [
    'Campaign Details',
    'جزییات کمپین',
    '活动详细信息',
  ],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.API_ERROR': [
    'Error getting campaign info',
    'خطا در دریافت اطلاعات کمپین',
    '获取活动信息时出错',
  ],
  'ADVERTISEMENT.KEYWORDS.TITLE': [
    'Manage Keywords',
    'مدیریت کلیدواژه‌ها',
    'Manage Keywords',
  ],
  'ADVERTISEMENT.KEYWORDS.EMPTY_TITLE': [
    'Add keywords for this campaign',
    'افزودن کلیدواژه برای این کمپین ',
    'Add keywords for this campaign',
  ],
  'ADVERTISEMENT.KEYWORDS.EMPTY_DESCRIPTION': [
    'In this section, you can add keywords related to your campaign to either single mode or CSV file.',
    'در این قسمت می‌توانید کلیدواژه‌های مرتبط با کمپین خود را به دو حالت تکی و یا فایل CSV اضافه کنید.',
    'In this section, you can add keywords related to your campaign to either single mode or CSV file.',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.TITLE': [
    'Campaign Finance',
    'مالی کمپین',
    '活动资金',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.DESCRIPTION': [
    'In this section, you can change the budget of this campaign by assigning your account credit.',
    'در این بخش شما می‌توانید بودجه‌ی این کمپین را با تخصیص از اعتبار کیف پول تبلیغات، تغییر دهید.',
    'In this section, you can change the budget of this campaign by assigning your account credit.',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_BUDGET': [
    'Change Budget',
    'تغییر بودجه',
    '更改预算',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.REMAINING_BUDGET': [
    'Remaining Budget',
    'بودجه باقی‌مانده',
    '剩余预算',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.OUT_OF_BUDGET': [
    'No Credit',
    'بودجه تمام شده',
    '无预算',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_CREDIT_TYPE': [
    'Credit Type',
    'نوع بودجه',
    '信用类型',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_FROM_CREDIT': [
    'Charge From Credit',
    'تخصیص اعتبار از کیف پول تبلیغات',
    '赊账',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_AMOUNT': [
    'Budget:',
    'بودجه:',
    'Budget:',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.FINAL_CHARGE_AMOUNT': [
    'Charge Budget Amount',
    'مبلغ شارژ بودجه',
    '费用预算金额',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.CHARGE_BUTTON': [
    'Change Budget',
    'تغییر بودجه',
    'Change Budget',
  ],
  'ADVERTISEMENT.BUDGET_ERROR.TITLE': [
    'Insufficient budget',
    'بودجه ناکافی',
    'Insufficient budget',
  ],
  'ADVERTISEMENT.BUDGET_ERROR.DESCRIPTION': [
    'The budget entered is more than the credit of your wallet.',
    'بودجه وارد شده از اعتبار کیف پول شما بیشتر است.',
    'The budget entered is more than the credit of your wallet.',
  ],
  'ADVERTISEMENT.BUDGET_ERROR.ADD_TO_WALLET': [
    'Increase wallet credit',
    'افزایش اعتبار کیف پول',
    'Increase wallet credit',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.AVAILABLE_BUDGET': [
    'Available credit',
    'اعتبار قابل تخصیص',
    'Available credit',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_TITLE': [
    'Daily Cap',
    'سقف مصرف روزانه',
    '每日上限',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_AMOUNT': [
    'Amount of Daily Cap',
    'مبلغ سقف مصرف روزانه',
    '每日上线',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_DESCRIPTION': [
    'In this section, you can set a limit for your daily budget in this campaign.',
    'در این بخش شما می توانید برای میزان مصرف روزانه بودجه در این کمپین‌تان، یک حد تعیین کنید.',
    '在本节中,您可以设置此活动中的每日预算限制。',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_DAILY_CAP': [
    'Change Daily Cap',
    'تغییر سقف مصرف روزانه',
    '更改每日上限',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.WITHOUT_DAILY_CAP': [
    'Without Daily Cap',
    'بدون سقف مصرف روزانه',
    '无每日上限',
  ],
  'ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_ERROR': [
    'Daily cap should be greater than 1,000,000 Rials.',
    'مقدار سقف مصرف روزانه باید بیشتر از یک میلیون ریال باشد.',
    '每日上限应大于1,000,000 里亚尔以上。',
  ],
  'ADVERTISEMENT.BIDS.API_ERROR': [
    'Error getting keywords list',
    'خطا در دریافت لیست کلیدواژه‌ها',
    'Error getting keywords list',
  ],
  'ADVERTISEMENT.SUGGESTIONS.API_ERROR': [
    'Error getting suggestions',
    'خطا در دریافت لیست عبارت‌های مرتبط',
    '获取建议时出错',
  ],
  'ADVERTISEMENT.BIDS.PAUSE': ['Pause', 'توقف', 'Pause'],
  'ADVERTISEMENT.BIDS.SEARCH_BID': [
    'Search within keywords',
    'جستجو در میان کلیدواژه‌ها',
    'Search within keywords',
  ],
  'ADVERTISEMENT.BIDS.EXPORT_CSV': ['Export CSV', 'دریافت CSV', 'Export CSV'],
  'ADVERTISEMENT.BIDS.RUN': ['Run', 'ادامه دادن', '运行'],
  'ADVERTISEMENT.BIDS.CHANGE_COLUMN': [
    'Change Columns',
    'تغییر ستون‌ها',
    '更改列',
  ],
  'ADVERTISEMENT.BIDS.SELECTED_COLUMNS': [
    'Selected Columns',
    'ستون‌های انتخاب شده',
    '选定列',
  ],
  'ADVERTISEMENT.BIDS.HIDDEN_COLUMNS': [
    'Hidden Columns',
    'ستون‌های پنهان شده',
    '隐藏列',
  ],
  'ADVERTISEMENT.NEGATIVE_KEYWORDS.API_ERROR': [
    'Error getting negative keywords',
    'خطا در دریافت لیست کلیدواژه منفی',
    'Error getting negative keywords',
  ],
  'ADVERTISEMENT.NEGATIVE_KEYWORDS.TITLE': [
    'Negative Keywords',
    'کلیدواژه‌های منفی',
    'Negative Keywords',
  ],
  'ADVERTISEMENT.NEGATIVE_KEYWORDS.ADD_TITLE': [
    'Add Negative Keyword',
    'افزودن کلیدواژه منفی',
    'Add Negative Keyword',
  ],
  'ADVERTISEMENT.NEGATIVE_KEYWORDS.KEYWORD': [
    'Negative Keyword',
    'کلیدواژه منفی',
    'Negative Keyword',
  ],
  'ADVERTISEMENT.NEGATIVE_KEYWORDS.ADD_BUTTON': ['Add', 'افزودن', '添加'],
  'ADVERTISEMENT.NEGATIVE_KEYWORDS.DESC': [
    'In this section, add the keywords you don`t want to be shawn in broad auctioning and in your campaign.',
    'در این بخش کلماتی که تمایل دارید بر روی آن‌ها در کمپین‌تان و در حالت گسترده به هیچ‌وجه نمایش داده نشوید را انتخاب کنید.',
    '在本节中,添加您不希望在广泛拍卖和您的活动中显示的关键字。',
  ],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.NO_DATA': [
    'No keywords found.',
    'هیچ کلیدواژه‌ای یافت نشد.',
    'No keywords found.',
  ],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.CAMPAIGN_DESC': [
    'The details of your campaign is shown here. You can edit these details here.',
    'اطلاعات کمپین شما در این قسمت نمایش داده شده است. شما می‌توانید این اطلاعات را ویرایش کنید.',
    '你的活动详情在这里显示。你可以在这里编辑这些细节',
  ],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.BIDS_LIST.TITLE': [
    'Keywords',
    'کلیدواژه‌ها',
    'Keywords',
  ],
  'ADVERTISEMENT.NOTIFICATIONS.TITLE': ['Notifications', 'اعلان‌ها', '通知'],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.DELETE_CAMPAIGN': [
    'Delete Campaign',
    'حذف کمپین',
    '删除活动',
  ],
  'ADVERTISEMENT.THIS_LINK': ['these links', 'این لینک', 'these links'],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.SUGGESTIONS_LIST.TITLE': [
    'Query Suggestions:',
    'عبارت‌های مرتبط:',
    '查询建议：',
  ],
  'ADVERTISEMENT.CAMPAIGN_DETAILS.SUGGESTION_LIST.DESC': [
    'This list of suggestions is automatically generated and would be rejected in review.',
    'عبارت‌های زیر به طور خودکار برای برنامه‌ی شما تولید شده‌اند و ممکن است حین بازبینی تأیید نشوند.',
    '此建议列表将自动生成,并在审阅时被拒绝。',
  ],
  'ADVERTISEMENT.BID.KEYWORD': ['Keyword', 'Keyword', 'Keyword'],
  'ADVERTISEMENT.BID.MAX_CPI': [
    'MAX CPI (Rials)',
    'MAX CPI (Rials)',
    'MAX CPI (Rials)',
  ],
  'ADVERTISEMENT.BID.REJECTED': ['Rejected', 'رد شده', '拒绝'],
  'ADVERTISEMENT.BID.PENDING': ['Pending', 'در حال بررسی', '待定'],
  'ADVERTISEMENT.BID.ACTIVE': ['Showing', 'در حال نمایش', 'Showing'],
  'ADVERTISEMENT.BID.CAMPAIGN_STOPPED': [
    'Campaign Stopped',
    'کمپین متوقف شده',
    '活动已停止',
  ],
  'ADVERTISEMENT.BID.LOSER': [
    'Auction Participant',
    'حضور در حراجی',
    'Auction Participant',
  ],
  'ADVERTISEMENT.BID.ALERTED': ['Alerted', 'اخطار گرفته', '警觉的'],
  'ADVERTISEMENT.BID.DETAILS': ['Details', 'جزئیات', '详细信息'],
  'ADVERTISEMENT.BID.COLUMN_DESC_MAX_CPI_TITLE': [
    'Maximum Cost Per Full Installation',
    'Maximum Cost Per Full Installation',
    'Maximum Cost Per Full Installation',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_MAX_CPI_CONTENT': [
    'The maximum amount of money you are willing to pay for the full installation of your ad by the user in the Bazaar.',
    'بیشترین مقدار پولی است که شما حاضر هستید به ازای نصب کامل از تبلیغ‌تان توسط کاربر در «بازار» بپردازید.',
    'The maximum amount of money you are willing to pay for the full installation of your ad by the user in the Bazaar.',
  ],
  'ADVERTISEMENT.BID.COLUMN_STATUS': ['Status', 'Status', 'Status'],
  'ADVERTISEMENT.BID.COLUMN_WIN_RATE': ['Win Rate', 'Win Rate', 'Win Rate'],
  'ADVERTISEMENT.BID.COLUMN_DESC_WIN_RATE_CONTENT': [
    'Win Rate represents the percentage of times your bid wins the auction and gets displayed to users. A higher win rate indicates better competitive positioning for your keyword bid.',
    'Win Rate درصد دفعاتی است که پیشنهاد شما در حراجی برنده می‌شود و به کاربران نشان داده می‌شود. نرخ برد بالاتر نشان‌دهنده موقعیت رقابتی بهتر برای پیشنهاد کلیدواژه شما است.',
    'Win Rate represents the percentage of times your bid wins the auction and gets displayed to users. A higher win rate indicates better competitive positioning for your keyword bid.',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_STATUS_CONTENT': [
    `
    <b>Pending Status:</b> The keyword of your choice is being reviewed by the Market Advertising System.
    <br /> <br />
    <b>Showing Status:</b> In the last ten minutes, your application has been shown to the user at least once through this offer, in search of the suggested keyword or other related phrases. It should be noted that due to the dynamics of the system and the different level of competition on each of the search terms related to the proposed keyword, this does not mean that you always win or you win on exactly the proposed keyword.
    <br /> <br />
    <b>Auction Participant Status:</b> In the last 10 minutes, for all searches on the suggested keyword and other related phrases, your application did not win the auction or none of these keywords were searched during this time. .
    `,
    `
    <b>وضعیت در حال بررسی:</b> کلیدواژه‌ی انتخابی شما توسط سیستم تبلیغات بازار در حال بررسی است.
    <br /><br />
    <b>وضعیت در حال نمایش:</b> در ده دقیقه‌ی گذشته حداقل یکبار برنامه‌ی شما از طریق این پیشنهاد، در جستجوی keyword پیشنهادی یا سایر عبارت‌های مرتبط به آن، به کاربر نشان داده شده است. لازم به ذکر است که با توجه به داینامیک بودن سیستم و متفاوت بودن سطح رقابت روی هر یک از عبارت‌های جستجوی مرتبط به keyword پیشنهادی، این موضوع به معنای همیشه برنده‌شدن شما یا برنده‌‌شدن شما روی دقیقا Keyword پیشنهادی نمی‌باشد.
    <br /><br />
    <b>وضعیت حضور در حراجی:</b> در ۱۰ دقیقه‌ی گذشته و به ازای تمام جستجوهای انجام شده روی keyword پیشنهادی و سایر عبارت‌های مرتبط به آن، برنامه شما در حراجی برنده نشده است یا هیچ‌کدام از این کلیدواژه‌ها در این بازه جستجو نشده‌اند.
    `,
    `
    <b>Pending Status:</b> The keyword of your choice is being reviewed by the Market Advertising System.
    <br /> <br />
    <b>Showing Status:</b> In the last ten minutes, your application has been shown to the user at least once through this offer, in search of the suggested keyword or other related phrases. It should be noted that due to the dynamics of the system and the different level of competition on each of the search terms related to the proposed keyword, this does not mean that you always win or you win on exactly the proposed keyword.
    <br /> <br />
    <b>Auction Participant Status:</b> In the last 10 minutes, for all searches on the suggested keyword and other related phrases, your application did not win the auction or none of these keywords were searched during this time. .
    `,
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_MATCH_TYPE_CONTENT': [
    'After selecting Keyword, with the help of Matching Types, you can access a larger and more specific circle of search terms by users in Bazaar.',
    'پس از انتخاب Keyword، با کمک Matching Typeها، شما می‌توانید به دایره‌‌ی مشخص و بزرگ‌تری از عبارت‌های جست‌وجو شده توسط کاربران در بازار دسترسی داشته باشید',
    'After selecting Keyword, with the help of Matching Types, you can access a larger and more specific circle of search terms by users in Bazaar.',
  ],
  'ADVERTISEMENT.BID.COLUMN_AVG_CPI': [
    'Avg CPI (Rials)',
    'Avg CPI (Rials)',
    'Avg CPI (Rials)',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_AVG_CPI_TITLE': [
    'Average Cost Per Full Install',
    'Average Cost Per Full Install',
    'Average Cost Per Full Install',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_AVG_CPI_CONTENT': [
    'The average price you pay for each complete installation by your user. To calculate this number, we have divided the total cost of each keyword by the number of installations.',
    'میانگین بهایی است که به ازای هر بار نصب کامل در تبلیغ‌تان توسط کاربر پرداخته‌اید. برای محاسبه‌ی این عدد ما هزینه‌ی کلی‌ هر کلیدواژه را تقسیم بر تعداد نصب‌های آن کرده‌ایم.',
    'The average price you pay for each complete installation by your user. To calculate this number, we have divided the total cost of each keyword by the number of installations.',
  ],
  'ADVERTISEMENT.BID.COLUMN_INSTALLATION': [
    'Full Installation',
    'Full Installation',
    'Full Installation',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_TAP_ON_INSTALL_CONTENT': [
    "The number of times a user fully installs app through your ad on the search page or after going to the App Detail page. <br> Full installation, if it's not through the ad and from the search list or other paths , Even though your ad is displayed at the top of the page, it won't count in this section.",
    'نصب کامل (Full Installation) تعداد دفعاتی است که کاربر با دیدن تبلیغ شما در صفحه جستجو یا پس از رفتن به صفحه جزییات برنامه (App Detail)، برنامه شما را کامل نصب کرده است. نصب کامل برنامه اگر از طریق تبلیغ نباشد و از لیست جستجو یا مسیرهای دیگر باشد، حتی با وجود نمایش تبلیغ شما در بالای صفحه، در این بخش شمارش نمی‌شود.',
    "The number of times a user fully installs app through your ad on the search page or after going to the App Detail page. <br> Full installation, if it's not through the ad and from the search list or other paths , Even though your ad is displayed at the top of the page, it won't count in this section.",
  ],
  'ADVERTISEMENT.BID.COLUMN_IMPRESSIONS': [
    'Impressions',
    'Impressions',
    'Impressions',
  ],
  'ADVERTISEMENT.BID.COLUMN_COST': [
    'Cost (Rials)',
    'Cost (Rials)',
    'Cost (Rials)',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_COST_CONTENT': [
    "Cost is the total money spent for a keyword. It's the product of Installation and AVG CPI",
    'Cost مجموع هزینه‌ای است که برای یک keyword خاص پرداخته‌اید. در حقیقت این عدد برابر است با ضرب میزان Installation در Avg CPI',
    "Cost is the total money spent for a keyword. It's the product of Installation and AVG CPI",
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_IMPRESSIONS_CONTENT': [
    'The number of times your ad is displayed in the Bazaar.',
    'تعداد دفعاتی که تبلیغ شما در جستجوی ‌بازار به نمایش درآمده است.',
    'The number of times your ad is displayed in the Bazaar.',
  ],
  'ADVERTISEMENT.BID.COLUMN_CONV_RATE': [
    'Conv. Rate',
    'Conv. Rate',
    'Conv. Rate',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_CONV_RATE_TITLE': [
    'Conversion Rate',
    'Conversion Rate',
    'Conversion Rate',
  ],
  'ADVERTISEMENT.BID.COLUMN_DESC_CONV_RATE_CONTENT': [
    "The result is the number of installs divided by the number of impressions / display ads. In a way, this criterion determines how well your program relates to your chosen Keyword and the users' preferences.",
    'به حاصل تقسیم تعداد نصب‌ها به تعداد اثرگذاری‌ها/نمایش تبلیغات گفته می‌شود. به نوعی این معیار میزان ارتباط برنامه‌ی شما با Keyword انتخاب شده و اقبال کاربران را بیان می‌کند.',
    "The result is the number of installs divided by the number of impressions / display ads. In a way, this criterion determines how well your program relates to your chosen Keyword and the users' preferences.",
  ],
  'ADVERTISEMENT.ENTER_FULL_SCREEN': ['Fullscreen', 'بزرگ‌نمایی', 'Fullscreen'],
  'ADVERTISEMENT.EXIT_FULL_SCREEN': [
    'Exit Fullscreen',
    'کوچک‌نمایی',
    'Exit Fullscreen',
  ],
  'ADVERTISEMENT.REFRESH': ['Refresh', 'بارگذاری مجدد', 'Refresh'],
  'ADVERTISEMENT.BIDS.ACTION_BUTTON': [
    'Edit | Edit 1 keyword | Edit {count} keywords',
    'ویرایش | ویرایش ۱ کلیدواژه | ویرایش {count} کلیدواژه‌ها',
    'Edit | Edit {count} keyword | Edit {count} keywords',
  ],
  'ADVERTISEMENT.BIDS.ACTION_PAUSE': [
    'Pause | Pause 1 keyword | Pause {count} keywords',
    'متوقف کردن | متوقف کردن ۱ کلیدواژه | متوقف کردن {count} کلیدواژه‌',
    'Pause | Pause 1 keyword | Pause {count} keywords',
  ],
  'ADVERTISEMENT.BIDS.ACTION_ACTIVATE': [
    'Activate | Activate 1 keyword | Activate {count} keywords',
    'فعال کردن | فعال کردن ۱ کلیدواژه | فعال کردن {count} کلیدواژه‌',
    'Activate | Activate 1 keyword | Activate {count} keywords',
  ],
  'ADVERTISEMENT.BIDS.ACTION_REMOVE': [
    'Remove | Remove 1 keyword | Remove {count} keywords',
    'حذف کردن | حذف کردن ۱ کلیدواژه | حذف کردن {count} کلیدواژه‌',
    'Remove | Remove 1 keyword | Remove {count} keywords',
  ],
  'ADVERTISEMENT.BIDS.EDIT_SELECTED_BIDS': [
    'Edit price offer of selected bids | Edit price offer of 1 bid | Edit price offer of {count} bids',
    'ویرایش قیمت کلیدواژه‌های انتخاب‌شده | ویرایش قیمت ۱ کلیدواژه | ویرایش قیمت {count} کلیدواژه‌ها ',
    'Edit price offer of selected bids | Edit price offer of 1 ذهی | Edit price offer of {count} bids',
  ],
  'ADVERTISEMENT.BIDS.EDIT_ALL_BIDS': [
    'Edit price offer of all bids',
    'ویرایش قیمت همه',
    'Edit price offer of all bids',
  ],
  'ADVERTISEMENT.BID.EDIT_SUCCESS': [
    'Keyword(s) edited successfully.',
    'کلیدواژه(ها) با موفقیت تغییر یافتند.',
    'Keyword(s) edited successfully.',
  ],
  'ADVERTISEMENT.BID.DELETE_SUCCESS': [
    'Keyword(s) deleted successfully.',
    'کلیدواژه(ها) با موفقیت حذف شدند.',
    'Keyword(s) deleted successfully.',
  ],
  'ADVERTISEMENT.BID.ROUGH_DESC': [
    'The Search Ads system automatically engages you in the auction for similar terms to the one you entered.',
    'سیستم تبلیغات چستچو، به صورت خودکار شما را در حراجی مربوط به عبارت‌های مشابه به عبارتی که وارد کرده‌اید، شرکت می‌دهد.',
    'The Search Ads system automatically engages you in the auction for similar terms to the one you entered.',
  ],
  'ADVERTISEMENT.BID.ROUGH_HEADING': [
    '‌Broad Auctioning',
    'مدل حراجی گسترده',
    '广泛拍卖',
  ],
  'ADVERTISEMENT.BIDSTATS.GENERAL_INFO_TITLE': [
    'General Info',
    'مشخصات کلی',
    '一般信息',
  ],
  'ADVERTISEMENT.BIDSTATS.GENERAL_INFO_DESCRIPTION': [
    'You will see general info in this section.',
    'در این قسمت مشخصات کلی را مشاهده می‌کنید.',
    '您将在本节中看到一般信息。',
  ],
  'ADVERTISEMENT.BIDSTATS.SUCCESS_RATE': [
    'Success Rate in Auctions',
    'درصد برنده شدن حراجی',
    '拍卖成功率',
  ],
  'ADVERTISEMENT.BIDSTATS.STATS_TITLE': ['Statistics', 'آمار', '统计'],
  'ADVERTISEMENT.BIDSTATS.STATS_DESCRIPTION': [
    'You will see statistics in this section.',
    'در این قسمت آمارها را مشاهده می‌کنید.',
    '您将在本节中看到统计数据。',
  ],
  'ADVERTISEMENT.BIDSTATS.STATS.LEGEND': [
    'Keyword General Stats',
    'آمار کلی کلیدواژه',
    'Keyword General Stats',
  ],
  'ADVERTISEMENT.BIDSTATS.STATS.AXIS': ['Count', 'تعداد', '数量'],
  'ADVERTISEMENT.ADD_SINGLE_BID': [
    'Add Single Keyword',
    'افزودن تکی کلیدواژه',
    'Add Single Keyword',
  ],
  'ADVERTISEMENT.ADD_BID': ['Add Keyword', 'افزودن کلیدواژه', 'Add Keyword'],
  'ADVERTISEMENT.ADD_BULK_BID': [
    'Add Bulk Keywords with CSV',
    'افزودن دسته‌ای کلیدواژه با CSV',
    'Add Bulk Keywords with CSV',
  ],
  'ADVERTISEMENT.ADD_BID_BTN': [
    'Add Keyword',
    'افزودن کلیدواژه',
    'Add Keyword',
  ],
  'ADVERTISEMENT.EDIT_ALL_BID_PRICE_OFFER': [
    'Edit The Price Offer Of All Keywords',
    'ویرایش قیمت همه‌ی کلیدواژه‌ها',
    'Edit The Price Offer Of All Keywords',
  ],
  'ADVERTISEMENT.EDIT_SELECTED_BID_PRICE_OFFER': [
    'Edit The Price Offer Of {count} Keywords',
    'ویرایش قیمت برای {count} کلیدواژه',
    '编辑投标',
  ],
  'ADVERTISEMENT.EDIT_BID_BTN': [
    'Edit Keyword',
    'ویرایش کلیدواژه',
    'Edit Keyword',
  ],
  'ADVERTISEMENT.BID.EDIT': ['Edit', 'ویرایش', '编辑'],
  'ADVERTISEMENT.BID.MATCH_TYPE': ['Match Type', 'Match Type', 'Match Type'],
  'ADVERTISEMENT.BID.EXACT_MATCHING_TYPE': ['Exact', 'Exact', 'Exact'],
  'ADVERTISEMENT.BID.BROAD_MATCHING_TYPE': ['Broad', 'Broad', 'Broad'],
  'ADVERTISEMENT.BID.KEYWORD_MATCHING_TYPE': ['Phrase', 'Phrase', 'Phrase'],
  'ADVERTISEMENT.BID.MATCH_TYPE_DESCRIPTION_TITLE': [
    'Match Type Guide',
    'راهنمای Match Type',
    'Match Type Guide',
  ],
  'ADVERTISEMENT.BID.MATCH_TYPE_EXAMPLE_TITLE': [
    'For example, for the word "map"',
    'مثلا برای کلمه «نقشه»',
    'For example, for the word "map"',
  ],
  'ADVERTISEMENT.BID.MATCH_TYPE_BROAD_DESCRIPTION': [
    'Ads may appear in searches related to your keyword. It also has Phrase Match mode.',
    'تبلیغات ممکن است در جستجوهایی که به کلمه‌کلیدی شما مرتبط است نمایش ‌داده شود. ضمن اینکه حالت Phrase Match را درون خود دارد.',
    'Ads may appear in searches related to your keyword. It also has Phrase Match mode.',
  ],
  'ADVERTISEMENT.BID.MATCH_TYPE_BROAD_EXAMPLES': [
    'routing, address, traffic',
    'مسیریابی، آدرس، ترافیک',
    'routing, address, traffic',
  ],
  'ADVERTISEMENT.BID.MATCH_TYPE_EXACT_DESCRIPTION': [
    'Ads may also appear in searches with similar meanings to your entered keyword.',
    'تبلیغات ممکن است در جستجوهایی با معانی مشابه کلمه‌کلیدی وارد شده شما ‌نیز نمایش داده شود.',
    'Ads may also appear in searches with similar meanings to your entered keyword.',
  ],
  'ADVERTISEMENT.BID.MATCH_TYPE_EXACT_EXAMPLES': [
    'map, maps, maaps',
    'مپ، نقشه، نغشه، نقشه‌ها',
    'map, maps, maaps',
  ],
  'ADVERTISEMENT.BID.MATCH_TYPE_KEYWORD_DESCRIPTION': [
    'Ads may also appear in searches that include the meaning of your keyword. Of course, winning the auction will be a condition for its display.',
    'تبلیغات ممکن است در جستجوهایی که معنی کلمه‌کلیدی شما را در بر می‌گیرد ‌هم نمایش داده شود. البته برنده شدن در حراجی شرط نمایش داده شدن آن خواهد بود.',
    'Ads may also appear in searches that include the meaning of your keyword. Of course, winning the auction will be a condition for its display.',
  ],
  'ADVERTISEMENT.BID.MATCH_TYPE_KEYWORD_EXAMPLES': [
    'light map, offline map',
    'نقشه سبک، نقشه آفلاین',
    'light map, offline map',
  ],
  'ADVERTISEMENT.BID.INVALID_MATCHING_TYPE': [
    'Invalid Matching Type',
    'Match Type نامعتبر',
    'Invalid Matching Type',
  ],
  'ADVERTISEMENT.BID.BROAD_DETAIL': [
    'Broad Auctioning`s Keywords',
    'کلیدواژه‌های حراجی گسترده',
    '广义拍卖关键词',
  ],
  'ADVERTISEMENT.BID.BROAD_DETAIL_DESCRIPTION': [
    'You have enabled Broad Auctioning. With Broad Auctioning enabled, you are automatically bidding on the following keywords. You can use the Negative Keywords feature to exclude certain phrases from the list below.',
    'شما حراجی گسترده را فعال کرده‌اید. با فعال بودن حراجی گسترده، شما به صورت خودکار در حراجی عبارات زیر شرکت داده می‌شوید. برای شرکت نکردن در عبارات خاصی از لیست زیر می‌توانید از قابلیت کلمات منفی استفاده کنید.',
    '你已经实现了广泛的拍卖。启用广泛拍卖后,您将自动竞价下列关键字。您可以使用"否定关键字"功能从下面的列表中排除某些短语。',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.TITLE': [
    'Campaign Info',
    'اطلاعات کمپین',
    '活动信息',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.STATUS': ['Status', 'وضعیت', '地位'],
  'ADVERTISEMENT.CAMPAIGN_VIEW.CAMPAIGN_NAME': [
    'Campaign Name',
    'نام کمپین',
    '活动名称',
  ],
  'ADVERTISEMENT.CAMPAIGNS.TYPE': [
    'Campaign Type',
    'نوع کمپین',
    'Campaign Type',
  ],
  'ADVERTISEMENT.CAMPAIGNS.DETAILS': ['Details', 'جزئیات', '详细信息'],
  'ADVERTISEMENT.CAMPAIGN_VIEW.ADD_KEYWORD_HINT_DESCRIPTION': [
    'To complete the created campaign, you need to find and set related keywords.',
    'برای تکمیل کردن کمپین ایجاد شده می‌بایست کلمات کلیدی مرتبط با آن را پیدا و تنظیم کنید.',
    'To complete the created campaign, you need to find and set related keywords.',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_TITLE': [
    'No budget has been allocated for this campaign.',
    'بودجه‌ای به این کمپین اختصاص داده نشده است.',
    'No budget has been allocated for this campaign.',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_ACTION': [
    'Allocate Budget',
    'تخصیص بودجه',
    'Allocate Budget',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.CPI_LIMIT_HINT': [
    'Some of your keywords are less than {limit} Rials and because of this, your campaign will not get install in these words',
    'برخی کلمات کلیدی شما مقداری زیر {limit} ریال دارند و به این علت، در این کلمات کمپین شما نصبی نخواهد گرفت.',
    'Some of your keywords are less than {limit} Rials and because of this, your campaign will not get install in these words',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.CPI_ERROR_LIMIT_HINT': [
    'All your keywords are less than {limit} Rials and it is not possible to run the campaign because of this. Use the campaign edit option to change. ',
    'تمامی کلمات کلیدی شما مقداری زیر {limit} ریال دارند و اجرا شدن کمپین به این علت امکان‌پذیر نیست. برای تغییر از گزینه ویرایش کمپین استفاده کنید.',
    'All your keywords are less than {limit} Rials and it is not possible to run the campaign because of this. Use the campaign edit option to change. ',
  ],
  'ADVERTISEMENT.CAMPAIGNS.SEARCH.CPI_LIMIT_HELP': [
    'With a number below {limit} Rials, the possibility of your installation will be extremely low.',
    'با عدد زیر {limit} ریال، احتمال نصب گرفتن شما به شدت کم خواهد بود.',
    'With a number below {limit} Rials, the possibility of your installation will be extremely low.',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_DESCRIPTION': [
    'You can also refer to your wallet to increase your credit before the budget is allocated.',
    'و همچنین برای افزایش اعتبار خود پیش از تخصیص بودجه می‌توانید به {0} خود رجوع کنید.',
    'You can also refer to your wallet to increase your credit before the budget is allocated.',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_WALLET': [
    'Wallet',
    'کیف پول',
    'Wallet',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.BASIC_INFO': [
    'Campaign Info',
    'اطلاعات پایه',
    '活动信息',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.INFO.TITLE': ['Information', 'اطلاعات', '信息'],
  'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.TITLE': ['Stats', 'آمار', '统计'],
  'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.OVERALL.TITLE': [
    'Overall',
    'آمار کلی',
    '总体统计',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.BUILDER.TITLE': [
    'Design Stats',
    'طراحی آمار',
    '设计统计',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.BUILDER.DESCRIPTION': [
    'In this section, you can check and compare the parameters you want for one or more of your keywords in a given time period.',
    'در این بخش، شما می‌توانید پارامترهای آماری مورد نظرتان را برای یک یا چند کلیدواژه در یک بازه‌ی زمانی مشخص بررسی و مقایسه نمایید.',
    'In this section, you can check and compare the parameters you want for one or more of your keywords in a given time period.',
  ],
  'ADVERTISEMENT.CAMPAIGN.STATS.BUILDER.BID_NAMES': [
    'Enter keyword/keywords names',
    'نام کلیدواژه/کلیدواژه‌ها را وارد کنید',
    'Enter keyword/keywords names',
  ],
  'ADVERTISEMENT.CAMPAIGN.STATS.BUILDER.CHART_TYPE': [
    'Choose chart type',
    'نوع نمودار را انتخاب کنید',
    '选择图表类型',
  ],
  'ADVERTISEMENT.CAMPAIGN.STATS.OVERALL.LEGEND': [
    'Overall Campaign Status',
    'آمار کلی کمپین',
    '整体活动状态',
  ],
  'ADVERTISEMENT.CAMPAIGN.STATS.OVERALL.AXIS': ['Count', 'تعداد', '计数'],
  'ADVERTISEMENT.CAMPAIGN.STATS.OVERALL.AVG_INSTALL_COST.AXIS': [
    'Price (Rials)',
    'قیمت به ریال',
    '价格（里亚尔）',
  ],
  'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.BIDS.TITLE': [
    'Keywords insights',
    'آمار کلیدواژه‌ها',
    'Keywords insights',
  ],
  'ADVERTISEMENT.CAMPAIGN_REPORT.TITLE': [
    'Campaign Report',
    'گزارش کمپین',
    '活动报道',
  ],
  'ADVERTISEMENT.CAMPAIGN_REPORT.TOTAL_BIDS': ['Total', 'جمع کمپین', '总数'],
  'ADVERTISEMENT.CAMPAIGN_REPORT.DESC': [
    'Views and full installations acquired throught this campaign',
    'تعداد نمایش و نصب کامل به دست آمده توسط این کمپین',
    'Views and full installations acquired throught this campaign',
  ],
  'ADVERTISEMENT.CAMPAIGN_REPORT.FILTER': ['Filters', 'فیلتر‌ها', '滤器'],
  'ADVERTISEMENT.CAMPAIGN_REPORT.API_ERROR': [
    'Error creating campaign report',
    'خطای سرور در ایجاد گزارش کمپین',
    '创建活动报告时出错',
  ],
  'ADVERTISEMENT.CAMPAIGN_REPORT.NO_DATA': [
    'No Data.',
    'هیچ داده‌ای یافت نشد.',
    '没有数据',
  ],
  'ADVERTISEMENT.FINANCE.TITLE': ['Finance', 'مالی', '财务'],
  'ADVERTISEMENT.WALLET': [
    'Advertisement Wallet',
    'کیف پول تبلیغات',
    'Advertisement Wallet',
  ],
  'ADVERTISEMENT.BUDGET.TITLE': [
    'Advertisement Budget',
    'بودجه‌ی تبلیغات',
    '广告预算',
  ],
  'ADVERTISEMENT.BUDGET.NO_CREDIT': [
    'You have no credit.',
    'اعتبار تبلیغات شما خالی است.',
    '您没有信用。',
  ],
  'ADVERTISEMENT.BUDGET.DEVELOPER_CREDIT': [
    'Remaining Credit',
    'اعتبار باقی‌مانده',
    '剩余信贷',
  ],
  'ADVERTISEMENT.BUDGET.LOADING': [
    'Loading credit info...',
    'در حال بارگذاری اعتبار تبلیغات...',
    '加载信用信息',
  ],
  'ADVERTISEMENT.BUDGET.CHARGE_CREDIT': [
    'Charge Credit',
    'افزایش اعتبار',
    '赊账',
  ],
  'ADVERTISEMENT.RECEIPT.GATEWAY': [
    'Credit Charge',
    'افزایش اعتبار',
    'Credit Charge',
  ],
  'ADVERTISEMENT.RECEIPT.GATEWAY_REFUND': [
    'Credit Refund',
    'بازگشت اعتبار',
    'Credit Refund',
  ],
  'ADVERTISEMENT.RECEIPT.BANK_TRANSFER': [
    'Bank Transfer',
    'پرداخت بانکی',
    'Bank Transfer',
  ],
  'ADVERTISEMENT.RECEIPT.CHEQUE': ['Cheque', 'چک', 'Cheque'],
  'ADVERTISEMENT.FINANCE.TRANSACTIONS': ['Transactions', 'تراکنش‌ها', '交易'],
  'ADVERTISEMENT.FINANCE.INVOICE': [
    'Advertisement Invoice',
    'فاکتور تبلیغات',
    '广告发票',
  ],
  'ADVERTISEMENT.FINANCE.INVOICE_DESC': [
    '',
    'نظر به رعایت مفاد ماده ۱۶۹ قانون مالیات‌های مستقیم مبلغ فروش هر ماه که در پنل توسعه دهندگان قابل رویت می‌باشد، در گزارشات خرید و فروش فصلی شرکت آوای همراه هوشمند هزار دستان درج می‌گردد.\nدر این خصوص ضروریست کلیه توسعه دهندگان مبالغ خرید ماهانه خود را از پنل مذکور به صورت ماهانه دریافت و در گزارشات خرید و فروش فصلی درج نمایند.',
    '',
  ],
  'ADVERTISEMENT.FINANCE.INVOICE.SEND_TO_EMAIL': [
    'Send Invoice to Email',
    'ارسال فاکتور به ایمیل',
    'Send Invoice to Email',
  ],
  'ADVERTISEMENT.FINANCE.SEND_TO_EMAIL.SUCCESSFUL': [
    'The requested invoices will be sent to your email address in a few minutes.',
    'فاکتور فروش درخواستی در طی چند دقیقه آینده به ایمیل شما ارسال خواهد شد.',
    'The requested invoices will be sent to your email address in a few minutes.',
  ],
  'ADVERTISEMENT.FINANCE.SALES_FILE.SEND_TO_EMAIL': [
    'Send Sales File to Email',
    'ارسال فایل به ایمیل',
    'Send Sales File to Email',
  ],
  'ADVERTISEMENT.TRANSACTIONS.TOTAL_AMOUNT': [
    'Total Amount',
    'مبلغ کل',
    'Total Amount',
  ],
  'ADVERTISEMENT.TRANSACTIONS.CHARGE_AMOUNT': [
    'Charge Amount',
    'مبلغ شارژ',
    'Charge Amount',
  ],
  'ADVERTISEMENT.TRANSACTIONS.PURCHASE_TIME': [
    'Purchase Time',
    'زمان',
    '购买时间',
  ],
  'ADVERTISEMENT.TRANSACTIONS.ORDER_ID': ['Order ID', 'کد رهگیری', '订单号'],
  'ADVERTISEMENT.TRANSACTIONS.STATUS': ['Status', 'وضعیت', '状态'],
  'ADVERTISEMENT.TRANSACTIONS.TYPE': [
    'Transaction Type',
    'نوع پرداختی',
    'Transaction Type',
  ],
  'ADVERTISEMENT.TRANSACTIONS.NO_DATA': [
    'No Data.',
    'هیچ تراکنشی یافت نشد.',
    '没有数据',
  ],
  'ADVERTISEMENT.TRANSACTIONS.API_ERROR': [
    'Error getting transactions list',
    'خطا در دریافت تراکنش‌ها',
    '获取事务列表时出错',
  ],
  'ADVERTISEMENT.TRANSACTIONS.EMAIL_NOTICE': [
    'A copy of the factor has been sent to your email.',
    'یک کپی از فاکتور به ایمیل شما ارسال شده است.',
    'A copy of the factor has been sent to your email.',
  ],
  'ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_FACTOR_BODY': [
    'Click the button below to download a copy of your payment details right now.',
    'با کلیک روی دکمه زیر، همین الان یک نسخه از جزئیات پرداخت خود را دانلود کنید.',
    'Click the button below to download a copy of your payment details right now.',
  ],
  'ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_FACTOR_SUCCESSFUL': [
    'Factor downloaded successfully.',
    'فاکتور با موفقیت دریافت شد.',
    'Factor downloaded successfully.',
  ],
  'ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_INVOICE_FACTOR': [
    'Download Factor',
    'دریافت فاکتور',
    'Download Factor',
  ],
  'ADVERTISEMENT.BUDGET.CHARGE_IT': [
    'Go to payment portal',
    'انتقال به درگاه پرداخت',
    '转到付款门户',
  ],
  'ADVERTISEMENT.BUDGET.TAX': ['Tax', 'مالیات بر ارزش افزوده', 'Tax'],
  'ADVERTISEMENT.BUDGET.TOTAL_CHARGE': [
    'The total payable amount',
    'مبلغ کل قابل پرداخت',
    'The total payable amount',
  ],
  'ADVERTISEMENT.BUDGET.SHORT_CUT_ONE': [
    '5 Million Rials',
    '۵ میلیون ریال',
    '5 Million Rials',
  ],
  'ADVERTISEMENT.BUDGET.SHORT_CUT_TWO': [
    '10 Million Rials',
    '۱۰ میلیون ریال',
    '10 Million Rials',
  ],
  'ADVERTISEMENT.BUDGET.SHORT_CUT_THREE': [
    '450 Million Rials',
    '۴۵۰ میلیون ریال',
    '450 Million Rials',
  ],
  'ADVERTISEMENT.BUDGET.MAX_CHARGE_AMOUNT_WARNING': [
    'Note that the maximum amount of credit increase in each attempt is 450 million rials.',
    'توجه داشته باشید که حداکثر مبلغ افزایش اعتبار در هر مرحله ۴۵۰ میلیون ریال می‌باشد.',
    'Note that the maximum amount of credit increase in each attempt is 450 million rials.',
  ],
  'ADVERTISEMENT.BUDGET.BUDGET_MIN_ERROR': [
    'The amount entered must be greater than 5,000,000 Rials.',
    'مبلغ وارد شده باید بیشتر از ۵,۰۰۰,۰۰۰ ریال باشد.',
    'The amount entered must be greater than 5,000,000 Rials.',
  ],
  'ADVERTISEMENT.BUDGET.BUDGET_MAX_ERROR': [
    'The amount entered must be less than 450,000,000 Rials.',
    'مبلغ وارد شده باید کمتر از ۴۵۰,۰۰۰,۰۰۰ ریال باشد.',
    'The amount entered must be less than 450,000,000 Rials.',
  ],
  'ADVERTISEMENT.BUDGET.BUDGET_PLACEHOLDER': [
    'Amount desired',
    'مبلغ دلخواه',
    'Amount desired',
  ],
  'ADVERTISEMENT.BUDGET.FINAL_CHARGE_AMOUNT': [
    'Credit Amount',
    'مبلغ شارژ',
    '贷方金额',
  ],
  'ADVERTISEMENT.BUDGET.AMOUNT': ['Charge amount:', 'مبلغ شارژ:', '收费金额：'],
  'ADVERTISEMENT.BUDGET.AMOUNT_WITH_DESCRIPTION': [
    'Charge amount: <small>Should be multiple of one hundred thousand Rials.</small>',
    'مبلغ شارژ: <small>بایستی مضربی از صد هزار ریال باشد.</small>',
    '收费金额：<small>应该是十万里亚尔的倍数。</small>',
  ],
  'ADVERTISEMENT.BUDGET.CREDIT_API_ERROR': [
    'Error getting credit',
    'خطا در دریافت اطلاعات اعتبار',
    '获取学分时出错',
  ],
  'ADVERTISEMENT.BID.CONVERSION.TIP': [
    'Full installation over impression ratio',
    'نسبت نصب کامل به نمایش',
    'Full installation over impression ratio',
  ],
  'ADVERTISEMENT.BID.SUCCESS_RATE': [
    'Success Rate in Auctions',
    'درصد برنده شدن در حراجی',
    '拍卖成功率',
  ],
  'ADVERTISEMENT.BID.ORDER_BY': ['Order By', 'ترتیب نمایش', '排序依据'],
  'ADVERTISEMENT.BID.SORT_BY': ['Sort By', 'مرتب‌سازی بر اساس', '排序依据'],
  'ADVERTISEMENT.BID.ASCENDING': ['Ascending', 'صعودی', '提升'],
  'ADVERTISEMENT.BID.DESCENDING': ['Descending', 'نزولی', '下降'],
  'ADVERTISEMENT.BID.TOTAL_COST': ['Conversion Rate', 'مجموع هزینه', '转换率'],
  'ADVERTISEMENT.STATS.CAMPAIGN.TITLE': [
    'Overall Insights',
    'وضعیت کلی',
    '全面洞察',
  ],
  'ADVERTISEMENT.STATS.BIDS.TITLE': [
    'Keywords Insights',
    'عملکرد کلیدواژه‌ها',
    'Keywords Insights',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.TITLE': [
    'Search Terms',
    'عبارات جستجو شده',
    'Search Terms',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.SEARCH_TERM_COLUMN': [
    'Search Term',
    'Search Term',
    'Search Term',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.ADD_KEYWORD_TITLE': [
    'Add keyword from search terms',
    'افزودن کلیدواژه از عبارات جستجو شده توسط کاربران',
    'Add keyword from search terms',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.DESCRIPTION': [
    'In this section you can see the search terms that match one of your keywords.',
    'در این قسمت شما می‌توانید عبارت‌هایی جست‌و‌جو شده که با یکی از کلیدواژه‌های شما تطبیق خورده رو مشاهده کنید.',
    'In this section you can see the search terms that match one of your keywords.',
  ],
  'ADVERTISEMENT.BIDS.SEARCH_SEARCH_TERMS': [
    'Search within search terms',
    'جستجو در میان عبارات جستجو شده',
    'Search within search terms',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.NO_KEYWORD_SELECTED': [
    'No keyword selected',
    'عبارتی انتخاب نشده',
    'No keyword selected',
  ],
  'ADVERTISEMENT.ADD_TO_KEYWORDS': [
    'Add to Keywords',
    'افزودن به کلیدواژه‌ها',
    'Add to Keywords',
  ],
  'ADVERTISEMENT.ADD_TO_NEGATIVE_KEYWORDS': [
    'Add to Negative Keywords',
    'افزودن به کلیدواژه‌های منفی',
    'Add to Negative Keywords',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.INSTALL_PRICE_COLUMN': [
    'Install Price',
    'Install Price',
    'Install Price',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.INSTALL_PRICE_COLUMN_DESCRIPTION': [
    'The total price you paid to win this keyword.',
    'مجموع قیمتی که برای برنده شدن در این عبارت پرداخت کردید.',
    'The total price you paid to win this keyword.',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.ADD_BIDS_SUCCESS': [
    '"{keyword}" was added with the conditions and the price given. | "{keywords}" were added with the conditions and the price given.',
    '‌کلیدواژه‌های «{keywords}» با شرایط و قیمت تعیین شده با موفقیت اضافه شد. | کلیدواژه‌ی «{keyword}» با شرایط و قیمت تعیین شده با موفقیت اضافه شد.',
    '"{keyword}" was added with the conditions and the price given. | "{keywords}" were added with the conditions and the price given.',
  ],
  'ADVERTISEMENT.SEARCH_TERMS.ADD_NEGATIVE_BIDS_SUCCESS': [
    '"{keyword}" was added. | "{keywords}" were added.',
    '‌کلیدواژه‌های منفی «{keywords}» با موفقیت اضافه شد. | کلیدواژه‌ی منفی «{keyword}» با موفقیت اضافه شد.',
    '"{keyword}" was added. | "{keywords}" were added.',
  ],
  'ADVERTISEMENT.MAIL_SERVICE': [
    'Setup Email Notifications',
    'تنظیم ایمیل اطلاع‌رسانی',
    'Setup Email Notifications',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.NOTIFICATION_MIN_ERROR': [
    'Select at least one notification.',
    'حداقل یک اعلان انتخاب نمایید.',
    'Select at least one notification.',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.DESCRIPTON': [
    "You haven't subscribed to any notifications yet. Click the button below and add the desired email for each email address to set what information to send.",
    'تا کنون اعلانی را عضو نشده‌اید. با کلیک روی دکمه زیر و اضافه کردن ایمیل مورد نظر برای هر آدرس ایمیل تنظیم کنید چه اطلاعاتی ارسال گردد.',
    "You haven't subscribed to any notifications yet. Click the button below and add the desired email for each email address to set what information to send.",
  ],
  'ADVERTISEMENT.MAIL_SERVICE.NEW_NOTIFICATION_BUTTON': [
    'Create a new notification',
    'ایجاد اعلان جدید',
    'Create a new notification',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.SEARCH_INPUT_PLACEHOLDER': [
    'Search the mailing list',
    'جستجو در لیست ایمیل‌ها',
    'Search the mailing list',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.EMAIL_COLUMN': [
    'Email Address',
    'آدرس ایمیل',
    'Email Address',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.STATUS_COLUMN': [
    'Email Receipt Status',
    'وضعیت دریافت ایمیل',
    'Email Receipt Status',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.ACTION_COLUMN': ['Action', 'عملیات', 'Action'],
  'ADVERTISEMENT.MAIL_SERVICE.EDIT_NOTIFICATION_TITLE': [
    'Edit email items',
    'ویرایش موارد ارسال ایمیل',
    'Edit email items',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.ADD_NOTIFICATION_TITLE': [
    'Select items to send email',
    'انتخاب موارد ارسال ایمیل',
    'Select items to send email',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.NIGHTLY_NOTIFICATIONS_DESCRIPTION': [
    'The emails marked with the subject of the nightly will be sent to you cumulatively and only one general case.',
    'ایمیل‌های مشخص شده با موضوع شبانه به صورت تجمعی و تنها یک مورد کلی برای شما ارسال خواهد شد.',
    'The emails marked with the subject of the nightly will be sent to you cumulatively and only one general case.',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.GENERAL_NOTIFICATIONS': [
    'General Notifications',
    'اعلان‌های عمومی',
    'General Notifications',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.GENERAL_MONTHLY_NOTIFICATION': [
    'Monthly newsletter of new features or advertisement panel changes',
    'خبرنامه‌ ماهانه ویژگی های جدید یا تغییرات پنل تبلیغات',
    'Monthly newsletter of new features or advertisement panel changes',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.FINANCIAL_NOTIFICATIONS': [
    'Financial Notifications',
    'اعلان‌های مالی',
    'Financial Notifications',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.FINANCIAL_END_BUDGET_NOTIFICATION': [
    'Receive an email with {0} of the campaign budget remaining',
    'دریافت ایمیل {0} ریال مانده به اتمام بودجه کمپین',
    'Receive an email with {0} of the campaign budget remaining',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.FINANCIAL_NIGHTLY_NOTIFICATION': [
    'Receive overnight emails on campaign budgets and budget balances (nightly)',
    'دریافت ایمیل شبانه وضعیت بودجه مصرفی کمپین‌ها و مانده بودجه (شبانه)',
    'Receive overnight emails on campaign budgets and budget balances (nightly)',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.CAMPAIGN_MANAGEMENT_NOTIFICATIONS': [
    'Campaign Management Notifications',
    'اعلان‌های مدیریت کمپین‌ها',
    'Campaign Management Notifications',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.CAMPAIGN_STOP_ALERTS': [
    'Receive campaign stop emails',
    'دریافت ایمیل توقف کمپین‌ها',
    'Receive campaign stop emails',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.CAMPAIGN_KEYWORD_RELATED': [
    'Receive emails related to changes in keywords (nightly)',
    'دریافت ایمیل‌های مربوط به تغییرات در کلیدواژه‌ها (شبانه)',
    'Receive emails related to changes in keywords (nightly)',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.CAMPAIGN_MANAGEMENT_ANALYZE_NOTIFICATION': [
    'Receive system guidance email to improve campaign productivity (Automatic campaign analysis by Bazaar)',
    '(دریافت ایمیل راهنمایی سیستمی بهبود بهره‌وری کمپین (آنالیز اتوماتیک کمپین توسط بازار',
    'Receive system guidance email to improve campaign productivity (Automatic campaign analysis by Bazaar)',
  ],
  'ADVERTISEMENT.MAIL_SERVICE.TO_BE_SENT_EMAIL_TITLE': [
    'Enter an email in the box above to send the above selected items continuously at the specified time:',
    'ایمیلی را در کادر روبرو وارد کنید تا موارد انتخاب شده‌ی بالا در زمان مشخص شده به صورت پیوسته ارسال گردد:',
    'Enter an email in the box above to send the above selected items continuously at the specified time:',
  ],
  'ADVERTISEMENT.BULK_IMPORT.DROPPABLE_DESCRIPTION': [
    'Drag your CSV file into the box or upload it via the button below and wait for the data processing to list the keywords. Note that the file encoding must be UTF-8.',
    'فایل CSV خود را درون کادر بکشید یا از طریق دکمه زیر آپلود کرده و منتظر پردازش اطلاعات برای لیست کردن کلیدواژه‌ها باشید. توجه کنید که Encoding فایل باید UTF-8 باشد.',
    'Drag your CSV file into the box or upload it via the button below and wait for the data processing to list the keywords. Note that the file encoding must be UTF-8.',
  ],
  'ADVERTISEMENT.BULK_IMPORT.BUTTON_TEXT': [
    'Upload from PC',
    'آپلود از روی کامپیوتر',
    'Upload from PC',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PROCESS_PROGRESS': [
    'Uploading {fileName}',
    'در حال پردازش فایل {fileName}',
    'Uploading {fileName}',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PROCESS_ERROR': [
    'An error occured in processing file.',
    'مشکلی هنگام پردازش فایل به وجود آمد.',
    'An error occured in processing file.',
  ],
  'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_TITLE': [
    'Select the keyword column',
    'انتخاب ستون کلیدواژه‌ها',
    'Select the keyword column',
  ],
  'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_DESCRIPTION': [
    'In this step you have to select the column in which you entered your keywords to set the price for them in the next step.',
    'در این مرحله شما باید ستونی که کلیدواژه‌های خود را در آن وارد کرده اید را انتخاب کنید تا در مرحله بعدی برای آنها قیمت تعیین کنید.',
    'In this step you have to select the column in which you entered your keywords to set the price for them in the next step.',
  ],
  'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_NEXT_STEP': [
    'Next step (pricing)',
    'مرحله بعد(تعیین قیمت)',
    'Next step (pricing)',
  ],
  'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_FOUND_COLUMNS': [
    '{count} column found | {count} column found | {count} columns found',
    '{count} ستون پیدا شده',
    '{count} column found | {count} column found | {count} columns found',
  ],
  'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_SELECTED_COLUMN': [
    'Column selected',
    'ستون انتخاب شده',
    'Column selected',
  ],
  'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_SELECT_COLUMN': [
    'Select column',
    'انتخاب این ستون',
    'Select column',
  ],
  'ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_COLUMN_TITLE': [
    'Column {name}',
    'ستون {name}',
    'Column {name}',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PREV_STEP': [
    'Previous step',
    'مرحله قبل',
    'Previous step',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PRICING_WARNING': [
    'You must specify a price and a Match Type for all of the above keywords.',
    'برای فعال شدن دکمه ذخیره باید برای تمامی کلیدواژه‌های بالا، قیمت و Match Type تعیین کنید.',
    'You must specify a price and a Match Type for all of the above keywords.',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PRICING_TITLE': [
    'Determining the price of keywords',
    'تعیین قیمت کلیدواژه‌ها',
    'Determining the price of keywords',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PRICING_DESCRIPTION': [
    'According to the uploaded CSV the following keywords were found, in the table below select and save the price and Match Type for them.',
    'با توجه به CSV آپلود شده کلیدواژه‌های زیر یافت شد، در جدول زیر برای آنها قیمت و Match Type انتخاب و ذخیره کنید.',
    'According to the uploaded CSV the following keywords were found, in the table below select and save the price and Match Type for them.',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PRICING_SET_PRICE': [
    'Price of Each Keyword',
    'قیمت هر کلیدواژه',
    'Price of Each Keyword',
  ],
  'ADVERTISEMENT.BULK_IMPORT.PRICING_MATCH_TYPR': [
    'Choose Match Type',
    'انتخاب Match Type',
    'Choose Match Type',
  ],
  'ADVERTISEMENT.BULK_IMPORT.SPECIFY_SELECTED_PROPERTIES': [
    'Specify Match Type and Price of Selected Keywords',
    'تعیین قیمت و Match Type کلیدواژه‌های انتخابی',
    'Specify Match Type and Price of Selected Keywords',
  ],
  'ADVERTISEMENT.BULK_IMPORT.REMOVE_SELECTED_KEYWORDS': [
    'Remove Selected Keywords',
    'حذف کلیدواژه‌های انتخاب شده از لیست',
    'Remove Selected Keywords',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_STATE.F': ['Failed', 'مردود', '失败'],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_STATE.S': [
    'Successful',
    'تأیید',
    '成功',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_STATE.N': [
    'Not Checked',
    'بررسی‌نشده',
    '未检查',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_STATE.W': [
    'Tax Invoice to Be Uploaded',
    'نیازمند آپلود فاکتور',
    '要上载的税务发票',
  ],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_TYPE.R': ['Refund', 'عودت', '退款'],
  'FINANCE.SETTLEMENT_TAX_HISTORY.INVOICE_TYPE.P': ['Purchase', 'خرید', '购买'],
  'VALIDATION.URL_IS_INVALID': [
    'URL is invalid',
    'لینک وارد شده به فرمت صحیح نمی باشد.',
    'URL无效',
  ],
  'UNKNOWN_ERROR': ['Uknown Error', 'خطای نامعلوم', '未知错误'],
  'ERROR': ['Error', 'خطا', 'Error'],
  'ABORTED_ERROR': ['Request canceled', 'درخواست لغو شد', 'Request canceled'],
  'UNKNOWN': ['Uknown', 'نامعلوم', 'Uknown'],
  'EXIT': ['Exit', 'خروج', '离去'],
  'CONFIRM': ['Confirm', 'تأیید', '确认'],
  'REDIRECTING_TO_BANK_GATEWAY': [
    'Redirecting to the bank gateway ...',
    'در حال انتقال به درگاه پرداخت ...',
    'Redirecting to the bank gateway ...',
  ],
  'NOTIFICATIONS_AREA.TITLE': ['Notifications', 'اعلامیه‌ها', 'Notifications'],
  'NOTIFICATIONS_AREA.API_ERROR': [
    'Error fetching notifications',
    'خطا در دریافت اعلامیه‌ها',
    'Error fetching notifications',
  ],
  'NOTIFICATIONS_AREA.EMPTY': [
    'You have no notification',
    'شما اعلامیه جدیدی ندارید',
    'You have no notification',
  ],
  'ADVERTISEMENT.BASIC_ADS_CAMPAINGS_LIST_TITLE': [
    'Smart Ads',
    'تبلیغات هوشمند',
    'Smart Ads',
  ],
  'ADVERTISEMENT.CAMPAIGNS_LIST.BASIC.TITLE': [
    '"Smart Ads" Campaigns',
    'کمپین‌‌های «تبلیغات هوشمند»',
    '"Smart Ads" Campaigns',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC.INSTALLS_COUNT': [
    'Installs count',
    'تعداد نصب',
    '安装数',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC.AVERAGE_INSTALL_PRICE': [
    'Average install price',
    'میانگین قیمت نصب',
    'Average install price',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC.TARGETED_CPI': [
    'Average bid price for each full installation (Rials)',
    'قیمت متوسط هر نصب کامل (ریال)',
    'Average bid price for each full installation (Rials)',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC.DOESNT_HAVE_TRACKER': [
    'Not set',
    'تنظیم‌نشده',
    'Not set',
  ],
  'ADVERTISEMENT.CAMPAIGNS.STOPPED': ['Stopped', 'متوقف شده', 'Stopped'],
  'ADVERTISEMENT.BASIC_ADS.STATS.PAYMENT_PER_INSTALL': [
    'Rial per install',
    'ریال پرداخت به ازای نصب',
    'Rial per install',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC.TRACKER_HELP': [
    'Please enter your click Tracker link',
    'لطفاً لینک مربوط به کلیک Tracker خود را قرار دهید.',
    'Please enter your click Tracker link',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.BASIC': [
    'Smart Ads',
    'تبلیغات هوشمند',
    'Smart Ads',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_BASIC': [
    'Create "Smart" Campaign',
    'ساخت کمپین هوشمند',
    'Create "Smart" Campaign',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_BASIC.STEPS.SET_PRICE': [
    'Set price',
    'تنظیم قیمت',
    'Set price',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_BASIC.ENABLE_DISCOVERY_ADS': [
    'Use the capacity of all the advertising spaces available in the market to display the ad and install it.',
    'از ظرفیت تمام جایگاه‌های تبلیغاتی موجود در بازار برای نمایش آگهی و نصب استفاده شود.',
    'Use the capacity of all the advertising spaces available in the market to display the ad and install it.',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_BASIC.NEXT_STEP': [
    'Next step',
    'مرحله بعد',
    'Next step',
  ],
  'ADVERTISEMENT.NEW_CAMPAIGN_BASIC.ADD_CAMPAIGN': [
    'Create Campaign',
    'ساخت کمپین',
    'Create Campaign',
  ],
  'ADVERTISEMENT.BASIC.UPDATE_CAMPAIGN_SUCCESS': [
    'Edited successfully.',
    'با موفقیت تغییر یافت.',
    'Edited successfully.',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC_ADS_‌CHART_TITLE': [
    'Smart Ads Installation Rates',
    'وضعیت نصب تبلیغات هوشمند',
    'Smart Ads Installation Rates',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC_ADS_INSTALL_STATS': [
    'Campaign Installs',
    'تعداد نصب کمپین',
    'Campaign Installs',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC_ADS_AVERAGE_INSTALL_STATS': [
    'Campaign Average Daily Installs',
    'میانگین نصب روزانه کمپین',
    'Campaign Average Daily Installs',
  ],
  'ADVERTISEMENT.CAMPAIGNS.BASIC_ADS.STATS_RANGE_ALL': [
    'From the beginning',
    'از آغاز کمپین',
    'From the beginning',
  ],
  'ADVERTISEMENT.CHOOSE_CAMPAIGN.BASIC_DESCRIPTION': [
    'Using artificial intelligence, this campaign increases the effectiveness of advertising and reduces costs, and automatically provides the best position to be seen.',
    'این کمپین با استفاده از هوش مصنوعی، کارآیی تبلیغات را بالا می‌برد و هزینه‌ها را کاهش می‌دهد و به صورت خودکار بهترین جایگاه را برای دیده شدن فراهم می‌کند.',
    'Using artificial intelligence, this campaign increases the effectiveness of advertising and reduces costs, and automatically provides the best position to be seen.',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.IMPACT_RATE_TO_INSTALL': [
    'Impact rate to install',
    'نرخ تاثیرگذاری به نصب',
    'Impact rate to install',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.IMPACT_RATE_TO_VISIT': [
    'Impact rate to visit',
    'نرخ تاثیرگذاری به بازدید',
    'Impact rate to visit',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.VISIT_RATE_TO_DOWNLOAD': [
    'Visit rate to download',
    'نرخ بازدید به دانلود',
    'Visit rate to download',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.DOWNLOAD_RATE_TO_INSTALL': [
    'Download rate to install',
    'نرخ دانلود به نصب',
    'Download rate to install',
  ],
  'YOU': ['You', 'شما', 'You'],
  'AVERAGE': ['Average', 'میانگین', 'Average'],
  'ADVERTISEMENT.DISCOVERY_ADS.YOUR_SOFTWARE_AVERAGE': [
    'Average of your software',
    'میانگین نرم‌افزار شما',
    'Average of your software',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.IMPRESSION': [
    'Impression',
    'اثرگذاری',
    'Impression',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.VISIT': ['Visit', 'بازدید', 'Visit'],
  'ADVERTISEMENT.DISCOVERY_ADS.DOWNLOAD': ['Download', 'دانلود', 'Download'],
  'ADVERTISEMENT.DISCOVERY_ADS.INSTALL': ['Install', 'نصب', 'Install'],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DOWNLOAD_RATE_TO_INSTALL': [
    'Ways to improve the download rate to install',
    'راهکارهای بهبود نرخ دانلود به نصب',
    'Ways to improve the download rate to install',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.IMPACT_RATE_TO_VISIT': [
    'Ways to improve the impact rate to visit',
    'راهکارهای بهبود نرخ تاثیرگذاری به بازدید',
    'Ways to improve the impact rate to visit',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.VISIT_RATE_TO_DOWNLOAD': [
    'Ways to improve the visit rate to download',
    'راهکار های بهبود نرخ بازدید به دانلود',
    'Ways to improve the visit rate to download',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_LOGO.TITLE': [
    'Change logo',
    'تغییر لوگو',
    'Change logo',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_LOGO.DESCRIPTION': [
    'Your logo is the first image that the user notices in the ad. If you have a higher quality or more attractive one, change your logo',
    'لوگوی شما اولین تصویری است که کاربر در تبلیغات به آن توجه می‌کند. اگر لوگوی با کیفیت‌تر یا جذاب‌تری دارید، لوگوی خود را تغییر دهید.',
    'Your logo is the first image that the user notices in the ad. If you have a higher quality or more attractive one, change your logo',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_NAME.TITLE': [
    'Change application title',
    'تغییر عنوان برنامه',
    'Change application title',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_NAME.DESCRIPTION': [
    'Your application name may not convey its usage properly to users. If so, you can rename your application',
    'ممکن است نام برنامه‌ی شما به خوبی رساننده‌ی کاربرد آن به کاربران نباشد. اگر این طور است، می‌توانید نام برنامه‌ی خود را تغییر دهید.',
    'Your application name may not convey its usage properly to users. If so, you can rename your application',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DESCRIPTION_IN_NAME.TITLE': [
    'Change application title',
    'تغییر عنوان برنامه',
    'Change application title',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DESCRIPTION_IN_NAME.DESCRIPTION': [
    'Some apps give users a brief description of their usage in front of their name. If you are new to the app, this might be a good idea for you too',
    'برخی اپلیکیشن‌ها، در جلوی نام خود توضیح کوتاهی از کاربری خود به کاربران می‌دهند. اگر برنامه جدیدی هستید، شاید این کار برای شما هم خوب باشد.',
    'Some apps give users a brief description of their usage in front of their name. If you are new to the app, this might be a good idea for you too',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.FIRST_IMAGE.DESCRIPTION': [
    "The first image among the images of the program has the most impact and durability in the user's memory. Make sure that the most attractive image of your application is in the first row of the image display",
    'تصویر اول در بین تصاویر برنامه، بیشترین تاثیر و ماندگاری در حافظه‌ی کاربر را دارد. مطمئن شوید که جذاب‌ترین تصویر برنامه شما، در اول صف نمایش تصاویر قرار دارد.',
    "The first image among the images of the program has the most impact and durability in the user's memory. Make sure that the most attractive image of your application is in the first row of the image display",
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.FIRST_IMAGE.TITLE': [
    'Change images',
    'تغییر تصاویر',
    'Change images',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DECREASE_SIZE': [
    'The smaller the size of your application, the more likely it is that the user will complete the download and installation process. Try to make your application available to users in the smallest possible size',
    'هر چقدر حجم برنامه شما کمتر باشد، احتمال اینکه کاربر به طور کامل پروسه دانلود و نصب آن را طی کند، بیشتر است. سعی کنید برنامه خود را در کوچک‌ترین حجم ممکن در اختیار کاربران قرار دهید',
    'The smaller the size of your application, the more likely it is that the user will complete the download and installation process. Try to make your application available to users in the smallest possible size',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_DESCRIPTION.TITLE': [
    'Change application description',
    'تغییر متن توضیحات برنامه',
    'Change application description',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_DESCRIPTION.DESCRIPTION': [
    'Compare the description of your application with the description of some of the top applications in the country. Optimizing even one sentence in the description will make a big difference in the number of your daily installations',
    'توضیحات برنامه‌ی خود را با توضیحات چند برنامه‌ی برتر کشور مقایسه کنید. بهینه‌سازی حتی یک جمله در توضیحات هم تغییر بزرگی در تعداد نصب روزانه‌ی شما به وجود خواهد آورد.',
    'Compare the description of your application with the description of some of the top applications in the country. Optimizing even one sentence in the description will make a big difference in the number of your daily installations',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_IMAGES.TITLE': [
    'Change application images',
    'تغییر عکس‌های صفحه توضیحات برنامه',
    'Change application images',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_IMAGES.DESCRIPTION': [
    'The first thing a user reviews about any new app is the screenshots of the app description. The most attractive images for users are the edited images including screenshots along with short descriptions.',
    'اولین موضوعی که کاربر در مورد هر برنامه‌ی جدید بررسی می‌کند، تصاویر صفحه‌ی توضیحات برنامه است. جذاب‌ترین تصاویر برای کاربران، تصاویر ادیت شده شامل اسکرین‌شات در کنار توضیحات کوتاه است.',
    'The first thing a user reviews about any new app is the screenshots of the app description. The most attractive images for users are the edited images including screenshots along with short descriptions.',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.ASNWER_COMMENTS.TITLE': [
    'Reply comments',
    'پاسخ به نظرات کاربران',
    'Reply comments',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.HINTS.ASNWER_COMMENTS.DESCRIPTION': [
    "Pay attention to your users' opinions and give appropriate answers to users who are dissatisfied with your program. Negative feedback seriously reduces the number of times you install ads per day",
    'به نظرات کاربران خود توجه کنید و پاسخ شایسته به کاربرانی که از برنامه‌ی شما ناراضی بوده‌اند بدهید. نظرات منفی تعداد نصب روزانه‌ی شما از تبلیغات را به طور جدی کاهش می‌دهد.',
    "Pay attention to your users' opinions and give appropriate answers to users who are dissatisfied with your program. Negative feedback seriously reduces the number of times you install ads per day",
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.OVERAL_ACTIVE_INSTALLS_STATS': [
    'Status of active installs',
    'وضعیت کلی نصب‌های فعال',
    'Status of active installs',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.CITIES_TABLE_TITLE': [
    'Geographical stats',
    'مشخصات جغرافیایی',
    'Geographical stats',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.PERCENTAGE': [
    'Percent of total',
    'درصد از کل',
    'Percent of total',
  ],
  'ADVERTISEMENT.DISCOVERY_ADS.TOTAL_INSTALL_COUNT': [
    'Total number of installs',
    'تعداد کل نصب',
    'Total number of installs',
  ],
  'APP.IAB.TRIAL_SUBSCRIPTION': [
    'Trial Subscription',
    'اشتراک آزمایشی',
    'Trial Subscription',
  ],
  'APP.IAB.TRIAL_PERIOD_IN_DAYS': [
    'Trial subscription period',
    'مدت اشتراک آزمایشی به روز',
    'Trial subscription period',
  ],
  'APP.IAB.ACTIVATE_BTN': ['Submit', 'ثبت نهایی', 'Submit'],
  'APP.IAB.DEATIVATE_TRIAL_SUBSCRIPTION': [
    'Deactivate trial subscription',
    'غیرفعال‌سازی اشتراک آزمایشی (Trial)',
    'Deactivate trial subscription',
  ],
  'APP.IAB.TRIAL_SUBSCRIPTION_PERIOD': [
    'Trial subscription period',
    'مدت اشتراک آزمایشی',
    'Trial subscription period',
  ],
  'APP.IAB.TRIAL_SUBSCRIPTION_PERIOD_ERROR': [
    'Period must be between 1 and 30',
    'مدت اشتراک آزمایشی باید بین ۱ و ۳۰ باشد',
    'Period must be between 1 and 30',
  ],
  'APP.IAB.DEATIVATE_TRIAL_SUBSCRIPTION_CONFIRM': [
    'You are deactivating your trial subscription',
    'شما در حال غیرفعال‌سازی اشتراک آزمایشی خود هستید.',
    'You are deactivating your trial subscription',
  ],
  'APP.FEATURES_&_LIBRARIES.INTRO': [
    'Dear developer, after checking your app, it is found that you have restricted your app to run on mobile phones with',
    'توسعه دهنده‌ گرامی، با بررسی برنامه‌ی شما، مشخص شده است که شما برنامه‌ی خود را برای استفاده‌ی گوشی‌های موبایل دارای',
    'Dear developer, after checking your app, it is found that you have restricted your app to run on mobile phones with',
  ],
  'APP.FEATURES_&_LIBRARIES.FEATURES': [
    'the following hardware:',
    'سخت‌افزار‌های زیر:',
    'the following hardware:',
  ],
  'APP.FEATURES_&_LIBRARIES.LIBRARIES': [
    'the following libraries',
    'کتابخانه‌های زیر:',
    'the following libraries',
  ],
  'APP.FEATURES_&_LIBRARIES.ENDING': [
    'If you want to expose your app to a larger community of users, please set the above values to False in the app manifest.',
    'محدود کرده‌اید. اگر مایل به نمایش برنامه‌ی خود به جامعه‌ی بیشتری از کاربران هستید، لطفا در مانیفست برنامه، مقادیر مذکور را False قرار دهید.',
    'If you want to expose your app to a larger community of users, please set the above values to False in the app manifest.',
  ],
  'DISABLE': ['Deactivate', 'غیرفعال‌سازی', 'Deactivate'],
  'ADS_ACADEMY': ['Ads Academy', 'آکادمی تبلیغات', 'Ads Academy'],
  'SUBSCRIBE_TO_NEWSLETTER': [
    'Subscribe to newsletter',
    'عضویت در خبرنامه',
    'Subscribe to newsletter',
  ],
  'ADS_NEWSLETTER_MODAL.DESCRIPTION': [
    'Do you want to be in the loop of the latest market and advertising industry news? Enter your information:',
    'می خواهید در جریان آخرین اخبار بازار و صنعت تبلیغات باشید؟ اطلاعات خود را وارد کنید:',
    'Do you want to be in the loop of the latest market and advertising industry news? Enter your information:',
  ],
  'ADS_NEWSLETTER_MODAL.SUBSCRIBED': [
    'Your information has been successfully registered.',
    'اطلاعات با موفقیت ثبت شد.',
    'Your information has been successfully registered.',
  ],
  'ADS_NEWSLETTER_MODAL.NAME': ['Full Name', 'نام و نام خانوادگی', 'Full Name'],
  'ADS_NEWSLETTER_MODAL.ROLE': ['Role', 'سمت', 'Role'],
  'ADS_NEWSLETTER_MODAL.PHONE': ['Phone', 'تلفن', 'Phone'],
  'ADS_NEWSLETTER_MODAL.EMAIL': ['Email', 'ایمیل', 'Email'],
  'ADS_NEWSLETTER_MODAL.SUBSCRIBE': ['Subscribe', 'عضویت', 'Subscribe'],
};
